import type { Icons } from "./types";

export const icons: Icons = {
  add: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V20C12.75 20.4142 12.4142 20.75 12 20.75C11.5858 20.75 11.25 20.4142 11.25 20V4C11.25 3.58579 11.5858 3.25 12 3.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12Z"
        fill="currentColor"
      />
    </>
  ),
  addChat: (
    <>
      <path
        d="M12.5 3.00372C11.6049 2.99039 10.7047 3.01289 9.8294 3.07107C5.64639 3.34913 2.31441 6.72838 2.04024 10.9707C1.98659 11.8009 1.98659 12.6607 2.04024 13.4909C2.1401 15.036 2.82343 16.4666 3.62791 17.6746C4.09501 18.5203 3.78674 19.5758 3.30021 20.4978C2.94941 21.1626 2.77401 21.495 2.91484 21.7351C3.05568 21.9752 3.37026 21.9829 3.99943 21.9982C5.24367 22.0285 6.08268 21.6757 6.74868 21.1846C7.1264 20.9061 7.31527 20.7668 7.44544 20.7508C7.5756 20.7348 7.83177 20.8403 8.34401 21.0513C8.8044 21.2409 9.33896 21.3579 9.8294 21.3905C11.2536 21.4852 12.7435 21.4854 14.1706 21.3905C18.3536 21.1125 21.6856 17.7332 21.9598 13.4909C22.0021 12.836 22.011 12.1627 21.9866 11.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 15H15.5M8.5 10H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5.5H22M18.5 2L18.5 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  addThick: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V20C12.75 20.4142 12.4142 20.75 12 20.75C11.5858 20.75 11.25 20.4142 11.25 20V4C11.25 3.58579 11.5858 3.25 12 3.25Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
    </>
  ),
  ai: (
    <>
      <path
        d="M10 7L9.48415 8.39405C8.80774 10.222 8.46953 11.136 7.80278 11.8028C7.13603 12.4695 6.22204 12.8077 4.39405 13.4842L3 14L4.39405 14.5158C6.22204 15.1923 7.13603 15.5305 7.80278 16.1972C8.46953 16.864 8.80774 17.778 9.48415 19.6059L10 21L10.5158 19.6059C11.1923 17.778 11.5305 16.864 12.1972 16.1972C12.864 15.5305 13.778 15.1923 15.6059 14.5158L17 14L15.6059 13.4842C13.778 12.8077 12.864 12.4695 12.1972 11.8028C11.5305 11.136 11.1923 10.222 10.5158 8.39405L10 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M18 3L17.7789 3.59745C17.489 4.38087 17.3441 4.77259 17.0583 5.05833C16.7726 5.34408 16.3809 5.48903 15.5975 5.77892L15 6L15.5975 6.22108C16.3809 6.51097 16.7726 6.65592 17.0583 6.94167C17.3441 7.22741 17.489 7.61913 17.7789 8.40255L18 9L18.2211 8.40255C18.511 7.61913 18.6559 7.22741 18.9417 6.94166C19.2274 6.65592 19.6191 6.51097 20.4025 6.22108L21 6L20.4025 5.77892C19.6191 5.48903 19.2274 5.34408 18.9417 5.05833C18.6559 4.77259 18.511 4.38087 18.2211 3.59745L18 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
    </>
  ),
  aiFile: (
    <>
      <path
        d="M19 12.001V10.6578C19 9.84033 19 9.43158 18.8478 9.06404C18.6955 8.69649 18.4065 8.40746 17.8284 7.8294L13.0919 3.09286C12.593 2.59397 12.3436 2.34453 12.0345 2.19672C11.9702 2.16598 11.9044 2.1387 11.8372 2.11499C11.5141 2.00098 11.1614 2.00098 10.4558 2.00098C7.21082 2.00098 5.58831 2.00098 4.48933 2.88705C4.26731 3.06606 4.06508 3.26829 3.88607 3.49031C3 4.58928 3 6.2118 3 9.45682V14.001C3 17.7722 3 19.6578 4.17157 20.8294C5.34315 22.001 7.22876 22.001 11 22.001H13.0345M12 2.50098V3.00098C12 5.8294 12 7.24362 12.8787 8.1223C13.7574 9.00098 15.1716 9.00098 18 9.00098H18.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 15.001L17.7579 15.698C18.0961 16.612 18.2652 17.069 18.5986 17.4024C18.932 17.7357 19.389 17.9048 20.303 18.2431L21 18.501L20.303 18.7589C19.389 19.0971 18.932 19.2662 18.5986 19.5996C18.2652 19.933 18.0961 20.39 17.7579 21.3039L17.5 22.001L17.2421 21.3039C16.9039 20.39 16.7348 19.933 16.4014 19.5996C16.068 19.2662 15.611 19.0971 14.697 18.7589L14 18.501L14.697 18.2431C15.611 17.9048 16.068 17.7357 16.4014 17.4024C16.7348 17.069 16.9039 16.612 17.2421 15.698L17.5 15.001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  aiFilled: (
    <>
      <path
        d="M10.7024 6.75H9.29761L8.78249 8.14208C8.08325 10.0317 7.7991 10.7535 7.27631 11.2763C6.75353 11.7991 6.03174 12.0833 4.14208 12.7825L2.75 13.2976V14.7024L4.14208 15.2175C6.03174 15.9167 6.75353 16.2009 7.27631 16.7237C7.7991 17.2465 8.08325 17.9683 8.78249 19.8579L9.29761 21.25H10.7024L11.2175 19.8579C11.9167 17.9683 12.2009 17.2465 12.7237 16.7237C13.2465 16.2009 13.9683 15.9167 15.8579 15.2175L17.25 14.7024V13.2976L15.8579 12.7825C13.9683 12.0833 13.2465 11.7991 12.7237 11.2763C12.2009 10.7535 11.9167 10.0317 11.2175 8.14208L10.7024 6.75Z"
        fill="currentColor"
      />
      <path
        d="M18.7031 2.75H17.3008L17.0804 3.34557C16.7677 4.19067 16.6767 4.39057 16.5346 4.53264C16.3925 4.67472 16.1926 4.76573 15.3475 5.07845L14.752 5.29883V6.70117L15.3475 6.92155C16.1926 7.23427 16.3925 7.32528 16.5346 7.46735C16.6767 7.60943 16.7677 7.80933 17.0804 8.65443L17.3008 9.25L18.7031 9.25L18.9235 8.65443C19.2362 7.80933 19.3272 7.60943 19.4693 7.46735C19.6114 7.32528 19.8113 7.23427 20.6564 6.92155L21.252 6.70117L21.252 5.29883L20.6564 5.07845C19.8113 4.76573 19.6114 4.67472 19.4693 4.53264C19.3272 4.39057 19.2362 4.19067 18.9235 3.34557L18.7031 2.75Z"
        fill="currentColor"
      />
    </>
  ),
  aiSmall: (
    <g transform="translate(2, -2)">
      <path
        d="M10.7024 6.75H9.29761L8.78249 8.14208C8.08325 10.0317 7.7991 10.7535 7.27631 11.2763C6.75353 11.7991 6.03174 12.0833 4.14208 12.7825L2.75 13.2976V14.7024L4.14208 15.2175C6.03174 15.9167 6.75353 16.2009 7.27631 16.7237C7.7991 17.2465 8.08325 17.9683 8.78249 19.8579L9.29761 21.25H10.7024L11.2175 19.8579C11.9167 17.9683 12.2009 17.2465 12.7237 16.7237C13.2465 16.2009 13.9683 15.9167 15.8579 15.2175L17.25 14.7024V13.2976L15.8579 12.7825C13.9683 12.0833 13.2465 11.7991 12.7237 11.2763C12.2009 10.7535 11.9167 10.0317 11.2175 8.14208L10.7024 6.75Z"
        fill="currentColor"
      />
    </g>
  ),
  alertFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.362 2.015C11.4264 1.66167 12.5736 1.66167 13.638 2.015C14.6981 2.36687 15.5304 3.20141 16.3665 4.37395C17.1999 5.5426 18.1208 7.17206 19.3078 9.2725L19.3544 9.35496C20.5417 11.4557 21.4625 13.0851 22.0364 14.4065C22.613 15.7343 22.9002 16.8807 22.6711 17.9821C22.4403 19.0911 21.8714 20.0995 21.0428 20.8617C20.2162 21.622 19.0907 21.9428 17.6736 22.0968C16.2645 22.25 14.4212 22.25 12.0488 22.25H11.9513C9.57882 22.25 7.73554 22.25 6.32642 22.0968C4.90927 21.9428 3.78379 21.622 2.95722 20.8617C2.12862 20.0995 1.55968 19.0911 1.32895 17.9821C1.0998 16.8807 1.387 15.7343 1.96365 14.4065C2.53752 13.0851 3.45835 11.4557 4.64558 9.35495L4.69218 9.2725L4.69218 9.27249C5.87921 7.17206 6.80008 5.5426 7.63347 4.37395C8.46963 3.20141 9.30194 2.36687 10.362 2.015ZM11 17C11 16.4477 11.4457 16 11.9955 16H12.0045C12.5543 16 13 16.4477 13 17C13 17.5523 12.5543 18 12.0045 18H11.9955C11.4457 18 11 17.5523 11 17ZM11 13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V13Z"
      fill="currentColor"
    />
  ),
  apartment: (
    <>
      <path
        d="M15 2H9C5.69067 2 5 2.69067 5 6V22H19V6C19 2.69067 18.3093 2 15 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3 22H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15 22V19C15 17.3453 14.6547 17 13 17H11C9.34533 17 9 17.3453 9 19V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.5 6H10.5M13.5 9.5H10.5M13.5 13H10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
    </>
  ),
  arrowExpand: (
    <path
      d="M16.5148 16.5149C17.0896 15.9401 16.9941 13.4982 16.9941 13.4982M16.5148 16.5149C15.94 17.0897 13.4981 16.994 13.4981 16.994M16.5148 16.5149L13 13M7.48506 7.48512C8.05987 6.91031 10.5018 7.00596 10.5018 7.00596M7.48506 7.48512C6.91025 8.05993 7.00598 10.5018 7.00598 10.5018M7.48506 7.48512L11 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  arrowRight: (
    <>
      <path
        d="M20.0001 11.9998L4.00012 11.9998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0003 17C15.0003 17 20.0002 13.3176 20.0002 12C20.0002 10.6824 15.0002 7 15.0002 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  arrowUp: (
    <>
      <path
        d="M12 4L12 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9998 8.99996C16.9998 8.99996 13.3174 4.00001 11.9998 4C10.6822 3.99999 6.99982 9 6.99982 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  attach: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 3.75C7.15279 3.75 5.25 5.65279 5.25 8V13.5001C5.25 17.228 8.27208 20.2501 12 20.2501C15.7279 20.2501 18.75 17.228 18.75 13.5001V12.0001C18.75 11.5859 19.0858 11.2501 19.5 11.2501C19.9142 11.2501 20.25 11.5859 20.25 12.0001V13.5001C20.25 18.0564 16.5563 21.7501 12 21.7501C7.44364 21.7501 3.75 18.0564 3.75 13.5001V8C3.75 4.82437 6.32437 2.25 9.5 2.25C12.6756 2.25 15.25 4.82436 15.25 8V13.5C15.25 15.2949 13.7949 16.75 12 16.75C10.2051 16.75 8.75 15.2949 8.75 13.5V9.5C8.75 9.08579 9.08579 8.75 9.5 8.75C9.91421 8.75 10.25 9.08579 10.25 9.5V13.5C10.25 14.4665 11.0335 15.25 12 15.25C12.9665 15.25 13.75 14.4665 13.75 13.5V8C13.75 5.6528 11.8472 3.75 9.5 3.75Z"
      fill="currentColor"
    />
  ),
  bank: (
    <>
      <path
        d="M2 8.56907C2 7.37289 2.48238 6.63982 3.48063 6.08428L7.58987 3.79744C9.7431 2.59915 10.8197 2 12 2C13.1803 2 14.2569 2.59915 16.4101 3.79744L20.5194 6.08428C21.5176 6.63982 22 7.3729 22 8.56907C22 8.89343 22 9.05561 21.9646 9.18894C21.7785 9.88945 21.1437 10 20.5307 10H3.46928C2.85627 10 2.22152 9.88944 2.03542 9.18894C2 9.05561 2 8.89343 2 8.56907Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.9959 7H12.0049"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4 10V18.5M8 10V18.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M16 10V18.5M20 10V18.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M19 18.5H5C3.34315 18.5 2 19.8431 2 21.5C2 21.7761 2.22386 22 2.5 22H21.5C21.7761 22 22 21.7761 22 21.5C22 19.8431 20.6569 18.5 19 18.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  bell: (
    <>
      <path
        d="M2 20.5H22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3.05228 14.7749C3.51867 14.4791 3.99344 14.05 4.06165 13.502C4.55286 9.55471 7.9197 6.5 12 6.5C16.0803 6.5 19.4471 9.55471 19.9384 13.502C20.0066 14.05 20.4813 14.4791 20.9477 14.7749C21.3611 15.0371 21.6612 15.4673 21.7466 15.9796L22 17H2L2.2534 15.9796C2.33878 15.4673 2.63889 15.0371 3.05228 14.7749Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M12 6.5V3.5M12 3.5H9.5M12 3.5H14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M19 5.5L18.5 6.5M21.5 8L20.5009 8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M5 5.5L5.5 6.5M3.49913 8.5L2.5 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  book: (
    <>
      <path
        d="M15.5 7H8.5M12.499 11H8.49902"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M20 22H6C4.89543 22 4 21.1046 4 20M4 20C4 18.8954 4.89543 18 6 18H20V6C20 4.11438 20 3.17157 19.4142 2.58579C18.8284 2 17.8856 2 16 2H10C7.17157 2 5.75736 2 4.87868 2.87868C4 3.75736 4 5.17157 4 8V20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M19.5 18C19.5 18 18.5 18.7628 18.5 20C18.5 21.2372 19.5 22 19.5 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  briefcase: (
    <path
      fill="currentColor"
      d="M13.25,21.75h-1.25c-4.92,0-7.38,0-9.07-1.68s-1.68-4.15-1.68-9.07v-3.06c0-1.94,0-2.92.47-3.77.34-.61.84-1.11,1.45-1.45.85-.47,1.83-.47,3.77-.47,1.21,0,1.88,0,2.52.24,1.39.52,1.98,1.71,2.5,2.76l.5,1h4.29c2.26,0,3.39,0,4.33.63.41.28.76.62,1.03,1.03.63.95.63,2.08.63,4.33,0,3.66,0,5.49-.97,6.94-.42.63-.96,1.17-1.59,1.59-1.45.97-3.29.97-6.94.97ZM6.94,3.75c-1.68,0-2.53,0-3.04.29-.36.2-.67.5-.87.87-.29.51-.29,1.36-.29,3.04v3.06c0,4.5,0,6.76,1.24,8s3.5,1.25,8.01,1.25h1.25c3.36,0,5.04,0,6.11-.72.47-.31.86-.71,1.17-1.17.72-1.07.72-2.75.72-6.11,0-1.95,0-2.93-.38-3.5-.16-.25-.37-.46-.62-.62-.57-.38-1.55-.38-3.5-.38h-4.73s-.02,0-.03,0h-3.99c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h2.79l-.16-.33c-.46-.92-.85-1.72-1.69-2.03-.38-.14-.92-.14-1.99-.14Z"
    />
  ),
  briefcaseFilled: (
    <path
      fill="currentColor"
      d="M7.08,2.25c1.03,0,1.74,0,2.38.24,1.4.52,2.01,1.76,2.48,2.72.14.28.4.8.47.91.02.04.09.11.19.12.13.01.31.01.63.01h3.55c1.02,0,1.84,0,2.5.07.68.07,1.27.22,1.79.56.41.27.76.63,1.03,1.03.35.52.5,1.11.57,1.79.07.66.07,1.56.07,2.58,0,1.72,0,3.07-.11,4.14-.11,1.09-.34,1.99-.86,2.76-.42.63-.96,1.17-1.59,1.59-.77.52-1.67.75-2.76.86-1.07.11-2.42.11-4.14.11h-1.35c-2.31,0-4.12,0-5.53-.19-1.44-.19-2.58-.6-3.48-1.49-.89-.89-1.3-2.03-1.49-3.48-.19-1.41-.19-3.22-.19-5.53v-3.15c0-.88,0-1.59.05-2.16.05-.59.16-1.11.42-1.58.34-.61.84-1.11,1.45-1.45.47-.26.99-.37,1.58-.42.57-.05,1.45-.05,2.33-.05Z"
    />
  ),
  // --
  bug: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7277 4.66985C10.4449 5.13414 10.3 5.82649 10.3 6.6C10.3 7.15228 9.85228 7.6 9.3 7.6C8.74771 7.6 8.3 7.15228 8.3 6.6C8.3 5.63893 8.47017 4.53128 9.01979 3.62921C9.60836 2.66323 10.5989 2 12 2C13.4011 2 14.3916 2.66323 14.9802 3.62921C15.5298 4.53129 15.7 5.63893 15.7 6.6C15.7 7.15229 15.2523 7.6 14.7 7.6C14.1477 7.6 13.7 7.15229 13.7 6.6C13.7 5.82649 13.5551 5.13414 13.2723 4.66985C13.0283 4.26948 12.6688 4 12 4C11.3312 4 10.9717 4.26948 10.7277 4.66985ZM3 4C3.55228 4 4 4.44772 4 5V5.25C4 6.43741 4.96259 7.4 6.15 7.4C6.70228 7.4 7.15 7.84772 7.15 8.4C7.15 8.95228 6.70228 9.4 6.15 9.4C3.85802 9.4 2 7.54198 2 5.25V5C2 4.44772 2.44772 4 3 4ZM21 4C21.5523 4 22 4.44772 22 5V5.25C22 7.54198 20.142 9.4 17.85 9.4C17.2977 9.4 16.85 8.95228 16.85 8.4C16.85 7.84772 17.2977 7.4 17.85 7.4C19.0374 7.4 20 6.43741 20 5.25V5C20 4.44772 20.4477 4 21 4ZM2 12.9C2 12.3477 2.44772 11.9 3 11.9H6.15C6.70228 11.9 7.15 12.3477 7.15 12.9C7.15 13.4523 6.70228 13.9 6.15 13.9H3C2.44772 13.9 2 13.4523 2 12.9ZM16.85 12.9C16.85 12.3477 17.2977 11.9 17.85 11.9H21C21.5523 11.9 22 12.3477 22 12.9C22 13.4523 21.5523 13.9 21 13.9H17.85C17.2977 13.9 16.85 13.4523 16.85 12.9ZM2 21C2 18.4595 4.05949 16.4 6.6 16.4C7.15229 16.4 7.6 16.8477 7.6 17.4C7.6 17.9523 7.15229 18.4 6.6 18.4C5.16406 18.4 4 19.5641 4 21C4 21.5523 3.55229 22 3 22C2.44772 22 2 21.5523 2 21ZM16.4 17.4C16.4 16.8477 16.8477 16.4 17.4 16.4C19.9405 16.4 22 18.4595 22 21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21C20 19.5641 18.8359 18.4 17.4 18.4C16.8477 18.4 16.4 17.9523 16.4 17.4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7706 6.12583C15.368 5.97568 14.9426 5.91189 14.451 5.88138C13.9706 5.85156 13.3797 5.85156 12.6386 5.85156H12.6386H11.3621H11.3621H11.3621C10.621 5.85156 10.0302 5.85156 9.54981 5.88138C9.05821 5.91189 8.63281 5.97567 8.23022 6.12583C7.04806 6.56676 6.11558 7.49923 5.67466 8.68139C5.5245 9.08398 5.46072 9.50938 5.4302 10.001C5.40038 10.4813 5.40039 11.0722 5.40039 11.8133V11.8133V15.1516C5.40039 18.3116 7.62126 20.953 10.5873 21.5999C10.88 21.6638 11.0264 21.6957 11.1382 21.6056C11.25 21.5156 11.25 21.3563 11.25 21.0376V16.5C11.25 16.0858 11.5858 15.75 12 15.75C12.4142 15.75 12.75 16.0858 12.75 16.5V21.0378C12.75 21.3564 12.75 21.5157 12.8618 21.6058C12.9736 21.6958 13.12 21.6639 13.4126 21.6001C16.3791 20.9535 18.6004 18.3119 18.6004 15.1516L18.6004 11.8133C18.6004 11.0722 18.6004 10.4813 18.5706 10.001C18.5401 9.50938 18.4763 9.08398 18.3261 8.68139C17.8852 7.49923 16.9527 6.56676 15.7706 6.12583Z"
        fill="currentColor"
      />
    </>
  ),
  burger: (
    <>
      <path
        d="M14.8543 4H9.14613C6.6505 4 4.52893 5.96401 3.75315 8.7004C3.49773 9.6013 3.37003 10.0517 3.69086 10.5259C4.01169 11 4.53398 11 5.57854 11H18.4219C19.4664 11 19.9887 11 20.3096 10.5259C20.6304 10.0517 20.5027 9.6013 20.2473 8.7004C19.4715 5.96401 17.3499 4 14.8543 4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M6 15H5.57833C4.53377 15 4.01149 15 3.69065 15.3387C3.36982 15.6773 3.49753 15.9991 3.75294 16.6426C4.52873 18.5971 6.65029 20 9.14593 20H14.8541C17.3497 20 19.4713 18.5971 20.2471 16.6426C20.5025 15.9991 20.6302 15.6773 20.3093 15.3387C19.9885 15 19.4662 15 18.4217 15H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M19 15H20C21.1046 15 22 14.1046 22 13C22 11.8954 21.1046 11 20 11H12M5 15H4C2.89543 15 2 14.1046 2 13C2 11.8954 2.89543 11 4 11H6M6 11L7.48149 12.7284C8.18721 13.5517 8.54007 13.9634 9 13.9634C9.45993 13.9634 9.81279 13.5517 10.5185 12.7284L12 11M6 11H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.00781 8L8.99883 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15 7L14 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  bus: (
    <>
      <path
        d="M6.00391 10V5M11.0039 10V5M16.0039 10V5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.01609 17C3.59614 17 2.88616 17 2.44503 16.5607C2.00391 16.1213 2.00391 15.4142 2.00391 14V8C2.00391 6.58579 2.00391 5.87868 2.44503 5.43934C2.88616 5 3.59614 5 5.01609 5H12.1005C15.5742 5 17.311 5 18.6402 5.70624C19.619 6.22633 20.4346 7.0055 20.9971 7.95786C21.7609 9.25111 21.8332 10.9794 21.9779 14.436C22.0168 15.3678 22.0363 15.8337 21.8542 16.1862C21.7204 16.4454 21.5135 16.6601 21.2591 16.8041C20.913 17 20.4449 17 19.5085 17H19.0039M9.00391 17H15.0039"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00391 19C8.10848 19 9.00391 18.1046 9.00391 17C9.00391 15.8954 8.10848 15 7.00391 15C5.89934 15 5.00391 15.8954 5.00391 17C5.00391 18.1046 5.89934 19 7.00391 19Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M17.0039 19C18.1085 19 19.0039 18.1046 19.0039 17C19.0039 15.8954 18.1085 15 17.0039 15C15.8993 15 15.0039 15.8954 15.0039 17C15.0039 18.1046 15.8993 19 17.0039 19Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M1.99609 10.0009H15.3641C15.9911 10.0009 16.2041 10.3681 16.6841 10.9441C17.2361 11.4841 17.6093 11.8628 18.1241 11.9401C18.8441 12.0481 21.5081 11.9941 21.5081 11.9941"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  calculator: (
    <>
      <path
        d="M3 10H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M15 6L17 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 13V11C21 6.75736 21 4.63604 19.682 3.31802C18.364 2 16.2426 2 12 2C7.75736 2 5.63604 2 4.31802 3.31802C3 4.63604 3 6.75736 3 11V13C3 17.2426 3 19.364 4.31802 20.682C5.63604 22 7.75736 22 12 22C16.2426 22 18.364 22 19.682 20.682C21 19.364 21 17.2426 21 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7 14H7.52632M11.7368 14H12.2632M16.4737 14H17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 18H7.52632M11.7368 18H12.2632M16.4737 18H17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  calculatorFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 6C14 5.44772 14.4477 5 15 5L17 5C17.5523 5 18 5.44772 18 6C18 6.55229 17.5523 7 17 7L15 7C14.4477 7 14 6.55228 14 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9993 1.00115C13.6841 1.00115 15.3961 0.94976 17.0702 1.17473C18.4065 1.3543 19.5126 1.73591 20.3884 2.61125C21.1913 3.41379 21.5799 4.41096 21.7773 5.60434C21.9698 6.76856 21.9945 8.21809 21.9986 9.99434C21.9989 10.1287 21.9992 10.263 21.9994 10.3973C21.9999 10.6791 22.0001 10.82 21.9122 10.908C21.8243 10.9961 21.6831 10.9961 21.4007 10.9961C15.1335 10.9961 8.86628 10.9961 2.59909 10.9961C2.31713 10.9961 2.17615 10.9961 2.08837 10.9087C2.08804 10.9084 2.0877 10.9081 2.08736 10.9077C2 10.8199 2 10.679 2 10.397V9.99434C2.00402 8.21809 2.02875 6.76856 2.22128 5.60434C2.41862 4.41096 2.80724 3.41379 3.61019 2.61125C4.48597 1.73591 5.592 1.3543 6.9283 1.17473C8.60245 0.94976 10.3145 1.00115 11.9993 1.00115ZM7.1948 3.15589C6.08027 3.30566 5.46664 3.58273 5.0244 4.02474C4.61722 4.43172 4.35125 4.98247 4.1945 5.93032C4.08562 6.58876 4.03701 7.38709 4.01564 8.39065C4.00958 8.67483 4.00656 8.81692 4.0948 8.90701C4.18304 8.9971 4.32627 8.9971 4.61275 8.9971H19.3858C19.6723 8.9971 19.8155 8.9971 19.9038 8.90701C19.992 8.81692 19.989 8.67483 19.9829 8.39066C19.9615 7.38709 19.9129 6.58877 19.804 5.93032C19.6473 4.98247 19.3813 4.43172 18.9741 4.02474C18.5319 3.58273 17.9183 3.30566 16.8038 3.15589C15.6605 3.00226 14.1489 3.00014 11.9993 3.00014C9.84968 3.00014 8.33809 3.00226 7.1948 3.15589Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.997 9H2.00299L2.00073 9.99738C2 10.318 2 10.6526 2 10.9993V13.0726V13.0726C1.99998 15.1303 1.99996 16.7761 2.17367 18.0677C2.35333 19.4035 2.73514 20.5092 3.61092 21.3846C4.48669 22.2601 5.59273 22.6417 6.92903 22.8213C8.34109 23.0111 9.7801 23.0043 11.207 22.9975H11.207H11.2071C11.4719 22.9962 11.7363 22.9949 12 22.9949C12.2637 22.9949 12.5281 22.9962 12.7929 22.9975H12.793H12.793C14.2199 23.0043 15.6589 23.0111 17.071 22.8213C18.4073 22.6417 19.5133 22.2601 20.3891 21.3846C21.2649 20.5092 21.6467 19.4035 21.8263 18.0677C22 16.7761 22 15.1303 22 13.0726V10.9993C22 10.6523 22 10.3182 21.9993 9.99738L21.997 9ZM6 14C6 13.4477 6.44772 13 7 13H7.52632C8.0786 13 8.52632 13.4477 8.52632 14C8.52632 14.5523 8.0786 15 7.52632 15H7C6.44772 15 6 14.5523 6 14ZM10.7368 14C10.7368 13.4477 11.1846 13 11.7368 13H12.2632C12.8154 13 13.2632 13.4477 13.2632 14C13.2632 14.5523 12.8154 15 12.2632 15H11.7368C11.1846 15 10.7368 14.5523 10.7368 14ZM15.4737 14C15.4737 13.4477 15.9214 13 16.4737 13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H16.4737C15.9214 15 15.4737 14.5523 15.4737 14ZM7 17C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19H7.52632C8.0786 19 8.52632 18.5523 8.52632 18C8.52632 17.4477 8.0786 17 7.52632 17H7ZM11.7368 17C11.1846 17 10.7368 17.4477 10.7368 18C10.7368 18.5523 11.1846 19 11.7368 19H12.2632C12.8154 19 13.2632 18.5523 13.2632 18C13.2632 17.4477 12.8154 17 12.2632 17H11.7368ZM16.4737 17C15.9214 17 15.4737 17.4477 15.4737 18C15.4737 18.5523 15.9214 19 16.4737 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H16.4737Z"
        fill="currentColor"
      />
    </>
  ),
  calendar: (
    <>
      <path
        d="M16 2V6M8 2V6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9955 14H12.0045M11.9955 18H12.0045M15.991 14H16M8 14H8.00897M8 18H8.00897"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  calendarFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.1 1.25C8.63848 1.25 9.075 1.68754 9.075 2.22727V3.21284C9.6529 3.20453 10.2784 3.20453 10.9537 3.20454H13.0463C13.7216 3.20453 14.3471 3.20453 14.925 3.21284V2.22727C14.925 1.68754 15.3615 1.25 15.9 1.25C16.4385 1.25 16.875 1.68754 16.875 2.22727V3.29947C17.0513 3.31556 17.221 3.33437 17.3843 3.35638C18.5544 3.51407 19.5397 3.85141 20.3221 4.63573C21.1046 5.42004 21.4412 6.40758 21.5985 7.58045C21.75 8.71014 21.75 10.1465 21.75 11.9285V14.026C21.75 15.808 21.75 17.2444 21.5985 18.3741C21.4412 19.547 21.1046 20.5345 20.3221 21.3188C19.5397 22.1031 18.5544 22.4405 17.3843 22.5982C16.2572 22.75 14.8242 22.75 13.0463 22.75H10.9537C9.17581 22.75 7.74279 22.75 6.61573 22.5982C5.44558 22.4405 4.46035 22.1031 3.67786 21.3188C2.89537 20.5345 2.5588 19.547 2.40148 18.3741C2.24995 17.2444 2.24998 15.8081 2.25 14.0261V11.9285C2.24998 10.1465 2.24995 8.71012 2.40148 7.58045C2.5588 6.40758 2.89537 5.42004 3.67786 4.63573C4.46035 3.85141 5.44558 3.51407 6.61573 3.35638C6.77902 3.33437 6.94874 3.31556 7.125 3.29947V2.22727C7.125 1.68754 7.56152 1.25 8.1 1.25ZM4.21386 9.75C4.20045 10.3958 4.20001 11.1378 4.20001 12V13.9545C4.20001 15.8249 4.20208 17.1294 4.3341 18.1137C4.46235 19.0698 4.69693 19.5761 5.05673 19.9367C5.41652 20.2974 5.92166 20.5325 6.87557 20.6611C7.85752 20.7934 9.15897 20.7955 11.025 20.7955H12.975C14.8411 20.7955 16.1425 20.7934 17.1245 20.6611C18.0784 20.5325 18.5835 20.2974 18.9433 19.9367C19.3031 19.5761 19.5377 19.0698 19.6659 18.1137C19.7979 17.1294 19.8 15.8249 19.8 13.9545V12C19.8 11.1378 19.7996 10.3958 19.7862 9.75H4.21386Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 13.2734C7 12.7212 7.44772 12.2734 8 12.2734H8.00897C8.56126 12.2734 9.00897 12.7212 9.00897 13.2734C9.00897 13.8257 8.56126 14.2734 8.00897 14.2734H8C7.44772 14.2734 7 13.8257 7 13.2734ZM10.9955 13.2734C10.9955 12.7212 11.4432 12.2734 11.9955 12.2734H12.0045C12.5568 12.2734 13.0045 12.7212 13.0045 13.2734C13.0045 13.8257 12.5568 14.2734 12.0045 14.2734H11.9955C11.4432 14.2734 10.9955 13.8257 10.9955 13.2734ZM14.991 13.2734C14.991 12.7212 15.4387 12.2734 15.991 12.2734H16C16.5523 12.2734 17 12.7212 17 13.2734C17 13.8257 16.5523 14.2734 16 14.2734H15.991C15.4387 14.2734 14.991 13.8257 14.991 13.2734ZM7 17.2734C7 16.7212 7.44772 16.2734 8 16.2734H8.00897C8.56126 16.2734 9.00897 16.7212 9.00897 17.2734C9.00897 17.8257 8.56126 18.2734 8.00897 18.2734H8C7.44772 18.2734 7 17.8257 7 17.2734ZM10.9955 17.2734C10.9955 16.7212 11.4432 16.2734 11.9955 16.2734H12.0045C12.5568 16.2734 13.0045 16.7212 13.0045 17.2734C13.0045 17.8257 12.5568 18.2734 12.0045 18.2734H11.9955C11.4432 18.2734 10.9955 17.8257 10.9955 17.2734Z"
        fill="currentColor"
      />
    </>
  ),
  calendarPlus: (
    <>
      <path
        d="M18 2V4M6 2V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.05 22C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.4765 5.68186 21.4996 7.80438 21.5 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 8H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 18H21M17 14L17 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  call: (
    <path
      d="M7.33957 3H3.98685C3.43414 3 2.98438 3.44971 3.00042 4.00219C3.32014 15.0141 8.98594 20.6799 19.9978 20.9996C20.5503 21.0156 21 20.5659 21 20.0132V16.6604C21 16.2649 20.7671 15.9065 20.4057 15.7459L17.0654 14.2613C16.7171 14.1065 16.3111 14.163 16.0183 14.407L13.9654 16.1178C13.6762 16.3587 13.2747 16.4181 12.9315 16.2637C10.0586 14.971 9.02895 13.9414 7.73635 11.0685C7.58192 10.7253 7.64126 10.3238 7.8822 10.0346L9.59295 7.98173C9.83696 7.68891 9.89346 7.28291 9.73865 6.9346L8.25409 3.59432C8.09346 3.23291 7.73506 3 7.33957 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  callEndFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7931 2.79289C14.1836 2.40237 14.8168 2.40237 15.2073 2.79289L17.5002 5.08579L19.7931 2.79289C20.1836 2.40237 20.8168 2.40237 21.2073 2.79289C21.5978 3.18342 21.5978 3.81658 21.2073 4.20711L18.9144 6.5L21.2073 8.79289C21.5978 9.18342 21.5978 9.81658 21.2073 10.2071C20.8168 10.5976 20.1836 10.5976 19.7931 10.2071L17.5002 7.91421L15.2073 10.2071C14.8168 10.5976 14.1836 10.5976 13.7931 10.2071C13.4026 9.81658 13.4026 9.18342 13.7931 8.79289L16.086 6.5L13.7931 4.20711C13.4026 3.81658 13.4026 3.18342 13.7931 2.79289Z"
        fill="currentColor"
      />
      <path
        d="M9.09139 5.05609L8.83814 4.48626C8.49701 3.71873 8.32645 3.33496 8.04574 3.06369C7.86046 2.88463 7.64242 2.74293 7.40354 2.64634C7.04165 2.5 6.62168 2.5 5.78175 2.5C4.53109 2.5 3.90577 2.5 3.41855 2.80363C3.11972 2.98986 2.83392 3.30601 2.67871 3.62206C2.42563 4.13735 2.48304 4.70507 2.59786 5.84052C3.5506 15.2623 8.73786 20.4496 18.1597 21.4023C19.2951 21.5171 19.8628 21.5745 20.3781 21.3215C20.6942 21.1663 21.0103 20.8805 21.1966 20.5816C21.5002 20.0944 21.5002 19.4691 21.5002 18.2184C21.5002 17.3785 21.5002 16.9585 21.3538 16.5966C21.2573 16.3578 21.1156 16.1397 20.9365 15.9544C20.6652 15.6737 20.2815 15.5032 19.5139 15.162L18.9441 14.9088C18.2715 14.6099 17.9353 14.4604 17.5979 14.432C17.2391 14.4018 16.8788 14.4687 16.5548 14.6257C16.2501 14.7733 15.9899 15.0335 15.4695 15.5539C14.9575 16.0659 14.7015 16.3219 14.3681 16.4727C14.0437 16.6194 13.5877 16.6818 13.2359 16.6276C12.8742 16.5719 12.6084 16.4219 12.0769 16.1221C10.1924 15.0593 8.94092 13.8078 7.87805 11.9233C7.57824 11.3918 7.42833 11.126 7.37263 10.7643C7.31843 10.4124 7.38079 9.9565 7.52749 9.63208C7.67825 9.29869 7.93425 9.04269 8.44624 8.5307C8.96665 8.01029 9.22686 7.75008 9.37445 7.44543C9.53145 7.12138 9.59835 6.76105 9.56815 6.40224C9.53976 6.06491 9.3903 5.72863 9.09139 5.05609Z"
        fill="currentColor"
      />
    </>
  ),
  callFilled: (
    <path
      d="M5.31726 1.28657C5.88395 1.40369 6.33524 1.78443 6.61564 2.28746L7.50885 3.88991C7.83786 4.48011 8.11473 4.9768 8.29554 5.40857C8.48735 5.86658 8.60126 6.31824 8.54919 6.8176C8.49711 7.31696 8.29246 7.7354 8.01029 8.14399C7.74428 8.52917 7.37088 8.95804 6.92718 9.46767L5.61417 10.9759C5.37889 11.2461 5.26124 11.3812 5.25049 11.5501C5.23974 11.719 5.33616 11.8633 5.529 12.1518C7.17259 14.6109 9.38773 16.8268 11.8488 18.4718C12.1374 18.6647 12.2816 18.7611 12.4505 18.7503C12.6194 18.7396 12.7546 18.6219 13.0248 18.3866L14.5331 17.0736C15.0427 16.6299 15.4716 16.2565 15.8568 15.9905C16.2653 15.7083 16.6838 15.5036 17.1831 15.4516C17.6825 15.3995 18.1342 15.5134 18.5922 15.7052C19.0239 15.886 19.5206 16.1629 20.1107 16.4918L21.7133 17.3851C22.2163 17.6655 22.5971 18.1168 22.7142 18.6835C22.8325 19.2561 22.658 19.8316 22.2724 20.3047C20.8735 22.021 18.6322 23.1139 16.281 22.6396C14.8358 22.348 13.4098 21.8623 11.6851 20.8732C8.2197 18.8858 5.11263 15.777 3.12755 12.3157C2.13843 10.591 1.65272 9.165 1.36118 7.71974C0.886878 5.36852 1.97971 3.12724 3.69608 1.72833C4.16911 1.34279 4.74466 1.16822 5.31726 1.28657Z"
      fill="currentColor"
    />
  ),
  certificate: (
    <>
      <path
        d="M11.5 22C7.49306 22 5.48959 22 4.2448 20.5355C3 19.0711 3 16.714 3 12C3 7.28596 3 4.92893 4.2448 3.46447C5.48959 2 7.49306 2 11.5 2C15.5069 2 17.5104 2 18.7552 3.46447C19.7572 4.64332 19.9527 6.40054 19.9908 9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8H15M8 13H11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6092 18.1054C20.4521 17.4918 21 16.4974 21 15.375C21 13.511 19.489 12 17.625 12H17.375C15.511 12 14 13.511 14 15.375C14 16.4974 14.5479 17.4918 15.3908 18.1054M19.6092 18.1054C19.0523 18.5108 18.3666 18.75 17.625 18.75H17.375C16.6334 18.75 15.9477 18.5108 15.3908 18.1054M19.6092 18.1054L20.192 19.9404C20.4143 20.6403 20.5255 20.9903 20.4951 21.2082C20.4318 21.6617 20.0619 21.9984 19.6252 22C19.4154 22.0008 19.101 21.8358 18.4723 21.5059C18.2027 21.3644 18.0679 21.2936 17.93 21.252C17.649 21.1673 17.351 21.1673 17.07 21.252C16.9321 21.2936 16.7973 21.3644 16.5277 21.5059C15.899 21.8358 15.5846 22.0008 15.3748 22C14.9381 21.9984 14.5682 21.6617 14.5049 21.2082C14.4745 20.9903 14.5857 20.6403 14.808 19.9404L15.3908 18.1054"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  certificateFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5566 1.25C13.5045 1.24998 15.056 1.24996 16.2718 1.44227C17.5369 1.64238 18.5409 2.06461 19.3179 2.97873C20.0799 3.87527 20.4179 5.00361 20.5808 6.42849C20.7109 7.56695 20.7355 8.96746 20.7401 10.6906C19.8483 10.0964 18.7771 9.75 17.625 9.75H17.375C14.2684 9.75 11.75 12.2684 11.75 15.375C11.75 16.6204 12.1562 17.7722 12.8402 18.7032L12.6469 19.3115C12.5496 19.6179 12.4498 19.9319 12.382 20.197C12.3216 20.4329 12.1962 20.943 12.2765 21.5191C12.3377 21.9576 12.4905 22.3763 12.7183 22.7483C12.3506 22.75 11.9665 22.75 11.5656 22.75H11.4346C9.48668 22.75 7.93526 22.75 6.71943 22.5577C5.45432 22.3576 4.45035 21.9354 3.67334 21.0213C2.91129 20.1247 2.57328 18.9964 2.41045 17.5715C2.24999 16.1674 2.24999 14.3646 2.25 12.0495V12.0495V11.9505C2.24999 9.63539 2.24999 7.83262 2.41045 6.42849C2.57328 5.00361 2.91129 3.87527 3.67334 2.97873C4.44994 2.06508 5.45123 1.64255 6.71481 1.4423C7.92855 1.24996 9.47789 1.24998 11.4256 1.25H11.4256H11.5566H11.5566ZM8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75H15C15.4142 8.75 15.75 8.41421 15.75 8C15.75 7.58579 15.4142 7.25 15 7.25H8ZM8 12.25C7.58579 12.25 7.25 12.5858 7.25 13C7.25 13.4142 7.58579 13.75 8 13.75H10.209C10.6232 13.75 10.959 13.4142 10.959 13C10.959 12.5858 10.6232 12.25 10.209 12.25H8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.375 11.25C15.0968 11.25 13.25 13.0968 13.25 15.375C13.25 16.5477 13.7399 17.606 14.5242 18.3563L14.0863 19.7349C13.981 20.0665 13.8922 20.3459 13.8351 20.569C13.7808 20.7811 13.7251 21.0465 13.7621 21.3118C13.8731 22.1077 14.5353 22.7469 15.372 22.75C15.6508 22.751 15.9096 22.6473 16.1015 22.5611C16.306 22.4692 16.5587 22.3366 16.855 22.1811C17.1509 22.0258 17.2334 21.9861 17.2866 21.9701C17.4263 21.928 17.5737 21.928 17.7134 21.9701C17.7666 21.9861 17.849 22.0258 18.1449 22.1811C18.4412 22.3366 18.694 22.4692 18.8985 22.5611C19.0904 22.6473 19.3492 22.751 19.628 22.75C20.4647 22.7469 21.1269 22.1077 21.2379 21.3118C21.2749 21.0465 21.2192 20.7811 21.1649 20.569C21.1078 20.3459 21.019 20.0665 20.9137 19.7349L20.4758 18.3563C21.2601 17.606 21.75 16.5477 21.75 15.375C21.75 13.0968 19.9032 11.25 17.625 11.25H17.375ZM15.5231 20.167L15.8301 19.2002C16.3077 19.3932 16.8295 19.4996 17.3753 19.4996H17.6253C18.1711 19.4996 18.6929 19.3932 19.1705 19.2002L19.4775 20.167C19.5915 20.5259 19.6668 20.7641 19.712 20.9406C19.8192 21.3051 19.6243 21.2603 19.5134 21.1924C19.356 21.1216 19.0981 20.9867 18.7748 20.817C18.5511 20.6994 18.3552 20.5964 18.1468 20.5336C17.7246 20.4062 17.276 20.4062 16.8538 20.5336C16.6454 20.5964 16.4495 20.6994 16.2258 20.817C15.9025 20.9867 15.6446 21.1216 15.4872 21.1924C15.2109 21.3285 15.2397 21.0813 15.2886 20.9406C15.3338 20.7641 15.4091 20.5259 15.5231 20.167Z"
        fill="currentColor"
      />
    </>
  ),
  chat: (
    <path
      d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  ),
  chatFilled: (
    <path
      d="M9.85 1.75H14.15C18.2041 1.75 20.2311 1.75 21.4906 3.01407C22.75 4.27813 22.75 6.31261 22.75 10.3816V10.9211C22.75 14.99 22.75 17.0245 21.4906 18.2886C20.2311 19.5526 18.2041 19.5526 14.15 19.5526C13.5475 19.5661 13.0676 19.6121 12.5962 19.7199C11.5124 19.9703 10.4961 20.4783 9.49881 20.9768C9.31077 21.0708 9.12311 21.1646 8.93611 21.2562C7.25633 22.0782 6.41645 22.4893 5.88937 22.1045C5.38644 21.7285 5.36431 21.0194 5.5044 20.2351C5.56226 19.9112 5.5912 19.7492 5.52074 19.6474C5.45029 19.5457 5.28808 19.5158 4.96365 19.4558C3.90736 19.2607 3.09038 18.8716 2.50944 18.2886C1.25 17.0245 1.25 14.99 1.25 10.9211V10.3816C1.25 6.31261 1.25 4.27813 2.50944 3.01407C3.76888 1.75 5.79592 1.75 9.85 1.75Z"
      fill="currentColor"
    />
  ),
  chatHistory: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0564 1.25C12.8942 1.24999 14.3498 1.24997 15.489 1.40314C16.6614 1.56076 17.6104 1.89288 18.3588 2.64124C19.1071 3.38961 19.4392 4.33856 19.5969 5.51098C19.75 6.65018 19.75 8.10585 19.75 9.94359V11.8696C18.7939 11.3165 17.6839 11 16.5 11C12.9101 11 10 13.9101 10 17.5C10 19.6536 11.0474 21.5626 12.6606 22.7454C12.1617 22.75 11.6278 22.75 11.0572 22.75H11.0564C9.21865 22.75 7.65019 22.75 6.51098 22.5969C5.33856 22.4392 4.38961 22.1071 3.64124 21.3588C2.89288 20.6104 2.56076 19.6614 2.40314 18.489C2.24997 17.3498 2.24999 15.8942 2.25 14.0564V14.0564V9.94357V9.94356C2.24999 8.10581 2.24997 6.65019 2.40314 5.51098C2.56076 4.33856 2.89288 3.38961 3.64124 2.64124C4.38961 1.89288 5.33856 1.56076 6.51098 1.40314C7.65019 1.24997 9.21867 1.24999 11.0564 1.25H11.0564ZM7 6.25C6.58579 6.25 6.25 6.58579 6.25 7C6.25 7.41421 6.58579 7.75 7 7.75H15C15.4142 7.75 15.75 7.41421 15.75 7C15.75 6.58579 15.4142 6.25 15 6.25H7ZM7 10.25C6.58579 10.25 6.25 10.5858 6.25 11C6.25 11.4142 6.58579 11.75 7 11.75H11.5C11.9142 11.75 12.25 11.4142 12.25 11C12.25 10.5858 11.9142 10.25 11.5 10.25H7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 12.25C13.6005 12.25 11.25 14.6005 11.25 17.5C11.25 20.3995 13.6005 22.75 16.5 22.75C19.3995 22.75 21.75 20.3995 21.75 17.5C21.75 14.6005 19.3995 12.25 16.5 12.25ZM17.25 15.5C17.25 15.0858 16.9142 14.75 16.5 14.75C16.0858 14.75 15.75 15.0858 15.75 15.5V17.95C15.75 18.2646 15.9464 18.5458 16.2418 18.6542L17.7418 19.2042C18.1307 19.3468 18.5616 19.1471 18.7042 18.7582C18.8468 18.3693 18.6471 17.9384 18.2582 17.7958L17.25 17.4262V15.5Z"
        fill="currentColor"
      />
    </>
  ),
  chatVerified: (
    <>
      <path
        fill="currentColor"
        d="M15.98,9.27s-.03,0-.04,0c-.27-.01-.51-.17-.63-.41-.43-.86-.86-1.3-.86-1.31-.29-.29-.29-.77,0-1.06.29-.29.77-.29,1.06,0,.04.04.25.25.53.65.65-.84,1.67-1.97,2.69-2.33.39-.14.82.07.96.46.14.39-.07.82-.46.96-.85.3-2.05,1.81-2.62,2.7-.14.22-.38.35-.63.35Z"
      />
      <path
        fill="currentColor"
        d="M11.41,22.75c-2.21,0-4.53-.06-6.16-.15-3.01-.18-3.99-3.35-3.99-4.86-.02-1.27-.01-3.81,0-6.52v-4.25c0-4.7,2.98-5.42,4.26-5.51.03,0,1.97-.29,4.51-.18.41.02.73.37.72.78-.02.41-.34.73-.78.72-2.39-.1-4.27.17-4.29.17-1.36.1-2.92.87-2.92,4.02v4.26c-.01,2.71-.02,5.24,0,6.51,0,.69.44,3.24,2.58,3.37,3.06.18,8.58.22,11.12,0,.04,0,2.31-.16,2.57-2.4.26-2.25.24-3.88.24-4.5v-.19c0-.41.33-.75.75-.75s.75.34.75.75v.18c0,.64.03,2.35-.24,4.69-.34,2.89-2.97,3.66-3.96,3.72-1.22.1-3.14.15-5.15.15Z"
      />
      <path
        fill="currentColor"
        d="M17,12.77c-3.17,0-5.75-2.58-5.75-5.75s2.58-5.75,5.75-5.75,5.75,2.58,5.75,5.75-2.58,5.75-5.75,5.75ZM17,2.77c-2.35,0-4.25,1.91-4.25,4.25s1.91,4.25,4.25,4.25,4.25-1.91,4.25-4.25-1.91-4.25-4.25-4.25Z"
      />
      <path
        fill="currentColor"
        d="M10.98,13.77h-4c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h4c.41,0,.75.34.75.75s-.34.75-.75.75Z"
      />
      <path
        fill="currentColor"
        d="M14.98,17.77H6.98c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h8c.41,0,.75.34.75.75s-.34.75-.75.75Z"
      />
    </>
  ),
  chatVerifiedFilled: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17,1.25c-3.18,0-5.75,2.57-5.75,5.75s2.57,5.75,5.75,5.75,5.75-2.57,5.75-5.75-2.57-5.75-5.75-5.75ZM19.25,6.21c.39-.14.59-.57.46-.96s-.57-.59-.96-.46c-.48.17-.93.49-1.31.82-.39.34-.74.73-1.05,1.09-.15.18-.28.35-.4.5-.09-.08-.18-.15-.26-.21h0c-.16-.11-.37-.25-.72-.25-.41,0-.75.34-.75.75,0,.37.27.69.63.74,0,0,0,0,.01,0,.06.04.23.18.43.59.12.24.36.4.63.41s.53-.12.67-.35c.16-.23.64-.91.91-1.23.27-.33.58-.65.88-.92.32-.28.6-.46.82-.54Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.58,1.25c-1.72,1.33-2.83,3.41-2.83,5.75,0,4,3.25,7.25,7.25,7.25,1.37,0,2.66-.38,3.75-1.04v.85c0,1.84,0,3.29-.16,4.44-.17,1.18-.52,2.13-1.31,2.88-.78.74-1.77,1.07-3,1.22-1.2.15-2.74.15-4.69.15h-1.17c-1.95,0-3.49,0-4.69-.15-1.23-.16-2.22-.48-3-1.22-.79-.75-1.14-1.7-1.31-2.88-.16-1.14-.16-2.6-.16-4.44v-4.12c0-1.84,0-3.29.16-4.44.17-1.18.52-2.13,1.31-2.88.78-.74,1.77-1.07,3-1.22,1.2-.15,2.74-.15,4.69-.15h1.17c.35,0,.68,0,1,0ZM5,13c0-.55.45-1,1-1h3.11c.55,0,1,.45,1,1s-.45,1-1,1h-3.11c-.55,0-1-.45-1-1ZM6,16c-.55,0-1,.45-1,1s.45,1,1,1h8c.55,0,1-.45,1-1s-.45-1-1-1H6Z"
      />
    </>
  ),
  check: (
    <path
      d="M4.25 13.5L8.75 18L19.75 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  checkCircleFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12ZM16.6757 8.26285C17.0828 8.63604 17.1103 9.26861 16.7372 9.67573L11.2372 15.6757C11.0528 15.8768 10.7944 15.9938 10.5217 15.9998C10.249 16.0057 9.98576 15.9 9.79289 15.7071L7.29289 13.2071C6.90237 12.8166 6.90237 12.1834 7.29289 11.7929C7.68342 11.4024 8.31658 11.4024 8.70711 11.7929L10.4686 13.5544L15.2628 8.32428C15.636 7.91716 16.2686 7.88966 16.6757 8.26285Z"
      fill="currentColor"
    />
  ),
  checkThick: (
    <path
      d="M4.25 13.5L8.75 18L19.75 6"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  chevronDown: (
    <path
      d="M5.99977 9.00005L11.9998 15L17.9998 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  chevronLeft: (
    <path
      d="M15 6L9 12.0001L15 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  chevronRight: (
    <path
      d="M9.00005 6L15 12L9 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  chevronRightThick: (
    <path
      d="M9.00005 6L15 12L9 18"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  chevronUp: (
    <path
      d="M18 15L12 9L6 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  childcare: (
    <>
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 5.73791C14 5.73791 12.8849 6.23808 12.1017 5.85651C11.1464 5.39118 10.1991 3.44619 12.0914 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00897 9H8M16 9H15.991"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15C8.91212 16.2144 10.3643 17 12 17C13.6357 17 15.0879 16.2144 16 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  // playground: (
  //   <>
  //     <path
  //       d="M7 19L9.5 10.5"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M4.5 11.5H9"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M3 15.5H7.5"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M2 19L6 5L13.8191 17.163C14.3967 18.0616 14.6855 18.5108 15.1335 18.7554C15.5815 19 16.1156 19 17.1838 19H22C21.0651 19 20.1944 18.5246 19.6889 17.7382L11.5 5"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M7.5 7H12.5"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //   </>
  // ),
  circleFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
      fill="currentColor"
    />
  ),
  clock: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 7H12.75V11.6893L15.0303 13.9697L13.9697 15.0303L11.25 12.3107V7Z"
        fill="currentColor"
      />
    </>
  ),
  clockFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12C11 12.2652 11.1054 12.5196 11.2929 12.7071L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13 11.5858V8Z"
      fill="currentColor"
    />
  ),
  close: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.47016 4.46955C4.76305 4.17665 5.23793 4.17665 5.53082 4.46955L12.0005 10.9392L18.4702 4.46955C18.7631 4.17665 19.2379 4.17665 19.5308 4.46955C19.8237 4.76244 19.8237 5.23731 19.5308 5.53021L13.0612 11.9999L19.5308 18.4696C19.8237 18.7625 19.8237 19.2373 19.5308 19.5302C19.2379 19.8231 18.7631 19.8231 18.4702 19.5302L12.0005 13.0605L5.53082 19.5302C5.23793 19.8231 4.76305 19.8231 4.47016 19.5302C4.17727 19.2373 4.17726 18.7625 4.47016 18.4696L10.9398 11.9999L4.47016 5.53021C4.17726 5.23731 4.17727 4.76244 4.47016 4.46955Z"
      fill="currentColor"
    />
  ),
  closeSmall: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
      fill="currentColor"
    />
  ),
  // closeCircleFilled: (
  //   <path
  //     d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
  //     fill="currentColor"
  //   />
  // ),
  closeThick: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.47016 4.46955C4.76305 4.17665 5.23793 4.17665 5.53082 4.46955L12.0005 10.9392L18.4702 4.46955C18.7631 4.17665 19.2379 4.17665 19.5308 4.46955C19.8237 4.76244 19.8237 5.23731 19.5308 5.53021L13.0612 11.9999L19.5308 18.4696C19.8237 18.7625 19.8237 19.2373 19.5308 19.5302C19.2379 19.8231 18.7631 19.8231 18.4702 19.5302L12.0005 13.0605L5.53082 19.5302C5.23793 19.8231 4.76305 19.8231 4.47016 19.5302C4.17727 19.2373 4.17726 18.7625 4.47016 18.4696L10.9398 11.9999L4.47016 5.53021C4.17726 5.23731 4.17727 4.76244 4.47016 4.46955Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  ),
  cocktail: (
    <>
      <path
        d="M8.20538 15.3582L4.51713 11.0812C2.62475 8.88671 1.67856 7.78948 2.09833 6.89474C2.5181 6 3.97907 6 6.90099 6H11.099C14.0209 6 15.4819 6 15.9017 6.89474C16.3214 7.78948 15.3753 8.88671 13.4829 11.0812L9.79462 15.3582C9.42563 15.7861 9.24114 16 9 16C8.75886 16 8.57437 15.7861 8.20538 15.3582Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M8.5 6L8.09898 3.59389C8.03809 3.22852 7.78022 2.92674 7.42882 2.80961L5 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M9 16V22M7.5 22H10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M15.8601 8.83333C16.5043 9.54937 17.4403 10 18.4822 10C20.425 10 22 8.433 22 6.5C22 4.567 20.425 3 18.4822 3C16.71 3 15.2438 4.30385 15 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
    </>
  ),
  compare: (
    <>
      <path
        d="M19 17L19 11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5H10M10 5C10 4.29977 11.9943 2.99153 12.5 2.5M10 5C10 5.70023 11.9943 7.00847 12.5 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.5L5 13.5C5 16.3284 5 17.7426 5.87868 18.6213C6.75736 19.5 8.17157 19.5 11 19.5H14M14 19.5C14 20.2002 12.0057 21.5085 11.5 22M14 19.5C14 18.7998 12.0057 17.4915 11.5 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="19" cy="19" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="5" cy="5" r="2" stroke="currentColor" strokeWidth="1.5" />
    </>
  ),
  compass: (
    <>
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.4014 8.29796L15.3213 7.32465C16.2075 7.02924 16.6507 6.88153 16.8846 7.11544C17.1185 7.34935 16.9708 7.79247 16.6753 8.67871L15.702 11.5986C15.1986 13.1088 14.9469 13.8639 14.4054 14.4054C13.8639 14.9469 13.1088 15.1986 11.5986 15.702L8.67871 16.6753C7.79247 16.9708 7.34935 17.1185 7.11544 16.8846C6.88153 16.6507 7.02924 16.2075 7.32465 15.3213L8.29796 12.4014C8.80136 10.8912 9.05306 10.1361 9.59457 9.59457C10.1361 9.05306 10.8912 8.80136 12.4014 8.29796Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L11.9936 12.0064"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  compassFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.937 6.06293 22.75 12 22.75C17.937 22.75 22.75 17.937 22.75 12C22.75 6.06293 17.937 1.25 12 1.25ZM17.3532 6.64627C17.4872 6.7801 17.5341 6.97813 17.4743 7.15781L15.2957 13.708C15.0471 14.4555 14.4607 15.042 13.7134 15.2909L7.15702 17.4744C6.97741 17.5342 6.77942 17.4875 6.64554 17.3536C6.51165 17.2198 6.46484 17.0218 6.52461 16.8422L8.7022 10.2971C8.95066 9.5503 9.53628 8.96412 10.2828 8.71494L16.8415 6.52574C17.0212 6.46578 17.2192 6.51244 17.3532 6.64627ZM12.9985 11.9844C13.0071 12.5366 12.5664 12.9913 12.0142 12.9999L12.0078 13C11.4556 13.0086 11.0009 12.5679 10.9923 12.0157C10.9837 11.4635 11.4243 11.0089 11.9766 11.0002L11.983 11.0001C12.5352 10.9915 12.9898 11.4322 12.9985 11.9844Z"
      fill="currentColor"
    />
  ),
  conversation: (
    <>
      <path
        d="M7.5 12H13.5M7.5 8H10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 20C9.55038 20.8697 10.8145 21.4238 12.2635 21.5188C13.4052 21.5937 14.5971 21.5936 15.7365 21.5188C16.1288 21.4931 16.5565 21.4007 16.9248 21.251C17.3345 21.0845 17.5395 21.0012 17.6437 21.0138C17.7478 21.0264 17.8989 21.1364 18.2011 21.3563C18.7339 21.744 19.4051 22.0225 20.4005 21.9986C20.9038 21.9865 21.1555 21.9804 21.2681 21.7909C21.3808 21.6013 21.2405 21.3389 20.9598 20.8141C20.5706 20.0862 20.324 19.2529 20.6977 18.5852C21.3413 17.6315 21.8879 16.5021 21.9678 15.2823C22.0107 14.6269 22.0107 13.9481 21.9678 13.2927C21.9146 12.4799 21.7173 11.7073 21.4012 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.345 17.4868C15.9006 17.2526 18.7328 14.4069 18.9658 10.8344C19.0114 10.1353 19.0114 9.41131 18.9658 8.71219C18.7328 5.13969 15.9006 2.29401 12.345 2.05985C11.132 1.97997 9.86553 1.98013 8.65499 2.05985C5.09943 2.29401 2.26725 5.13969 2.0342 8.71219C1.9886 9.41131 1.9886 10.1353 2.0342 10.8344C2.11908 12.1356 2.69992 13.3403 3.38372 14.3576C3.78076 15.0697 3.51873 15.9586 3.10518 16.735C2.807 17.2948 2.65791 17.5747 2.77762 17.7769C2.89732 17.9791 3.16472 17.9856 3.69951 17.9985C4.75712 18.024 5.47028 17.7269 6.03638 17.3134C6.35744 17.0788 6.51798 16.9615 6.62862 16.9481C6.73926 16.9346 6.957 17.0234 7.39241 17.2011C7.78374 17.3608 8.23812 17.4593 8.65499 17.4868C9.86553 17.5665 11.132 17.5666 12.345 17.4868Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </>
  ),
  delete: (
    <>
      <path
        d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.5 16.5L9.5 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.5 16.5L14.5 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  // pencilFilled: (
  //   <>
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M10 19.75C10 19.1977 10.4477 18.75 11 18.75H17C17.5523 18.75 18 19.1977 18 19.75C18 20.3023 17.5523 20.75 17 20.75H11C10.4477 20.75 10 20.3023 10 19.75Z"
  //       fill="currentColor"
  //     />
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M14.1538 5.98191L6.36945 13.7663C5.40084 14.7347 4.80884 15.3265 4.40167 16.0552C4.17455 16.4616 3.97615 17.0781 3.8006 17.709C3.62 18.3579 3.44221 19.1047 3.27249 19.8175L3.27041 19.8262C3.21009 20.0796 3.28552 20.3461 3.46969 20.5303C3.65385 20.7144 3.92037 20.7899 4.17373 20.7295L4.18242 20.7275C4.89508 20.5579 5.64214 20.3799 6.29098 20.1993C6.92183 20.0238 7.53832 19.8254 7.94476 19.5983C8.67342 19.1911 9.26526 18.5991 10.2337 17.6305L18.018 9.84609L14.1538 5.98191ZM19.0786 8.78543L19.9497 7.91435C21.0168 6.84729 21.0168 5.11724 19.9497 4.05017C18.8827 2.98311 17.1526 2.98311 16.0855 4.05017L15.2145 4.92125L19.0786 8.78543Z"
  //       fill="currentColor"
  //     />
  //   </>
  // ),
  // gridFilled: (
  //   <>
  //     <rect x="5" y="5" width="6" height="6" rx="2" fill="currentColor" />
  //     <rect x="5" y="13" width="6" height="6" rx="2" fill="currentColor" />
  //     <rect x="13" y="5" width="6" height="6" rx="2" fill="currentColor" />
  //     <rect x="13" y="13" width="6" height="6" rx="2" fill="currentColor" />
  //   </>
  // ),
  // keyboard: (
  //   <>
  //     <path
  //       d="M14.5 7H9.5C6.21252 7 4.56878 7 3.46243 7.90796C3.25989 8.07418 3.07418 8.25989 2.90796 8.46243C2 9.56878 2 11.2125 2 14.5C2 17.7875 2 19.4312 2.90796 20.5376C3.07418 20.7401 3.25989 20.9258 3.46243 21.092C4.56878 22 6.21252 22 9.5 22H14.5C17.7875 22 19.4312 22 20.5376 21.092C20.7401 20.9258 20.9258 20.7401 21.092 20.5376C22 19.4312 22 17.7875 22 14.5C22 11.2125 22 9.56878 21.092 8.46243C20.9258 8.25989 20.7401 8.07418 20.5376 7.90796C19.4312 7 17.7875 7 14.5 7Z"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     />
  //     <path
  //       d="M12 7V5C12 4.44772 12.4477 4 13 4C13.5523 4 14 3.55228 14 3V2"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M7 12H8"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M11.5 12H12.5"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M16 12H17"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //     <path
  //       d="M7 17H17"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     />
  //   </>
  // ),
  doctor: (
    <>
      <path
        d="M20 22V19C20 16.1716 20 14.7574 19.1213 13.8787C18.2426 13 16.8284 13 14 13L12 15L10 13C7.17157 13 5.75736 13 4.87868 13.8787C4 14.7574 4 16.1716 4 19V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M16 13V18.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8.5 13V17M8.5 17C9.60457 17 10.5 17.8954 10.5 19V20M8.5 17C7.39543 17 6.5 17.8954 6.5 19V20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15.5 6.5V5.5C15.5 3.567 13.933 2 12 2C10.067 2 8.5 3.567 8.5 5.5V6.5C8.5 8.433 10.067 10 12 10C13.933 10 15.5 8.433 15.5 6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M16.75 19.25C16.75 19.6642 16.4142 20 16 20C15.5858 20 15.25 19.6642 15.25 19.25C15.25 18.8358 15.5858 18.5 16 18.5C16.4142 18.5 16.75 18.8358 16.75 19.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
      ></path>
    </>
  ),
  document: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 4C3.25 2.48122 4.48122 1.25 6 1.25H13C13.1989 1.25 13.3897 1.32902 13.5303 1.46967L20.5303 8.46967C20.671 8.61032 20.75 8.80109 20.75 9V20C20.75 21.5188 19.5188 22.75 18 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V4ZM6 2.75C5.30964 2.75 4.75 3.30964 4.75 4V20C4.75 20.6904 5.30964 21.25 6 21.25H18C18.6904 21.25 19.25 20.6904 19.25 20V9.31066L12.6893 2.75H6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 7V2H13.75V7C13.75 7.69036 14.3096 8.25 15 8.25H20V9.75H15C13.4812 9.75 12.25 8.51878 12.25 7Z"
        fill="currentColor"
      />
    </>
  ),
  documentAI: (
    <>
      <path
        d="M19 11.0032V10C19 6.22876 19 4.34315 17.8284 3.17157C16.6569 2 14.7712 2 11 2H10.0082L3 8.98648V14.0062C3 17.7714 3 19.654 4.16811 20.825L4.17504 20.8319C5.34602 22 7.2286 22 10.9938 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9.00195H4C6.82843 9.00195 8.24264 9.00195 9.12132 8.12327C10 7.24459 10 5.83038 10 3.00195V2.00195"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4069 21.5983C16.6192 22.1365 17.3808 22.1365 17.5931 21.5983L17.6298 21.5051C18.1482 20.1906 19.1887 19.1502 20.5031 18.6318L20.5964 18.595C21.1345 18.3828 21.1345 17.6211 20.5964 17.4089L20.5031 17.3721C19.1887 16.8537 18.1482 15.8133 17.6298 14.4989L17.5931 14.4056C17.3808 13.8674 16.6192 13.8674 16.4069 14.4056L16.3702 14.4989C15.8518 15.8133 14.8113 16.8537 13.4969 17.3721L13.4036 17.4089C12.8655 17.6211 12.8655 18.3828 13.4036 18.595L13.4969 18.6318C14.8113 19.1502 15.8518 20.1906 16.3702 21.5051L16.4069 21.5983Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  documentCheck: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4801 15.4239C20.7983 15.689 20.8413 16.1619 20.5762 16.4802L15.5762 22.4802C15.4413 22.642 15.2445 22.7397 15.034 22.7492C14.8235 22.7588 14.6187 22.6794 14.4697 22.5303L12.4697 20.5303C12.1768 20.2375 12.1768 19.7626 12.4697 19.4697C12.7626 19.1768 13.2374 19.1768 13.5303 19.4697L14.9496 20.889L19.4238 15.5199C19.689 15.2017 20.1619 15.1587 20.4801 15.4239Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 4C3.25 2.48122 4.48122 1.25 6 1.25H13C13.1989 1.25 13.3897 1.32902 13.5303 1.46967L20.5303 8.46967C20.671 8.61032 20.75 8.80109 20.75 9V13C20.75 13.4142 20.4142 13.75 20 13.75C19.5858 13.75 19.25 13.4142 19.25 13V9.31066L12.6893 2.75H6C5.30964 2.75 4.75 3.30964 4.75 4V20C4.75 20.6904 5.30964 21.25 6 21.25H10C10.4142 21.25 10.75 21.5858 10.75 22C10.75 22.4142 10.4142 22.75 10 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 7V2H13.75V7C13.75 7.69036 14.3096 8.25 15 8.25H20V9.75H15C13.4812 9.75 12.25 8.51878 12.25 7Z"
        fill="currentColor"
      />
    </>
  ),
  documentDownload: (
    <>
      <path
        d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9L7 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 13L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  documentDownloadFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 14.5475L3.25006 9.58262L3.93948 10.4322C4.24983 10.7984 4.63633 11.2265 5.05081 11.5795C5.25916 11.757 5.52709 11.9611 5.84242 12.1298C6.13996 12.289 6.63268 12.5 7.25 12.5C7.86733 12.5 8.36004 12.289 8.65759 12.1298C8.97291 11.9611 9.24084 11.757 9.4492 11.5795C9.86368 11.2265 10.2502 10.7984 10.5605 10.4322L11.9094 8.76954C12.7285 7.87599 12.6932 6.48709 11.8182 5.6366C11.1844 5.02053 10.2807 4.85291 9.5 5.12818V1.27145C10.2792 1.25001 11.1477 1.25002 12.071 1.25003C13.8438 1.25001 15.2727 1.24999 16.3965 1.40186C17.5633 1.55955 18.5457 1.8969 19.326 2.6812C20.1062 3.46551 20.4418 4.45303 20.5987 5.62589C20.7498 6.75557 20.7498 8.19192 20.7497 9.97393L20.7499 13.4482C20.7509 14.1116 20.7518 14.7003 20.5277 15.2441C20.3037 15.7878 19.8889 16.2035 19.4215 16.6718L14.6387 21.4795C14.2362 21.8851 13.8799 22.2442 13.4251 22.4629C13.3314 22.5079 13.2353 22.5479 13.1373 22.5827C12.6619 22.7514 12.1574 22.7507 11.5874 22.7499C10.0617 22.75 8.6541 22.7499 7.67535 22.635C6.66266 22.5161 5.79495 22.2631 5.05993 21.6674C4.79012 21.4487 4.54435 21.2017 4.32681 20.9305C3.73418 20.1916 3.48249 19.3194 3.36425 18.3015C3.24997 17.3176 3.24998 16.0811 3.25 14.5475ZM18.7314 14.4961C18.6746 14.634 18.5692 14.7643 17.9511 15.3856L13.3462 20.0145C12.8133 20.5502 12.6719 20.6836 12.4902 20.7383C12.4902 19.3765 12.4902 18.7204 12.6065 17.8552C12.7275 16.9551 12.9864 16.1972 13.5884 15.5953C14.1903 14.9934 14.9481 14.7345 15.8483 14.6135C16.7152 14.4969 17.3638 14.4961 18.7314 14.4961Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 1.25003C7.80229 1.25003 8.25 1.69775 8.25 2.25003V8.12842C8.44276 7.89384 8.63115 7.65388 8.8107 7.42518C8.82861 7.40237 8.84643 7.37967 8.86416 7.35709C9.09344 7.06519 9.33989 6.75164 9.53292 6.55304C9.91786 6.15701 10.551 6.14801 10.947 6.53295C11.343 6.91789 11.352 7.55099 10.9671 7.94702C10.8652 8.05184 10.6942 8.265 10.437 8.59249C10.4184 8.61612 10.3996 8.64016 10.3804 8.66456C10.1525 8.95493 9.8838 9.29722 9.60685 9.62407C9.31032 9.97402 8.97549 10.3411 8.6387 10.6279C8.46989 10.7717 8.27715 10.9157 8.0678 11.0277C7.86638 11.1355 7.58271 11.25 7.25 11.25C6.91729 11.25 6.63363 11.1355 6.4322 11.0277C6.22285 10.9157 6.03012 10.7717 5.8613 10.6279C5.52451 10.3411 5.18968 9.97403 4.89315 9.62407C4.61619 9.29722 4.3475 8.95491 4.11958 8.66455C4.10043 8.64015 4.08156 8.61611 4.06301 8.59249C3.80578 8.265 3.6348 8.05184 3.53292 7.94702C3.14798 7.55099 3.15698 6.91789 3.55301 6.53295C3.94904 6.14801 4.58215 6.15701 4.96708 6.55304C5.16012 6.75164 5.40657 7.06519 5.63584 7.3571C5.65358 7.37968 5.67141 7.40238 5.68932 7.42521C5.86886 7.6539 6.05725 7.89385 6.25 8.12842L6.25 2.25003C6.25 1.69775 6.69772 1.25003 7.25 1.25003Z"
        fill="currentColor"
      />
    </>
  ),
  documentFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.19144 22.75C4.58211 22.75 3.27678 21.4403 3.27427 19.823L3.25 4.18619C3.24749 2.56532 4.55429 1.25 6.16717 1.25H12.9695C13.2271 1.25 13.4741 1.35268 13.6564 1.53551L20.4645 8.36329C20.6473 8.5466 20.75 8.79546 20.75 9.05498V19.8184C20.75 21.4375 19.4439 22.75 17.8328 22.75H6.19144ZM18.8043 9.46094L12.5673 3.20594V7.96094C12.5673 8.78936 13.2389 9.46094 14.0673 9.46094H18.8043Z"
      fill="currentColor"
    />
  ),
  documentText: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H12C12.4142 12.25 12.75 12.5858 12.75 13C12.75 13.4142 12.4142 13.75 12 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 4C3.25 2.48122 4.48122 1.25 6 1.25H13C13.1989 1.25 13.3897 1.32902 13.5303 1.46967L20.5303 8.46967C20.671 8.61032 20.75 8.80109 20.75 9V20C20.75 21.5188 19.5188 22.75 18 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V4ZM6 2.75C5.30964 2.75 4.75 3.30964 4.75 4V20C4.75 20.6904 5.30964 21.25 6 21.25H18C18.6904 21.25 19.25 20.6904 19.25 20V9.31066L12.6893 2.75H6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 7V2H13.75V7C13.75 7.69036 14.3096 8.25 15 8.25H20V9.75H15C13.4812 9.75 12.25 8.51878 12.25 7Z"
        fill="currentColor"
      />
    </>
  ),
  documentUpload: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 2C12.25 1.58579 12.5858 1.25 13 1.25H18C19.5188 1.25 20.75 2.48122 20.75 4V15.0145C20.75 15.2137 20.6708 15.4047 20.5298 15.5454L13.5284 22.5324C13.3878 22.6727 13.1972 22.7515 12.9986 22.7515H6C4.48122 22.7515 3.25 21.5203 3.25 20.0015V12C3.25 11.5858 3.58579 11.25 4 11.25C4.41421 11.25 4.75 11.5858 4.75 12V20.0015C4.75 20.6919 5.30964 21.2515 6 21.2515H12.6884L19.25 14.7034V4C19.25 3.30964 18.6904 2.75 18 2.75H13C12.5858 2.75 12.25 2.41421 12.25 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 17C12.25 15.4812 13.4812 14.25 15 14.25H20V15.75H15C14.3096 15.75 13.75 16.3096 13.75 17V22H12.25V17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.46967 1.46967C6.76256 1.17678 7.23744 1.17678 7.53033 1.46967L10.5303 4.46967C10.8232 4.76256 10.8232 5.23744 10.5303 5.53033C10.2374 5.82322 9.76256 5.82322 9.46967 5.53033L7.75 3.81066V10C7.75 10.4142 7.41421 10.75 7 10.75C6.58579 10.75 6.25 10.4142 6.25 10V3.81066L4.53033 5.53033C4.23744 5.82322 3.76256 5.82322 3.46967 5.53033C3.17678 5.23744 3.17678 4.76256 3.46967 4.46967L6.46967 1.46967Z"
        fill="currentColor"
      />
    </>
  ),
  documentUploadFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63584 5.14294C5.40657 5.43484 5.16012 5.74839 4.96708 5.94699C4.58215 6.34302 3.94904 6.35202 3.55301 5.96708C3.15698 5.58214 3.14798 4.94904 3.53292 4.55301C3.6348 4.44819 3.80578 4.23503 4.06301 3.90754C4.08157 3.88391 4.10044 3.85988 4.11959 3.83547C4.34751 3.54511 4.6162 3.20281 4.89315 2.87596C5.18969 2.52601 5.52451 2.15896 5.86131 1.87211C6.03012 1.72834 6.22285 1.58436 6.43221 1.47233C6.63363 1.36454 6.91729 1.25 7.25 1.25C7.58271 1.25 7.86638 1.36454 8.0678 1.47233C8.27715 1.58436 8.46989 1.72834 8.6387 1.87211C8.97549 2.15896 9.31032 2.52601 9.60685 2.87596C9.88381 3.20282 10.1525 3.54512 10.3804 3.83549C10.3996 3.85989 10.4184 3.88392 10.437 3.90754C10.6942 4.23503 10.8652 4.44819 10.9671 4.55301C11.352 4.94904 11.343 5.58214 10.947 5.96708C10.551 6.35202 9.91786 6.34302 9.53292 5.94699C9.33989 5.74839 9.09344 5.43484 8.86416 5.14294C8.84643 5.12036 8.82861 5.09766 8.8107 5.07485C8.63115 4.84615 8.44276 4.60619 8.25 4.37161L8.25 10.25C8.25 10.8023 7.80229 11.25 7.25 11.25C6.69772 11.25 6.25 10.8023 6.25 10.25L6.25 4.37161C6.05724 4.60618 5.86886 4.84614 5.68932 5.07483C5.6714 5.09765 5.65358 5.12036 5.63584 5.14294Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27715 7.27948C3.24998 8.07213 3.24999 8.96792 3.25 9.97383V14.5474C3.24998 16.0811 3.24997 17.3176 3.36425 18.3014C3.48248 19.3194 3.73418 20.1916 4.32681 20.9305C4.54435 21.2017 4.79012 21.4487 5.05993 21.6674C5.79495 22.2631 6.66266 22.5161 7.67535 22.635C8.6541 22.7498 10.0617 22.7499 11.5874 22.7499C12.1574 22.7507 12.6619 22.7513 13.1373 22.5827C13.2353 22.5479 13.3314 22.5079 13.4251 22.4629C13.8799 22.2442 14.2362 21.8851 14.6387 21.4795L19.4215 16.6718C19.8889 16.2035 20.3037 15.7878 20.5277 15.244C20.7518 14.7003 20.7509 14.1115 20.7499 13.4482L20.7497 9.9739C20.7498 8.19189 20.7498 6.75554 20.5987 5.62586C20.4418 4.453 20.1062 3.46548 19.326 2.68117C18.5457 1.89686 17.5633 1.55952 16.3965 1.40183C15.2727 1.24996 13.8438 1.24997 12.071 1.25C11.2732 1.24999 10.5163 1.24998 9.82257 1.26381C10.0944 1.53119 10.3457 1.81435 10.5605 2.06787L10.5777 2.08855L11.9094 3.73049C12.7285 4.62404 12.6932 6.01294 11.8182 6.86343C11.1844 7.47951 10.2807 7.64712 9.5 7.37185L9.5 10.25C9.5 11.4926 8.49264 12.5 7.25 12.5C6.00736 12.5 5 11.4926 5 10.25L5 7.37185C4.44071 7.56906 3.81826 7.53896 3.27715 7.27948ZM17.9511 15.3856C18.5692 14.7643 18.6746 14.6339 18.7314 14.4961C17.3638 14.4961 16.7152 14.4969 15.8483 14.6134C14.9481 14.7344 14.1903 14.9933 13.5884 15.5953C12.9864 16.1972 12.7275 16.955 12.6065 17.8551C12.4902 18.7203 12.4902 19.3764 12.4902 20.7383C12.6719 20.6836 12.8133 20.5502 13.3462 20.0145L17.9511 15.3856Z"
        fill="currentColor"
      />
    </>
  ),
  doors: (
    <>
      <path
        d="M17 16V8C17 5.64298 17 4.46447 16.2678 3.73223C15.5355 3 14.357 3 12 3H8C5.64298 3 4.46447 3 3.73223 3.73223C3 4.46447 3 5.64298 3 8V16C3 18.357 3 19.5355 3.73223 20.2678C4.46447 21 5.64298 21 8 21H12C14.357 21 15.5355 21 16.2678 20.2678C17 19.5355 17 18.357 17 16Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11 21H17C18.8856 21 19.8284 21 20.4142 20.4142C21 19.8284 21 18.8856 21 17V10C21 8.11438 21 7.17157 20.4142 6.58579C19.8284 6 18.8856 6 17 6"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M13 11V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  downloadFilled: (
    <>
      <path
        d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM8.5 16.25C7.94772 16.25 7.5 16.6977 7.5 17.25C7.5 17.8023 7.94772 18.25 8.5 18.25H15.5C16.0523 18.25 16.5 17.8023 16.5 17.25C16.5 16.6977 16.0523 16.25 15.5 16.25H8.5ZM12 5.75C11.4477 5.75 11 6.19772 11 6.75V11.3359L9.20703 9.54297L9.13086 9.47461C8.73809 9.15426 8.15908 9.17685 7.79297 9.54297C7.42685 9.90908 7.40426 10.4881 7.72461 10.8809L7.79297 10.957L11.293 14.457C11.4805 14.6446 11.7348 14.75 12 14.75C12.2652 14.75 12.5195 14.6446 12.707 14.457L16.207 10.957C16.5976 10.5665 16.5976 9.93349 16.207 9.54297C15.8165 9.15244 15.1835 9.15244 14.793 9.54297L13 11.3359V6.75C13 6.19772 12.5523 5.75 12 5.75Z"
        fill="currentColor"
      />
    </>
  ),
  drag: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6.5C4 5.67157 4.67157 5 5.5 5H5.50634C6.33477 5 7.00634 5.67157 7.00634 6.5C7.00634 7.32843 6.33477 8 5.50634 8H5.5C4.67157 8 4 7.32843 4 6.5ZM9.99683 6.5C9.99683 5.67157 10.6684 5 11.4968 5H11.5032C12.3316 5 13.0032 5.67157 13.0032 6.5C13.0032 7.32843 12.3316 8 11.5032 8H11.4968C10.6684 8 9.99683 7.32843 9.99683 6.5ZM15.9937 6.5C15.9937 5.67157 16.6652 5 17.4937 5H17.5C18.3284 5 19 5.67157 19 6.5C19 7.32843 18.3284 8 17.5 8H17.4937C16.6652 8 15.9937 7.32843 15.9937 6.5ZM4 12.5C4 11.6716 4.67157 11 5.5 11H5.50634C6.33477 11 7.00634 11.6716 7.00634 12.5C7.00634 13.3284 6.33477 14 5.50634 14H5.5C4.67157 14 4 13.3284 4 12.5ZM9.99683 12.5C9.99683 11.6716 10.6684 11 11.4968 11H11.5032C12.3316 11 13.0032 11.6716 13.0032 12.5C13.0032 13.3284 12.3316 14 11.5032 14H11.4968C10.6684 14 9.99683 13.3284 9.99683 12.5ZM15.9937 12.5C15.9937 11.6716 16.6652 11 17.4937 11H17.5C18.3284 11 19 11.6716 19 12.5C19 13.3284 18.3284 14 17.5 14H17.4937C16.6652 14 15.9937 13.3284 15.9937 12.5ZM4 18.5C4 17.6716 4.67157 17 5.5 17H5.50634C6.33477 17 7.00634 17.6716 7.00634 18.5C7.00634 19.3284 6.33477 20 5.50634 20H5.5C4.67157 20 4 19.3284 4 18.5ZM9.99683 18.5C9.99683 17.6716 10.6684 17 11.4968 17H11.5032C12.3316 17 13.0032 17.6716 13.0032 18.5C13.0032 19.3284 12.3316 20 11.5032 20H11.4968C10.6684 20 9.99683 19.3284 9.99683 18.5ZM15.9937 18.5C15.9937 17.6716 16.6652 17 17.4937 17H17.5C18.3284 17 19 17.6716 19 18.5C19 19.3284 18.3284 20 17.5 20H17.4937C16.6652 20 15.9937 19.3284 15.9937 18.5Z"
      fill="currentColor"
    />
  ),
  dropFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2723 1.35235C12.6673 0.882548 11.8327 0.882549 11.2277 1.35235C10.2594 2.10421 8.23017 3.77604 6.43589 5.88816C4.66736 7.96996 3 10.6255 3 13.3309C3 17.8466 6.50744 22.5 12.25 22.5C17.9926 22.5 21.5 17.8466 21.5 13.3309C21.5 10.6255 19.8326 7.96996 18.0641 5.88816C16.2698 3.77604 14.2406 2.10421 13.2723 1.35235ZM18 14.75C18 14.3358 17.6642 14 17.25 14C16.8358 14 16.5 14.3358 16.5 14.75C16.5 16.5449 15.0449 18 13.25 18C12.8358 18 12.5 18.3358 12.5 18.75C12.5 19.1642 12.8358 19.5 13.25 19.5C15.8734 19.5 18 17.3734 18 14.75Z"
      fill="currentColor"
    />
  ),
  edit: (
    <>
      <path
        d="M16.4249 4.60509L17.4149 3.6151C18.2351 2.79497 19.5648 2.79497 20.3849 3.6151C21.205 4.43524 21.205 5.76493 20.3849 6.58507L19.3949 7.57506M16.4249 4.60509L9.76558 11.2644C9.25807 11.772 8.89804 12.4078 8.72397 13.1041L8 16L10.8959 15.276C11.5922 15.102 12.228 14.7419 12.7356 14.2344L19.3949 7.57506M16.4249 4.60509L19.3949 7.57506"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M18.9999 13.5C18.9999 16.7875 18.9999 18.4312 18.092 19.5376C17.9258 19.7401 17.7401 19.9258 17.5375 20.092C16.4312 21 14.7874 21 11.4999 21H11C7.22876 21 5.34316 21 4.17159 19.8284C3.00003 18.6569 3 16.7712 3 13V12.5C3 9.21252 3 7.56879 3.90794 6.46244C4.07417 6.2599 4.2599 6.07417 4.46244 5.90794C5.56879 5 7.21252 5 10.5 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  email: (
    <>
      <path
        d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </>
  ),
  emailFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.92 2.78677C12.967 2.7377 11.033 2.7377 9.07999 2.78677L9.02182 2.78823C7.497 2.82651 6.27002 2.85732 5.2867 3.02857C4.2572 3.20786 3.42048 3.55174 2.71362 4.26129C2.00971 4.96787 1.66764 5.79256 1.49176 6.80537C1.32429 7.76974 1.29878 8.96677 1.26719 10.4496L1.26593 10.5084C1.24469 11.5047 1.24469 12.4952 1.26594 13.4916L1.26719 13.5503C1.29879 15.0332 1.32429 16.2302 1.49176 17.1946C1.66764 18.2074 2.00972 19.0321 2.71362 19.7386C3.42048 20.4482 4.2572 20.7921 5.2867 20.9714C6.27001 21.1426 7.49697 21.1734 9.02177 21.2117L9.07999 21.2132C11.033 21.2622 12.967 21.2622 14.92 21.2132L14.9782 21.2117C16.503 21.1734 17.73 21.1426 18.7133 20.9714C19.7428 20.7921 20.5795 20.4482 21.2864 19.7386C21.9903 19.0321 22.3324 18.2074 22.5082 17.1946C22.6757 16.2302 22.7012 15.0332 22.7328 13.5503L22.7341 13.4916C22.7553 12.4952 22.7553 11.5047 22.7341 10.5084L22.7328 10.4496C22.7012 8.96679 22.6757 7.76976 22.5082 6.80539C22.3324 5.79258 21.9903 4.96789 21.2864 4.26131C20.5795 3.55176 19.7428 3.20788 18.7133 3.02859C17.73 2.85733 16.503 2.82652 14.9782 2.78824L14.92 2.78677ZM7.38182 7.85449C7.02527 7.64368 6.56533 7.76183 6.35452 8.11838C6.14371 8.47494 6.26186 8.93488 6.61841 9.14569L9.56043 10.8851C10.4313 11.4 11.1827 11.7501 12.0001 11.7501C12.8175 11.7501 13.569 11.4 14.4398 10.8851L17.3818 9.14569C17.7384 8.93488 17.8565 8.47494 17.6457 8.11838C17.4349 7.76183 16.975 7.64368 16.6184 7.85449L13.6764 9.59392C12.832 10.0931 12.3831 10.2501 12.0001 10.2501C11.6171 10.2501 11.1682 10.0931 10.3238 9.59392L7.38182 7.85449Z"
      fill="currentColor"
    />
  ),
  euro: (
    <>
      <path
        d="M5 10H13M5 14H13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 17.6076C17.8693 19.6404 15.812 21 13.4615 21C9.89293 21 7 17.866 7 14V10C7 6.13401 9.89293 3 13.4615 3C15.812 3 17.8693 4.35958 19 6.39241"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  eye: (
    <>
      <path
        d="M21.544 11.045C21.848 11.4713 22 11.6845 22 12C22 12.3155 21.848 12.5287 21.544 12.955C20.1779 14.8706 16.6892 19 12 19C7.31078 19 3.8221 14.8706 2.45604 12.955C2.15201 12.5287 2 12.3155 2 12C2 11.6845 2.15201 11.4713 2.45604 11.045C3.8221 9.12944 7.31078 5 12 5C16.6892 5 20.1779 9.12944 21.544 11.045Z"
        stroke="currentColor"
        strokeWidth="1.5"
      ></path>
      <path
        d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      ></path>
    </>
  ),
  eyeOff: (
    <>
      <path
        d="M21.544 11.045C21.848 11.4713 22 11.6845 22 12C22 12.3155 21.848 12.5287 21.544 12.955C20.1779 14.8706 16.6892 19 12 19C7.31078 19 3.8221 14.8706 2.45604 12.955C2.15201 12.5287 2 12.3155 2 12C2 11.6845 2.15201 11.4713 2.45604 11.045C3.8221 9.12944 7.31078 5 12 5C16.6892 5 20.1779 9.12944 21.544 11.045Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3 21L21 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  film: (
    <>
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      ></path>
      <path
        d="M2.5 7H21.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      ></path>
      <path
        d="M2.5 17H21.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      ></path>
      <path
        d="M12 17L12 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8 7L8 3M16 7L16 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8 21L8 17M16 21L16 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  floorPlan: (
    <>
      <path
        d="M2.5 9.5H13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M17.5 9.5H21.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.5 21.5L9.5 9.5"
        stroke="currentColor"
        strokeWidth="1.5"
      ></path>
      <path
        d="M9.5 6.5V2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M17 17C15 17 13 18.6223 13 21.5H10.5C6.72876 21.5 4.84315 21.5 3.67157 20.3284C2.5 19.1569 2.5 17.2712 2.5 13.5V10.5C2.5 6.72876 2.5 4.84315 3.67157 3.67157C4.84315 2.5 6.72876 2.5 10.5 2.5H13.5C17.2712 2.5 19.1569 2.5 20.3284 3.67157C21.5 4.84315 21.5 6.72876 21.5 10.5V17.8432C21.5 19.8628 19.8628 21.5 17.8432 21.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  floppyDisk: (
    <>
      <path
        d="M8 22V19C8 17.1144 8 16.1716 8.58579 15.5858C9.17157 15 10.1144 15 12 15C13.8856 15 14.8284 15 15.4142 15.5858C16 16.1716 16 17.1144 16 19V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M10 7H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11.8584C3 7.28199 3 4.99376 4.38674 3.54394C4.43797 3.49038 4.49038 3.43797 4.54394 3.38674C5.99376 2 8.28199 2 12.8584 2C13.943 2 14.4655 2.00376 14.9628 2.18936C15.4417 2.3681 15.8429 2.70239 16.6452 3.37099L18.8411 5.20092C19.9027 6.08561 20.4335 6.52795 20.7168 7.13266C21 7.73737 21 8.42833 21 9.81025V13C21 16.7497 21 18.6246 20.0451 19.9389C19.7367 20.3634 19.3634 20.7367 18.9389 21.0451C17.6246 22 15.7497 22 12 22C8.25027 22 6.3754 22 5.06107 21.0451C4.6366 20.7367 4.26331 20.3634 3.95491 19.9389C3 18.6246 3 16.7497 3 13V11.8584Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  folder: (
    <path
      d="M8 7H16.75C18.8567 7 19.91 7 20.6667 7.50559C20.9943 7.72447 21.2755 8.00572 21.4944 8.33329C22 9.08996 22 10.1433 22 12.25C22 15.7612 22 17.5167 21.1573 18.7779C20.7926 19.3238 20.3238 19.7926 19.7779 20.1573C18.5167 21 16.7612 21 13.25 21H12C7.28595 21 4.92893 21 3.46447 19.5355C2 18.0711 2 15.714 2 11V7.94427C2 6.1278 2 5.21956 2.38032 4.53806C2.65142 4.05227 3.05227 3.65142 3.53806 3.38032C4.21956 3 5.1278 3 6.94427 3C8.10802 3 8.6899 3 9.19926 3.19101C10.3622 3.62712 10.8418 4.68358 11.3666 5.73313L12 7"
      strokeWidth="1.5"
      strokeLinecap="round"
      stroke="currentColor"
    />
  ),
  folderFilled: (
    <path
      d="M7.08264 2.24992C8.11205 2.24947 8.82373 2.24915 9.4626 2.48872C10.8581 3.01201 11.4704 4.25117 11.9425 5.20632C12.0838 5.48905 12.3409 6.00266 12.4128 6.11559C12.4348 6.15251 12.5044 6.22813 12.6064 6.23527C12.7396 6.24904 12.92 6.24996 13.2361 6.24996H16.7905C17.8095 6.24995 18.6312 6.24994 19.2905 6.31701C19.9711 6.38624 20.5613 6.53309 21.0834 6.88195C21.4929 7.15555 21.8444 7.50711 22.118 7.91657C22.4669 8.43868 22.6137 9.02889 22.683 9.70945C22.75 10.3688 22.75 11.2733 22.75 12.2923C22.75 14.012 22.75 15.3602 22.6408 16.4336C22.5295 17.5283 22.2983 18.4202 21.781 19.1945C21.3614 19.8224 20.8224 20.3614 20.1945 20.781C19.4202 21.2983 18.5283 21.5295 17.4336 21.6408C16.3602 21.75 15.012 21.75 13.2923 21.75H11.9426C9.63423 21.75 7.82519 21.75 6.41371 21.5603C4.96897 21.366 3.82895 20.9607 2.93414 20.0659C2.03933 19.1711 1.63399 18.031 1.43975 16.5863C1.24998 15.1748 1.24999 13.3658 1.25 11.0574V7.90947C1.24999 7.03073 1.24998 6.32201 1.30044 5.74966C1.35242 5.15992 1.46238 4.64384 1.7254 4.17254C2.06428 3.5653 2.56533 3.06424 3.17258 2.72536C3.64388 2.46234 4.15996 2.35239 4.7497 2.3004C5.32205 2.24995 6.2039 2.24991 7.08264 2.24992Z"
      fill="currentColor"
    />
  ),
  formPlus: (
    <>
      <path
        fill="currentColor"
        d="M18,10.75c-.41,0-.75-.34-.75-.75v-3.25h-3.25c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h3.25v-3.25c0-.41.34-.75.75-.75s.75.34.75.75v3.25h3.25c.41,0,.75.34.75.75s-.34.75-.75.75h-3.25v3.25c0,.41-.34.75-.75.75Z"
      />
      <path
        fill="currentColor"
        d="M6,10.75c-1.52,0-2.28,0-2.98-.35-.62-.31-1.11-.81-1.42-1.42-.35-.7-.35-1.46-.35-2.97s0-2.28.35-2.98c.31-.62.8-1.11,1.42-1.42.69-.35,1.46-.35,2.97-.35s2.28,0,2.98.35c.62.31,1.11.8,1.42,1.42.35.69.35,1.46.35,2.97s0,2.28-.35,2.97c-.31.62-.8,1.11-1.42,1.42-.69.35-1.46.35-2.98.35ZM6,2.75c-1.24,0-1.92,0-2.29.19-.33.17-.6.43-.76.76-.19.38-.19,1.06-.19,2.29s0,1.92.19,2.29c.17.33.43.59.77.76.37.19,1.06.19,2.29.19s1.92,0,2.29-.19c.33-.17.6-.43.76-.76.19-.38.19-1.06.19-2.29s0-1.92-.19-2.29c-.17-.33-.43-.6-.76-.76-.38-.19-1.06-.19-2.29-.19Z"
      />
      <path
        fill="currentColor"
        d="M6,22.75c-1.52,0-2.28,0-2.98-.35-.62-.31-1.11-.81-1.42-1.42-.35-.7-.35-1.46-.35-2.97s0-2.28.35-2.98c.31-.62.8-1.11,1.42-1.42.69-.35,1.46-.35,2.97-.35s2.28,0,2.98.35c.62.31,1.11.8,1.42,1.42.35.69.35,1.46.35,2.97s0,2.28-.35,2.97c-.31.62-.8,1.11-1.42,1.42-.69.35-1.46.35-2.98.35ZM6,14.75c-1.24,0-1.92,0-2.29.19-.33.17-.6.43-.76.76-.19.38-.19,1.06-.19,2.29s0,1.92.19,2.29c.17.33.43.59.77.76.37.19,1.06.19,2.29.19s1.92,0,2.29-.19c.33-.17.6-.43.76-.76.19-.38.19-1.06.19-2.29s0-1.92-.19-2.29c-.17-.33-.43-.6-.76-.76-.38-.19-1.06-.19-2.29-.19Z"
      />
      <path
        fill="currentColor"
        d="M18,22.75c-1.52,0-2.28,0-2.98-.35-.62-.31-1.11-.81-1.42-1.42-.35-.7-.35-1.46-.35-2.97s0-2.28.35-2.98c.31-.62.8-1.11,1.42-1.42.69-.35,1.46-.35,2.97-.35s2.28,0,2.98.35c.62.31,1.11.8,1.42,1.42.35.69.35,1.46.35,2.97s0,2.28-.35,2.97c-.31.62-.8,1.11-1.42,1.42-.69.35-1.46.35-2.98.35ZM18,14.75c-1.24,0-1.92,0-2.29.19-.33.17-.6.43-.76.76-.19.38-.19,1.06-.19,2.29s0,1.92.19,2.29c.17.33.43.59.77.76.37.19,1.06.19,2.29.19s1.92,0,2.29-.19c.33-.17.6-.43.76-.76.19-.38.19-1.06.19-2.29s0-1.92-.19-2.29c-.17-.33-.43-.6-.76-.76-.38-.19-1.06-.19-2.29-.19Z"
      />
    </>
  ),
  formPlusFilled: (
    <>
      <path
        fill="currentColor"
        d="M18.03,13.25c.67,0,1.22,0,1.67.04.46.04.88.12,1.27.32.61.31,1.11.81,1.42,1.42.2.39.28.81.32,1.27.04.45.04,1,.04,1.67v.06c0,.67,0,1.22-.04,1.67-.04.46-.12.88-.32,1.27-.31.61-.81,1.11-1.42,1.42-.39.2-.81.28-1.27.32-.45.04-1,.04-1.67.04h-.06c-.67,0-1.22,0-1.67-.04-.46-.04-.88-.12-1.27-.32-.61-.31-1.11-.81-1.42-1.42-.2-.39-.28-.81-.32-1.27-.04-.45-.04-1-.04-1.67v-.06c0-.67,0-1.22.04-1.67.04-.46.12-.88.32-1.27.31-.61.81-1.11,1.42-1.42.39-.2.81-.28,1.27-.32.45-.04,1-.04,1.67-.04h.06Z"
      />
      <path
        fill="currentColor"
        d="M6.03,13.25c.67,0,1.22,0,1.67.04.46.04.88.12,1.27.32.61.31,1.11.81,1.42,1.42.2.39.28.81.32,1.27.04.45.04,1,.04,1.67v.06c0,.67,0,1.22-.04,1.67-.04.46-.12.88-.32,1.27-.31.61-.81,1.11-1.42,1.42-.39.2-.81.28-1.27.32-.45.04-1,.04-1.67.04h-.06c-.67,0-1.22,0-1.67-.04-.46-.04-.88-.12-1.27-.32-.61-.31-1.11-.81-1.42-1.42-.2-.39-.28-.81-.32-1.27-.04-.45-.04-1-.04-1.67v-.06c0-.67,0-1.22.04-1.67.04-.46.12-.88.32-1.27.31-.61.81-1.11,1.42-1.42.39-.2.81-.28,1.27-.32.45-.04,1-.04,1.67-.04h.06Z"
      />
      <path
        fill="currentColor"
        d="M6.03,1.25c.67,0,1.22,0,1.67.04.46.04.88.12,1.27.32.61.31,1.11.81,1.42,1.42.2.39.28.81.32,1.27.04.45.04,1,.04,1.67v.06c0,.67,0,1.22-.04,1.67-.04.46-.12.88-.32,1.27-.31.61-.81,1.11-1.42,1.42-.39.2-.81.28-1.27.32-.45.04-1,.04-1.67.04h-.06c-.67,0-1.22,0-1.67-.04-.46-.04-.88-.12-1.27-.32-.61-.31-1.11-.81-1.42-1.42-.2-.39-.28-.81-.32-1.27-.04-.45-.04-1-.04-1.67v-.06c0-.67,0-1.22.04-1.67.04-.46.12-.88.32-1.27.31-.61.81-1.11,1.42-1.42.39-.2.81-.28,1.27-.32.45-.04,1-.04,1.67-.04h.06Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18,1.5c.55,0,1,.45,1,1v2.5h2.5c.55,0,1,.45,1,1s-.45,1-1,1h-2.5v2.5c0,.55-.45,1-1,1s-1-.45-1-1v-2.5h-2.5c-.55,0-1-.45-1-1s.45-1,1-1h2.5v-2.5c0-.55.45-1,1-1Z"
      />
    </>
  ),
  fullScreen: (
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
      transform="translate(4 4)"
    />
  ),
  graph: (
    <>
      <path
        d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 12H6.00898M8.9982 12H9.00718M11.9964 12H12.0054M14.9946 12H15.0036M17.9928 12H18.0018M20.991 12H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7C6.67348 5.87847 7.58712 5 8.99282 5C14.9359 5 11.5954 17 17.9819 17C19.3976 17 20.3057 16.1157 21 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  graph2: (
    <>
      <path
        d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5 20C5.43938 16.8438 7.67642 8.7643 10.4282 8.7643C12.3301 8.7643 12.8226 12.6353 14.6864 12.6353C17.8931 12.6353 17.4282 4 21 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  graph3: (
    <>
      <path
        d="M7 18V16M12 18V15M17 18V13M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99219 11.4863C8.14729 11.5581 13.0341 11.2328 15.8137 6.82132M13.9923 6.28835L15.8678 5.98649C16.0964 5.95738 16.432 6.13785 16.5145 6.35298L17.0104 7.99142"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  graphFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.312 1.93059C15.9686 1.74998 14.2479 1.74999 12.0572 1.75H11.9428C9.75212 1.74999 8.03144 1.74998 6.68802 1.93059C5.31137 2.11568 4.21911 2.50272 3.36091 3.36091C2.50272 4.21911 2.11568 5.31137 1.93059 6.68802C1.74998 8.03144 1.74999 9.75212 1.75 11.9428V12.0572C1.74999 14.2479 1.74998 15.9686 1.93059 17.312C2.11568 18.6886 2.50272 19.7809 3.36091 20.6391C4.21911 21.4973 5.31137 21.8843 6.68802 22.0694C8.03144 22.25 9.7521 22.25 11.9428 22.25H11.9428H12.0572H12.0572C14.2479 22.25 15.9686 22.25 17.312 22.0694C18.6886 21.8843 19.7809 21.4973 20.6391 20.6391C21.4973 19.7809 21.8843 18.6886 22.0694 17.312C22.25 15.9686 22.25 14.2479 22.25 12.0572V12.0572V11.9428V11.9428C22.25 9.7521 22.25 8.03144 22.0694 6.68802C21.8843 5.31137 21.4973 4.21911 20.6391 3.36091C19.7809 2.50272 18.6886 2.11568 17.312 1.93059ZM7.75 13C7.75 12.5858 7.41421 12.25 7 12.25C6.58579 12.25 6.25 12.5858 6.25 13V17C6.25 17.4142 6.58579 17.75 7 17.75C7.41421 17.75 7.75 17.4142 7.75 17V13ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V7C11.25 6.58579 11.5858 6.25 12 6.25ZM17.75 11C17.75 10.5858 17.4142 10.25 17 10.25C16.5858 10.25 16.25 10.5858 16.25 11V17C16.25 17.4142 16.5858 17.75 17 17.75C17.4142 17.75 17.75 17.4142 17.75 17V11Z"
        fill="currentColor"
      />
    </>
  ),
  greenHouse: (
    <>
      <path
        d="M12.551 13.6081C11.0316 15.2407 5.21031 18.0107 7.02784 21.0275C7.68071 22.1111 9.56024 22 10.8612 22H13.1388C16.5537 22 18.2611 22 19.429 21.0286C20.5969 20.0572 20.8471 18.4289 21.3476 15.1724L21.6486 13.2135C22.0016 10.9162 22.1781 9.76763 21.7438 8.74938C21.3095 7.73112 20.346 7.03443 18.4189 5.64106L16.979 4.6C14.5817 2.86667 13.3831 2 12 2C10.6169 2 9.41829 2.86667 7.02099 4.6L5.58114 5.64106C3.65403 7.03443 2.69047 7.73112 2.25617 8.74938C1.82186 9.76763 1.99837 10.9162 2.35139 13.2135L2.65243 15.1724C3.00843 17.489 3.23781 18.9817 3.76102 20M12.1801 18.1259C14.5484 17.6674 16.1708 16.2098 16.9339 13.855C17.7983 11.1881 16.6267 7.88376 13.6752 7.11938C13.6752 7.11938 14.5852 8.20421 13.9973 9.15585C12.864 11.1955 9.62452 10.5174 8.32535 13.1165C7.56032 14.5675 7.79225 16.285 8.89383 17.3563C9.58602 18.0294 11.0428 18.3461 12.1801 18.1259Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  handBag: (
    <>
      <path
        d="M19.1737 12.9256V12.12C19.1737 10.6492 19.1737 9.91383 18.7234 9.45691C18.2732 9 17.5485 9 16.0992 9H7.90077C6.45147 9 5.72682 9 5.27658 9.45691C4.82634 9.91383 4.82634 10.6492 4.82634 12.12V12.9256C4.82634 13.3018 4.82634 13.4899 4.79345 13.6739C4.76056 13.858 4.69549 14.0341 4.56534 14.3863L4.34812 14.9742C3.16867 18.166 2.57895 19.7619 3.34312 20.8809C4.1073 22 5.78684 22 9.14591 22H14.8541C18.2132 22 19.8927 22 20.6569 20.8809C21.4211 19.7619 20.8313 18.166 19.6519 14.9742L19.4347 14.3863C19.3045 14.0341 19.2394 13.858 19.2065 13.6739C19.1737 13.4899 19.1737 13.3018 19.1737 12.9256Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M16 11C16 5 13.8655 2 12 2C10.1345 2 8 5 8 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M12 16C13.2504 16 14.944 18.6278 13.3547 18.8954C12.5228 19.0354 11.4711 19.0344 10.6453 18.8954C9.056 18.6278 10.7496 16 12 16Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M13.94 17.0049C15.2105 16.8729 17.4477 16.1267 19.0551 14.9424"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M10.1147 17.0314C8.84417 16.8993 6.60699 16.1532 4.99961 14.9689"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  handshake: (
    <>
      <path
        fill="currentColor"
        d="M9,20h0c-.58,0-1.12-.23-1.53-.64l-2.83-2.89c-.54-.55-.77-.78-1-.88s-.55-.1-1.33-.1h-.32c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h.32c.9,0,1.4,0,1.91.21s.86.57,1.49,1.21l2.83,2.88c.12.12.29.19.46.19h0c.18,0,.34-.07.47-.2.26-.26.26-.69,0-.95h0l-.5-.5c-.29-.29-.29-.77,0-1.06.29-.29.77-.29,1.06,0l2,2.01c.12.13.29.2.47.2h0c.18,0,.34-.07.47-.2.26-.26.26-.69,0-.95l-2-2c-.29-.29-.29-.77,0-1.06s.77-.29,1.06,0l2,2h0s1,1.01,1,1.01c.12.13.29.2.47.2h0c.18,0,.34-.07.47-.2.26-.26.26-.69,0-.95h0l-3-3.02c-.29-.29-.29-.77,0-1.06.29-.29.77-.29,1.06,0l3,3.02s0,0,0,0h0s.5.5.5.5c.12.13.29.2.47.2h0c.18,0,.34-.07.47-.2.26-.26.26-.69,0-.95l-5.78-5.82h-.38l-1.01,1.02c-.99,1-2.57,1.09-3.67.2-.24-.19-.39-.31-.51-.47-.46-.58-.5-1.39-.11-2.01.11-.17.23-.29.46-.52l.76-.76c.91-.91,1.41-1.41,2.09-1.69.69-.28,1.55-.28,2.86-.28.94,0,1.46,0,1.99.16.5.15,1.2.61,2.23,1.29.48.32.67.44.84.5.17.05.41.05.97.05h2.79c.41,0,.75.34.75.75s-.34.75-.75.75h-2.79c-.65,0-1.01,0-1.4-.12-.39-.12-.69-.32-1.22-.67-.61-.41-1.52-1.01-1.84-1.11-.32-.1-.73-.1-1.56-.1-1.08,0-1.87,0-2.28.17-.41.17-.81.57-1.6,1.36l-.77.77c-.13.13-.21.2-.25.26-.05.08-.04.2.02.28.05.05.13.11.27.23.5.4,1.21.36,1.66-.09l1.23-1.24c.14-.14.33-.22.53-.22h1c.2,0,.39.08.53.22l6,6.04c.84.84.84,2.22,0,3.07-.41.41-.95.64-1.53.64h0c-.15,0-.29-.01-.43-.04-.1.33-.28.65-.54.91-.41.41-.95.64-1.53.64h0c-.37,0-.72-.09-1.03-.26-.1.23-.25.44-.43.63-.41.41-.95.64-1.53.64h0c-.58,0-1.12-.23-1.53-.64l-.04-.04c-.1.2-.23.38-.39.54-.41.41-.95.64-1.53.64Z"
      />
      <path
        fill="currentColor"
        d="M22,15.5h-2.5c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h2.5c.41,0,.75.34.75.75s-.34.75-.75.75Z"
      />
      <path
        fill="currentColor"
        d="M8.5,7.5H2c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h6.5c.41,0,.75.34.75.75s-.34.75-.75.75Z"
      />
    </>
  ),
  handshakeFilled: (
    <>
      <path
        fill="currentColor"
        d="M18.5,6.25h3c.55,0,1,.45,1,1v6c0,.55-.45,1-1,1h-1.59c-.01-.34-.15-.68-.41-.95l-6-6.04h-1l-1.23,1.24c-.72.72-1.87.79-2.66.15l-1.1-.89,2.62-2.64c.56-.57,1.33-.88,2.12-.88h2.35c.59,0,1.17.18,1.66.51l2.24,1.49Z"
      />
      <path
        fill="currentColor"
        d="M2.5,7.25h3.86c-.08.18-.12.38-.11.59.02.35.19.68.46.9l1.1.89c1.29,1.04,3.16.94,4.33-.24l.73-.74,5.62,5.65c.26.26.4.6.41.95.02.38-.12.77-.41,1.07-.55.56-1.45.56-2,0l-.5-.5c.55.56.55,1.46,0,2.01-.55.56-1.45.56-2,0l-1-1.01c.55.56.55,1.46,0,2.01-.55.56-1.45.56-2,0l-1.5-1.51c.55.56.55,1.46,0,2.01-.55.56-1.45.56-2,0l-4-4.08h-1c-.55,0-1-.45-1-1v-6c0-.55.45-1,1-1Z"
      />
    </>
  ),
  help: (
    <>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 9.39815 13.8837 9.76913 13.6831 10.0808C13.0854 11.0097 12 11.8954 12 13V13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.992 17H12.001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  helpSquare: (
    <>
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5C14.5 10.3569 14.0689 11.1131 13.4117 11.5636C12.7283 12.0319 12 12.6716 12 13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 17H12.009"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  helpSquareFilled: (
    <path
      d="M12.0527 1.75C14.2453 1.74999 15.9673 1.74998 17.3115 1.93066C18.6882 2.11575 19.7805 2.50313 20.6387 3.36133C21.4969 4.21953 21.8843 5.31182 22.0693 6.68848C22.25 8.03274 22.25 9.75468 22.25 11.9473V12.0527C22.25 14.2453 22.25 15.9673 22.0693 17.3115C21.8843 18.6882 21.4969 19.7805 20.6387 20.6387C19.7805 21.4969 18.6882 21.8843 17.3115 22.0693C15.9673 22.25 14.2453 22.25 12.0527 22.25H11.9473C9.75468 22.25 8.03274 22.25 6.68848 22.0693C5.31182 21.8843 4.21953 21.4969 3.36133 20.6387C2.50313 19.7805 2.11575 18.6882 1.93066 17.3115C1.74998 15.9673 1.74999 14.2453 1.75 12.0527V11.9473C1.74999 9.75468 1.74998 8.03274 1.93066 6.68848C2.11575 5.31182 2.50313 4.21953 3.36133 3.36133C4.21953 2.50313 5.31182 2.11575 6.68848 1.93066C8.03274 1.74998 9.75468 1.74999 11.9473 1.75H12.0527ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18H12.0088L12.1113 17.9951C12.6155 17.9439 13.0088 17.5177 13.0088 17C13.0088 16.4823 12.6155 16.0561 12.1113 16.0049L12.0088 16H12ZM12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 10.0523 8.94772 10.5 9.5 10.5C10.0523 10.5 10.5 10.0523 10.5 9.5C10.5 8.67158 11.1716 8 12 8C12.8284 8 13.5 8.67158 13.5 9.5C13.5 9.9492 13.3034 10.3529 12.9883 10.6289L12.8467 10.7383C12.4769 10.9917 12.0355 11.3308 11.6807 11.7578C11.322 12.1896 11 12.7754 11 13.5C11 14.0523 11.4477 14.5 12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 13.3962 13.0426 13.2483 13.2188 13.0361C13.3989 12.8193 13.6632 12.6035 13.9766 12.3887L14.1455 12.2656C14.9681 11.6267 15.5 10.6255 15.5 9.5C15.5 7.567 13.933 6 12 6Z"
      fill="currentColor"
    />
  ),
  highwayExit: (
    <>
      <path
        d="M2 21.9979V11.9955"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 21.9979V11.9955"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21.9974V20.9977"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.9964V16.9967"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.72533 5.65438L6.55526 6.41335M6.55526 6.41335C6.71446 6.14502 6.99041 5.67493 7.08183 5.38084C7.88067 2.81094 7.95145 2.10297 9.18504 2.00183H14.8119C16.0455 2.10297 16.1163 2.81094 16.9151 5.38084C17.0065 5.67493 17.2326 6.14502 17.3918 6.41335M6.55526 6.41335C5.95054 7.43262 5.1493 8.09969 5.02924 8.98037C5.0096 9.12441 5.02924 10.7318 5.02924 11.898C5.02924 12.7742 5.87312 12.7475 6.69535 12.8157C7.21787 12.859 7.74116 12.9538 8.26545 12.9592C11.1713 12.9888 13.0926 12.9919 15.9671 12.9606C16.5229 12.9545 17.083 12.85 17.637 12.803C18.2625 12.7499 18.9165 12.6794 18.9677 11.898C19.044 10.733 18.9873 9.12441 18.9677 8.98037C18.8476 8.09969 17.9965 7.43262 17.3918 6.41335M6.55526 6.41335H17.3918M17.3918 6.41335L18.364 5.65438M5.20362 8.42936L6.41209 9.34913M10.5581 10.5112L13.4968 10.5112M17.6201 9.32635L18.9548 8.90078M7.08183 12.855L7.00382 14.4987M16.9822 12.8755V14.4987"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  home: (
    <>
      <path
        fill="currentColor"
        d="M21.27,7.83c-.48-.99-1.29-1.62-2.89-2.87l-1-.78c-2.49-1.94-3.74-2.92-5.37-2.92s-2.86.96-5.29,2.86h0s-1.08.84-1.08.84c-1.6,1.25-2.41,1.88-2.89,2.87-.48.99-.48,2.01-.48,4.06v2.09c0,3.99,0,5.99,1.39,7.38,1.39,1.4,3.39,1.4,7.36,1.4h2c3.97,0,5.97,0,7.36-1.4,1.39-1.4,1.39-3.4,1.39-7.38v-2.09c0-2.04,0-3.07-.48-4.06ZM20.25,13.97c0,3.57,0,5.37-.95,6.32-.95.96-2.74.96-6.3.96h-2c-3.56,0-5.35,0-6.3-.96-.95-.96-.95-2.75-.95-6.32v-2.09c0-1.81,0-2.72.33-3.4.33-.68,1.05-1.24,2.47-2.35l1.01-.79c4.43-3.46,4.45-3.46,8.89,0l1.01.78c1.42,1.11,2.13,1.67,2.46,2.34.33.68.33,1.59.33,3.4v2.09Z"
      />
      <rect
        fill="currentColor"
        x="14.25"
        y="15.75"
        width="3.53"
        height="3.53"
        rx=".77"
        ry=".77"
      />
    </>
  ),
  homeFilled: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12,1.25c-.87,0-1.65.3-2.47.8-.8.48-1.71,1.2-2.86,2.09l-1.18.92c-1.38,1.07-2.27,1.77-2.75,2.76-.48.99-.48,2.12-.48,3.87v2.33c0,1.84,0,3.31.15,4.45.16,1.18.49,2.13,1.24,2.88.75.75,1.7,1.08,2.87,1.24,1.14.15,2.6.15,4.43.15h2.11c1.84,0,3.29,0,4.43-.15,1.17-.16,2.12-.49,2.87-1.24.75-.75,1.08-1.7,1.24-2.88.15-1.14.15-2.6.15-4.45v-2.33c0-1.75,0-2.88-.48-3.87-.48-.99-1.37-1.69-2.75-2.76l-1.18-.92c-1.15-.9-2.06-1.61-2.86-2.09-.83-.5-1.6-.8-2.47-.8ZM15,15.75c-.41,0-.75.34-.75.75v2c0,.41.34.75.75.75h2c.41,0,.75-.34.75-.75v-2c0-.41-.34-.75-.75-.75h-2Z"
    />
  ),
  hospital: (
    <>
      <path
        d="M14 2V4M14 4V6M14 4H10M10 2V4M10 4V6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 22V11.3808C3 7.8766 3 6.12452 4.15327 5.03591C4.88623 4.34404 5.90312 4.09189 7.5 4M21 22V11.3808C21 7.8766 21 6.12452 19.8467 5.03591C19.1138 4.34404 18.0969 4.09189 16.5 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 10H16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14 14H16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 14H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 10H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 22H9.5M22 22H14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 22V19.5C9.5 18.5654 9.5 18.0981 9.70096 17.75C9.83261 17.522 10.022 17.3326 10.25 17.201C10.5981 17 11.0654 17 12 17C12.9346 17 13.4019 17 13.75 17.201C13.978 17.3326 14.1674 17.522 14.299 17.75C14.5 18.0981 14.5 18.5654 14.5 19.5V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  house: (
    <>
      <path
        d="M22 10.5L12.8825 2.82207C12.6355 2.61407 12.3229 2.5 12 2.5C11.6771 2.5 11.3645 2.61407 11.1175 2.82207L2 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 5V15.5C20.5 18.3284 20.5 19.7426 19.6213 20.6213C18.7426 21.5 17.3284 21.5 14.5 21.5H9.5C6.67157 21.5 5.25736 21.5 4.37868 20.6213C3.5 19.7426 3.5 18.3284 3.5 15.5V9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11.5H9.5V12.5H10.5V11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M14.5 11.5H13.5V12.5H14.5V11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M10.5 15.5H9.5V16.5H10.5V15.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M14.5 15.5H13.5V16.5H14.5V15.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  houseSearch: (
    <>
      <path
        d="M20.0167 20.0233L21.9998 22M21.0528 17.5265C21.0528 15.5789 19.4739 14 17.5263 14C15.5786 14 13.9998 15.5789 13.9998 17.5265C13.9998 19.4742 15.5786 21.0531 17.5263 21.0531C19.4739 21.0531 21.0528 19.4742 21.0528 17.5265Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="currentColor"
        d="m 13.275461,21.585588 h -2 c -3.5600006,0 -5.3500006,0 -6.3000006,-0.96 -0.95,-0.96 -0.95,-2.75 -0.95,-6.32 v -2.09 c 0,-1.81 0,-2.72 0.33,-3.399999 0.33,-0.68 1.05,-1.24 2.47,-2.35 l 1.01,-0.79 c 3.6772146,-2.872046 4.3158606,-3.36009 6.9661116,-1.464132 0.54255,0.388133 1.169403,0.876177 1.923888,1.464132 l 1.01,0.78 c 1.42,1.11 2.130001,1.67 2.460001,2.34 0.33,0.679999 0.33,1.589999 0.33,3.399999 l 1.52,0.03 c 0,-2.04 0,-3.07 -0.48,-4.059999 h -0.02 c -0.48,-0.99 -1.29,-1.62 -2.890001,-2.87 l -1,-0.78 c -2.489999,-1.94 -3.739999,-2.92 -5.369999,-2.92 -1.63,0 -2.8600006,0.96 -5.2900006,2.86 v 0 l -1.08,0.84 c -1.6,1.25 -2.41,1.88 -2.89,2.87 -0.48,0.989999 -0.48,2.009999 -0.48,4.059999 v 2.09 c 0,3.99 0,5.99 1.39,7.38 1.39,1.4 3.39,1.4 7.3600006,1.4 h 2"
      />
    </>
  ),
  houseSearchFilled: (
    <>
      <path
        d="m 20.416176,20.422776 1.9831,1.9767 m -0.947,-4.4735 c 0,-1.9476 -1.5789,-3.5265 -3.5265,-3.5265 -1.9477,0 -3.5265,1.5789 -3.5265,3.5265 0,1.9477 1.5788,3.5266 3.5265,3.5266 1.9476,0 3.5265,-1.5789 3.5265,-3.5266 z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 12.285156 1.5957031 C 10.655156 1.5957031 9.4260937 2.5550781 6.9960938 4.4550781 L 5.9160156 5.2949219 C 4.3160156 6.5449219 3.5053906 7.1760156 3.0253906 8.1660156 C 2.5453906 9.1560146 2.5449219 10.176562 2.5449219 12.226562 L 2.5449219 14.316406 C 2.5449219 18.306406 2.5455469 20.305312 3.9355469 21.695312 C 5.3255469 23.095312 7.3249213 23.095703 11.294922 23.095703 L 13.294922 23.095703 L 13.28125 21.996094 C 12.135691 20.871409 11.417969 19.312073 11.417969 17.601562 C 11.417969 14.221834 14.213904 11.423828 17.59375 11.423828 C 18.94703 11.423828 20.206021 11.872079 21.230469 12.626953 L 22.044922 12.226562 C 22.044922 10.186562 22.046406 9.1560146 21.566406 8.1660156 L 21.544922 8.1660156 C 21.064922 7.1760156 20.256251 6.5449219 18.65625 5.2949219 L 17.65625 4.515625 C 15.166251 2.575625 13.915156 1.5957031 12.285156 1.5957031 z "
        fill="currentColor"
      />
    </>
  ),
  identityCard: (
    <>
      <path
        d="M14 3.5H10C6.22876 3.5 4.34315 3.5 3.17157 4.67157C2 5.84315 2 7.72876 2 11.5V12.5C2 16.2712 2 18.1569 3.17157 19.3284C4.34315 20.5 6.22876 20.5 10 20.5H14C17.7712 20.5 19.6569 20.5 20.8284 19.3284C22 18.1569 22 16.2712 22 12.5V11.5C22 7.72876 22 5.84315 20.8284 4.67157C19.6569 3.5 17.7712 3.5 14 3.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5 16C6.03569 13.4189 9.89616 13.2491 11 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.75 9.75C9.75 10.7165 8.9665 11.5 8 11.5C7.0335 11.5 6.25 10.7165 6.25 9.75C6.25 8.7835 7.0335 8 8 8C8.9665 8 9.75 8.7835 9.75 9.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M14 8.5H19M14 12H19M14 15.5H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  image: (
    <>
      <path
        d="M3 16L7.46967 11.5303C7.80923 11.1908 8.26978 11 8.75 11C9.23022 11 9.69077 11.1908 10.0303 11.5303L14 15.5M15.5 17L14 15.5M21 16L18.5303 13.5303C18.1908 13.1908 17.7302 13 17.25 13C16.7698 13 16.3092 13.1908 15.9697 13.5303L14 15.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 8C15.7761 8 16 7.77614 16 7.5C16 7.22386 15.7761 7 15.5 7M15.5 8C15.2239 8 15 7.77614 15 7.5C15 7.22386 15.2239 7 15.5 7M15.5 8V7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.69797 19.7472C2.5 18.3446 2.5 16.2297 2.5 12C2.5 7.77027 2.5 5.6554 3.69797 4.25276C3.86808 4.05358 4.05358 3.86808 4.25276 3.69797C5.6554 2.5 7.77027 2.5 12 2.5C16.2297 2.5 18.3446 2.5 19.7472 3.69797C19.9464 3.86808 20.1319 4.05358 20.302 4.25276C21.5 5.6554 21.5 7.77027 21.5 12C21.5 16.2297 21.5 18.3446 20.302 19.7472C20.1319 19.9464 19.9464 20.1319 19.7472 20.302C18.3446 21.5 16.2297 21.5 12 21.5C7.77027 21.5 5.6554 21.5 4.25276 20.302C4.05358 20.1319 3.86808 19.9464 3.69797 19.7472Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  imageFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0261 2.25C15.8081 2.24997 17.2444 2.24995 18.3741 2.40148C19.547 2.5588 20.5345 2.89536 21.3188 3.67786C22.1031 4.46035 22.4405 5.44558 22.5982 6.61573C22.75 7.74277 22.75 9.17578 22.75 10.9536V13.0464C22.75 14.8242 22.75 16.2572 22.5982 17.3843C22.4405 18.5544 22.1031 19.5397 21.3188 20.3221C20.5345 21.1046 19.547 21.4412 18.3741 21.5985C17.2444 21.75 15.8081 21.75 14.0261 21.75H9.97392C8.19192 21.75 6.75558 21.75 5.6259 21.5985C4.45303 21.4412 3.4655 21.1046 2.68118 20.3221C1.89687 19.5397 1.55952 18.5544 1.40183 17.3843C1.24995 16.2572 1.24997 14.8242 1.25 13.0464V13.0463V10.9537V10.9536C1.24997 9.17579 1.24995 7.74278 1.40183 6.61572C1.55952 5.44558 1.89687 4.46035 2.68118 3.67786C3.4655 2.89536 4.45303 2.5588 5.6259 2.40148C6.75558 2.24995 8.19193 2.24997 9.97393 2.25H9.97395H14.026H14.0261ZM10 8.5C10 9.32843 9.32843 10 8.5 10C7.67157 10 7 9.32843 7 8.5C7 7.67157 7.67157 7 8.5 7C9.32843 7 10 7.67157 10 8.5ZM4.06326 18.9433C3.70263 18.5835 3.4675 18.0784 3.33895 17.1244L3.33115 17.065L6.15441 13.8888C6.37423 13.6415 6.68931 13.5 7.02019 13.5C7.32741 13.5 7.62205 13.622 7.83928 13.8393L10 16L14.6571 11.3429C14.8767 11.1234 15.1745 11 15.485 11C15.8132 11 16.1263 11.1377 16.348 11.3797L20.7467 16.1783C20.7271 16.5248 20.6996 16.8382 20.6611 17.1244C20.5325 18.0784 20.2974 18.5835 19.9367 18.9433C19.5761 19.3031 19.0698 19.5377 18.1137 19.6659C17.1294 19.7979 15.8249 19.8 13.9546 19.8H10.0455C8.17507 19.8 6.87059 19.7979 5.88634 19.6659C4.93021 19.5377 4.42389 19.3031 4.06326 18.9433Z"
      fill="currentColor"
    />
  ),
  income: (
    <>
      <path
        d="M3 8.5H15C17.8284 8.5 19.2426 8.5 20.1213 9.37868C21 10.2574 21 11.6716 21 14.5V15.5C21 18.3284 21 19.7426 20.1213 20.6213C19.2426 21.5 17.8284 21.5 15 21.5H9C6.17157 21.5 4.75736 21.5 3.87868 20.6213C3 19.7426 3 18.3284 3 15.5V8.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 8.49833V4.1103C15 3.22096 14.279 2.5 13.3897 2.5C13.1336 2.5 12.8812 2.56108 12.6534 2.67818L3.7623 7.24927C3.29424 7.48991 3 7.97203 3 8.49833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 15.5C17.7761 15.5 18 15.2761 18 15C18 14.7239 17.7761 14.5 17.5 14.5M17.5 15.5C17.2239 15.5 17 15.2761 17 15C17 14.7239 17.2239 14.5 17.5 14.5M17.5 15.5V14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  info: (
    <g transform="scale(1.5) translate(-4.5, -4.5)">
      <path
        d="M12.5 16.5V12.1C12.5 11.5815 12.5 11.3222 12.3536 11.1611C12.2071 11 11.9714 11 11.5 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H12.0001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
  infoFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12ZM11.6819 11.0273C11.9289 11.0605 12.2707 11.1494 12.5607 11.4394C12.8507 11.7294 12.9396 12.0711 12.9728 12.3182C13.0003 12.5228 13.0001 12.7608 13 12.9606L13 13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11L11.0394 11C11.2393 10.9999 11.4772 10.9997 11.6819 11.0273ZM11.9954 7C11.4456 7 10.9999 7.44772 10.9999 8C10.9999 8.55228 11.4456 9 11.9954 9H12.0044C12.5542 9 12.9999 8.55228 12.9999 8C12.9999 7.44772 12.5542 7 12.0044 7H11.9954Z"
      fill="currentColor"
    />
  ),
  like: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.68 3.75C4.68264 3.75 2.75 6.21012 2.75 9.24837C2.75 11.8983 3.96439 14.0754 5.78988 15.9019C7.53571 17.6488 9.80694 19.0387 12 20.1583C14.1931 19.0387 16.4643 17.6488 18.2101 15.9019C20.0356 14.0754 21.25 11.8983 21.25 9.24837C21.25 6.21012 19.3173 3.75 16.32 3.75C14.6727 3.75 13.5253 4.56277 12.624 5.91466C12.4849 6.1233 12.2508 6.24863 12 6.24863C11.7492 6.24863 11.5151 6.1233 11.376 5.91466C10.4747 4.56277 9.32729 3.75 7.68 3.75ZM1.25 9.24837C1.25 5.60802 3.6447 2.25 7.68 2.25C9.55818 2.25 10.9526 3.0547 12 4.26046C13.0474 3.0547 14.4418 2.25 16.32 2.25C20.3553 2.25 22.75 5.60802 22.75 9.24837C22.75 12.41 21.2852 14.9471 19.2711 16.9623C17.2665 18.968 14.6821 20.4956 12.3355 21.6694C12.1243 21.775 11.8757 21.775 11.6645 21.6694C9.31793 20.4956 6.73346 18.968 4.72892 16.9623C2.71481 14.9471 1.25 12.41 1.25 9.24837Z"
      fill="currentColor"
    />
  ),
  likeFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8.99837C1 5.35802 3.3947 2 7.43 2C9.30819 2 10.7026 2.80471 11.75 4.01046C12.7974 2.80471 14.1918 2 16.07 2C20.1053 2 22.5 5.35802 22.5 8.99837C22.5 12.16 21.0352 14.697 19.0211 16.7123C17.0165 18.718 14.4321 20.2456 12.0855 21.4194C11.8743 21.525 11.6257 21.525 11.4145 21.4194C9.06793 20.2456 6.48346 18.718 4.47892 16.7123C2.46481 14.697 1 12.16 1 8.99837Z"
      fill="currentColor"
    />
  ),
  link: (
    <>
      <path
        d="M17 7L6 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 6.13151C11 6.13151 16.6335 5.65662 17.4885 6.51153C18.3434 7.36645 17.8684 13 17.8684 13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  list: (
    <>
      <path
        d="M8 5H20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4 5H4.00898"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H4.00898"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 19H4.00898"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12H20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8 19H20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  loading: (
    <path
      d="M15.1667 0.999756L15.7646 2.11753C16.1689 2.87322 16.371 3.25107 16.2374 3.41289C16.1037 3.57471 15.6635 3.44402 14.7831 3.18264C13.9029 2.92131 12.9684 2.78071 12 2.78071C6.75329 2.78071 2.5 6.90822 2.5 11.9998C2.5 13.6789 2.96262 15.2533 3.77093 16.6093M8.83333 22.9998L8.23536 21.882C7.83108 21.1263 7.62894 20.7484 7.7626 20.5866C7.89627 20.4248 8.33649 20.5555 9.21689 20.8169C10.0971 21.0782 11.0316 21.2188 12 21.2188C17.2467 21.2188 21.5 17.0913 21.5 11.9998C21.5 10.3206 21.0374 8.74623 20.2291 7.39023"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  // loading: (
  //   <path
  //     d="M5.16725 15.6269C4.86475 15.0641 4.63625 14.483 4.48175 13.8837C4.32725 13.2842 4.25 12.6729 4.25 12.0499C4.25 9.88711 5.00258 8.04644 6.50775 6.52794C8.01292 5.00928 9.84367 4.24994 12 4.24994H12.7808L10.9308 2.39994L11.9845 1.34619L15.6385 4.99994L11.9845 8.65369L10.9308 7.59994L12.7808 5.74994H12C10.2628 5.74994 8.78683 6.36144 7.572 7.58444C6.35733 8.80761 5.75 10.2961 5.75 12.0499C5.75 12.4641 5.79517 12.8779 5.8855 13.2912C5.976 13.7047 6.11158 14.1083 6.29225 14.5019L5.16725 15.6269ZM12.0155 22.6537L8.3615 18.9999L12.0155 15.3462L13.0693 16.3999L11.2192 18.2499H12C13.7372 18.2499 15.2132 17.6384 16.428 16.4154C17.6427 15.1923 18.25 13.7038 18.25 11.9499C18.25 11.5358 18.2048 11.122 18.1145 10.7087C18.024 10.2952 17.8884 9.89161 17.7078 9.49794L18.8328 8.37294C19.1353 8.93578 19.3637 9.51686 19.5182 10.1162C19.6727 10.7157 19.75 11.3269 19.75 11.9499C19.75 14.1128 18.9974 15.9534 17.4923 17.4719C15.9871 18.9906 14.1563 19.7499 12 19.7499H11.2192L13.0693 21.5999L12.0155 22.6537Z"
  //     fill="currentColor"
  //   />
  // ),
  // locationFilled: (
  //   <path
  //     fillRule="evenodd"
  //     clipRule="evenodd"
  //     d="M12 1.25C6.92757 1.25 2.75 5.16834 2.75 10.0807C2.75 12.7883 4.07718 14.7869 5.67363 16.4901C6.35837 17.2207 7.11246 17.9172 7.84456 18.5933L7.84539 18.5941C7.96133 18.7011 8.07671 18.8077 8.19117 18.9138C9.03952 19.7002 9.84562 20.4686 10.5352 21.2887C11.2845 22.1797 12.7108 22.2095 13.4858 21.3227C14.1933 20.5133 15.0081 19.7427 15.8592 18.9472L16.0149 18.8017C16.8086 18.0603 17.6288 17.2941 18.3679 16.4856C19.948 14.757 21.25 12.7371 21.25 10.0807C21.25 5.16834 17.0724 1.25 12 1.25ZM12 6.5C9.79086 6.5 8 8.29086 8 10.5C8 12.7091 9.79086 14.5 12 14.5C14.2091 14.5 16 12.7091 16 10.5C16 8.29086 14.2091 6.5 12 6.5Z"
  //     fill="currentColor"
  //   />
  // ),
  // lockFilled: (
  //   <path
  //     d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
  //     fill="currentColor"
  //   />
  // ),
  lockFilled: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.25C10.067 3.25 8.5 4.817 8.5 6.75V8.31016C9.61773 8.27048 10.7654 8.25 12 8.25C13.2346 8.25 14.3823 8.27048 15.5 8.31016V6.75C15.5 4.817 13.933 3.25 12 3.25ZM6.5 6.75V8.52712C4.93233 9.00686 3.74925 10.3861 3.52452 12.0552C3.37636 13.1556 3.25 14.3118 3.25 15.5C3.25 16.6882 3.37636 17.8444 3.52452 18.9448C3.79609 20.9618 5.46716 22.5555 7.52522 22.6501C8.95364 22.7158 10.4042 22.75 12 22.75C13.5958 22.75 15.0464 22.7158 16.4748 22.6501C18.5328 22.5555 20.2039 20.9618 20.4755 18.9448C20.6236 17.8444 20.75 16.6882 20.75 15.5C20.75 14.3118 20.6236 13.1556 20.4755 12.0552C20.2508 10.3861 19.0677 9.00686 17.5 8.52712V6.75C17.5 3.71243 15.0376 1.25 12 1.25C8.96243 1.25 6.5 3.71243 6.5 6.75ZM17 15.4902C17 14.9379 16.5523 14.4902 16 14.4902C15.4477 14.4902 15 14.9379 15 15.4902V15.5002C15 16.0525 15.4477 16.5002 16 16.5002C16.5523 16.5002 17 16.0525 17 15.5002V15.4902ZM12 14.4902C12.5523 14.4902 13 14.9379 13 15.4902V15.5002C13 16.0525 12.5523 16.5002 12 16.5002C11.4477 16.5002 11 16.0525 11 15.5002V15.4902C11 14.9379 11.4477 14.4902 12 14.4902ZM9 15.4902C9 14.9379 8.55228 14.4902 8 14.4902C7.44772 14.4902 7 14.9379 7 15.4902V15.5002C7 16.0525 7.44772 16.5002 8 16.5002C8.55228 16.5002 9 16.0525 9 15.5002V15.4902Z"
      fill="currentColor"
    />
  ),
  logOut: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6708 2.66463C10.8561 3.03512 10.7059 3.48562 10.3354 3.67086L5.44098 6.11807C5.44098 6.11807 5.44099 6.11807 5.44098 6.11807C5.0175 6.32982 4.75 6.76264 4.75 7.23611V16.7639C4.75 17.2375 5.01749 17.6703 5.44098 17.882C5.44098 17.882 5.44097 17.882 5.44098 17.882L10.3354 20.3292C10.7059 20.5145 10.8561 20.965 10.6708 21.3355C10.4856 21.7059 10.0351 21.8561 9.66459 21.6709L4.77016 19.2237C3.83851 18.7578 3.25 17.8056 3.25 16.7639V7.23611C3.25 6.19448 3.8385 5.24227 4.77016 4.77643L9.66459 2.32922C10.0351 2.14398 10.4856 2.29415 10.6708 2.66463Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9697 8.96967C17.2626 8.67678 17.7374 8.67678 18.0303 8.96967L20.5303 11.4697C20.8232 11.7626 20.8232 12.2374 20.5303 12.5303L18.0303 15.0303C17.7374 15.3232 17.2626 15.3232 16.9697 15.0303C16.6768 14.7374 16.6768 14.2626 16.9697 13.9697L18.1893 12.75H10C9.58579 12.75 9.25 12.4142 9.25 12C9.25 11.5858 9.58579 11.25 10 11.25H18.1893L16.9697 10.0303C16.6768 9.73744 16.6768 9.26256 16.9697 8.96967Z"
        fill="currentColor"
      />
    </>
  ),
  map: (
    <>
      <path
        d="M5.25345 4.19584L4.02558 4.90813C3.03739 5.48137 2.54329 5.768 2.27164 6.24483C2 6.72165 2 7.30233 2 8.46368V16.6283C2 18.1542 2 18.9172 2.34226 19.3418C2.57001 19.6244 2.88916 19.8143 3.242 19.8773C3.77226 19.9719 4.42148 19.5953 5.71987 18.8421C6.60156 18.3306 7.45011 17.7994 8.50487 17.9435C8.98466 18.009 9.44231 18.2366 10.3576 18.6917L14.1715 20.588C14.9964 20.9982 15.004 21 15.9214 21H18C19.8856 21 20.8284 21 21.4142 20.4013C22 19.8026 22 18.8389 22 16.9117V10.1715C22 8.24423 22 7.2806 21.4142 6.68188C20.8284 6.08316 19.8856 6.08316 18 6.08316H15.9214C15.004 6.08316 14.9964 6.08139 14.1715 5.6712L10.8399 4.01463C9.44884 3.32297 8.75332 2.97714 8.01238 3.00117C7.27143 3.02521 6.59877 3.41542 5.25345 4.19584Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3L8 17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 6.5L15 20.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  mask: (
    <>
      <path
        d="M12 5C15.0776 5 17.8526 4.27588 19.8097 3.11579C19.9349 3.04155 20.0772 3 20.2228 3C20.652 3 21 3.34797 21 3.77722V10C21 17 16.5 22 12 22C7.5 22 3 17 3 10V3.77722C3 3.34797 3.34797 3 3.77722 3C3.92281 3 4.06506 3.04155 4.1903 3.11579C6.14736 4.27588 8.92241 5 12 5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M6.5 10C6.86849 9.69313 7.40399 9.5 8 9.5C8.59601 9.5 9.13151 9.69313 9.5 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M12 15.7C13.192 15.7 14.263 15.4296 15 15C15 15 14.5 18 12 18C9.5 18 9 15 9 15C9.73698 15.4296 10.808 15.7 12 15.7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M14.5 10C14.8685 9.69313 15.404 9.5 16 9.5C16.596 9.5 17.1315 9.69313 17.5 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  menu: (
    <g transform="scale(-1, 1) translate(-24, 0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6H4V4H16V6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 13H4V11H20V13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20H4V18H12V20Z"
        fill="currentColor"
      />
    </g>
  ),
  // usersFilled: (
  //   <>
  //     <path
  //       d="M13.5647 15.2196C14.1348 15.5279 15.0292 16.0115 15.6409 16.586C16.0219 16.9438 16.4159 17.4431 16.4883 18.0781C16.5665 18.7652 16.2485 19.3855 15.6772 19.9077C14.7182 20.7843 13.5522 21.4999 12.0399 21.4999H4.96015C3.44779 21.4999 2.28177 20.7843 1.3228 19.9077C0.751481 19.3855 0.433458 18.7652 0.511739 18.0781C0.584083 17.4431 0.978131 16.9438 1.35906 16.586C1.97085 16.0115 2.86511 15.5279 3.43523 15.2196C3.56216 15.151 3.67304 15.091 3.76114 15.0407C6.66339 13.3827 10.3366 13.3827 13.2389 15.0407C13.3269 15.091 13.4378 15.151 13.5647 15.2196Z"
  //       fill="currentColor"
  //     />
  //     <path
  //       d="M3.59668 7.37838C3.59668 4.68412 5.79187 2.5 8.49977 2.5C11.2077 2.5 13.4029 4.68412 13.4029 7.37838C13.4029 10.0726 11.2077 12.2568 8.49977 12.2568C5.79187 12.2568 3.59668 10.0726 3.59668 7.37838Z"
  //       fill="currentColor"
  //     />
  //     <path
  //       d="M13.7776 10.9656C13.572 11.2407 13.4692 11.3783 13.5081 11.5144C13.5471 11.6506 13.6841 11.7128 13.9581 11.8373C14.5282 12.0963 15.1712 12.2419 15.8515 12.2419C18.1982 12.2419 20.1005 10.5088 20.1005 8.37097C20.1005 6.23309 18.1982 4.5 15.8515 4.5C15.5956 4.5 15.345 4.52061 15.1016 4.56011C14.8001 4.60902 14.6494 4.63347 14.5698 4.75422C14.4902 4.87497 14.5465 5.03357 14.6592 5.35075C14.8816 5.97695 15.0017 6.64504 15.0017 7.33871C15.0017 8.68342 14.5502 9.93204 13.7776 10.9656Z"
  //       fill="currentColor"
  //     />
  //     <path
  //       d="M18.893 20.5C20.4249 20.5 21.6164 19.9038 22.6072 19.1596C23.1944 18.7186 23.5791 18.1506 23.4862 17.4806C23.4027 16.8788 22.9563 16.4309 22.5711 16.1336C21.94 15.6466 21.0193 15.2377 20.4392 14.98C20.3111 14.9231 20.1996 14.8735 20.1114 14.8322C18.981 14.3015 17.7373 13.9735 16.4669 13.8483C15.6476 13.7676 15.238 13.7272 15.1443 13.9501C15.0507 14.173 15.4155 14.4118 16.1451 14.8893C16.4221 15.0707 16.6902 15.265 16.9254 15.4673C17.4549 15.9226 18.2313 16.7422 18.3777 17.9186C18.4456 18.4638 18.367 18.9661 18.1903 19.4199C17.9799 19.9603 17.8747 20.2305 17.9657 20.3586C17.9715 20.3668 17.9751 20.3713 17.9816 20.3791C18.0837 20.5 18.3534 20.5 18.893 20.5Z"
  //       fill="currentColor"
  //     />
  //   </>
  // ),
  // verifiedFilled: (
  //   <path
  //     d="M8.6 22.5L6.7 19.3L3.1 18.5L3.45 14.8L1 12L3.45 9.2L3.1 5.5L6.7 4.7L8.6 1.5L12 2.95L15.4 1.5L17.3 4.7L20.9 5.5L20.55 9.2L23 12L20.55 14.8L20.9 18.5L17.3 19.3L15.4 22.5L12 21.05L8.6 22.5ZM10.95 15.55L16.6 9.9L15.2 8.45L10.95 12.7L8.8 10.6L7.4 12L10.95 15.55Z"
  //     fill="currentColor"
  //   />
  // ),
  // voiceFilled: (
  //   <path
  //     fillRule="evenodd"
  //     clipRule="evenodd"
  //     d="M17.312 1.93059C15.9686 1.74998 14.2479 1.74999 12.0572 1.75H11.9428C9.75212 1.74999 8.03144 1.74998 6.68802 1.93059C5.31137 2.11568 4.21911 2.50272 3.36091 3.36091C2.50272 4.21911 2.11568 5.31137 1.93059 6.68802C1.74998 8.03144 1.74999 9.75212 1.75 11.9428V12.0572C1.74999 14.2479 1.74998 15.9686 1.93059 17.312C2.11568 18.6886 2.50272 19.7809 3.36091 20.6391C4.21911 21.4973 5.31137 21.8843 6.68802 22.0694C8.03144 22.25 9.7521 22.25 11.9428 22.25H12.0572C14.2479 22.25 15.9686 22.25 17.312 22.0694C18.6886 21.8843 19.7809 21.4973 20.6391 20.6391C21.4973 19.7809 21.8843 18.6886 22.0694 17.312C22.25 15.9686 22.25 14.2479 22.25 12.0572V11.9428C22.25 9.7521 22.25 8.03144 22.0694 6.68802C21.8843 5.31137 21.4973 4.21911 20.6391 3.36091C19.7809 2.50272 18.6886 2.11568 17.312 1.93059ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V8ZM9.75 10C9.75 9.58579 9.41421 9.25 9 9.25C8.58579 9.25 8.25 9.58579 8.25 10V14C8.25 14.4142 8.58579 14.75 9 14.75C9.41421 14.75 9.75 14.4142 9.75 14V10ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10V14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14V10ZM6.75 11C6.75 10.5858 6.41421 10.25 6 10.25C5.58579 10.25 5.25 10.5858 5.25 11V13C5.25 13.4142 5.58579 13.75 6 13.75C6.41421 13.75 6.75 13.4142 6.75 13V11ZM18.75 11C18.75 10.5858 18.4142 10.25 18 10.25C17.5858 10.25 17.25 10.5858 17.25 11V13C17.25 13.4142 17.5858 13.75 18 13.75C18.4142 13.75 18.75 13.4142 18.75 13V11Z"
  //     fill="currentColor"
  //   />
  // ),
  // whatsappFilled: (
  //   <>
  //     <g clipPath="url(#clip0_13_21984)">
  //       <path
  //         d="M12.0006 2C6.48622 2 2 6.48619 2 12.0008C2 14.1202 2.65838 16.1472 3.9038 17.863C3.96806 17.9514 3.98541 18.0661 3.95071 18.1697L2.87205 21.3778L6.21342 20.3072C6.24651 20.2965 6.28057 20.2914 6.31463 20.2914C6.3789 20.2914 6.44284 20.3101 6.49778 20.3464C8.13328 21.4283 10.0361 22.0003 12.0006 22.0003C17.5144 22.0003 22 17.5148 22 12.0011C22 6.48619 17.5141 2 12.0006 2ZM17.4177 15.7368C17.151 16.4838 15.9785 17.0963 15.4452 17.1439L15.3668 17.1513C15.2434 17.1637 15.1036 17.1773 14.9288 17.1773C14.513 17.1773 13.7817 17.1054 12.2375 16.4834C10.6334 15.8376 9.05096 14.4525 7.78176 12.5839C7.75991 12.5515 7.74481 12.5288 7.73646 12.5178C7.40486 12.0773 6.63306 10.9196 6.63306 9.69325C6.63306 8.33055 7.28019 7.55608 7.66255 7.31282C8.02307 7.08381 8.83889 6.9753 8.98863 6.96915C9.11169 6.96396 9.08245 6.96396 9.11169 6.96396C9.42787 6.96396 9.65536 7.15734 9.82726 7.5726C9.89891 7.74459 10.5721 9.38295 10.61 9.45907C10.6559 9.54976 10.798 9.83124 10.6315 10.1645L10.5958 10.2368C10.5277 10.3761 10.4689 10.4962 10.3369 10.6514C10.2945 10.7009 10.2514 10.7531 10.2083 10.8056C10.1174 10.916 10.0233 11.0304 9.93619 11.1169C9.90663 11.147 9.84911 11.205 9.84268 11.228C9.84268 11.228 9.84397 11.2477 9.86935 11.2914C10.0474 11.5953 11.3458 13.3966 13.0565 14.1458C13.1314 14.1785 13.3781 14.2808 13.3923 14.2808C13.4083 14.2808 13.4347 14.2539 13.4543 14.2316C13.6034 14.0619 14.0853 13.4937 14.2447 13.255C14.3858 13.0425 14.5664 12.9343 14.782 12.9343C14.9137 12.9343 15.0377 12.9751 15.1534 13.0169C15.4368 13.1196 17.0315 13.9112 17.0739 13.932C17.2828 14.033 17.4476 14.113 17.5433 14.2714C17.6831 14.5047 17.6279 15.1476 17.4177 15.7362V15.7368Z"
  //         fill="currentColor"
  //       />
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_13_21984">
  //         <rect
  //           width="20"
  //           height="20"
  //           fill="currentColor"
  //           transform="translate(2 2)"
  //         />
  //       </clipPath>
  //     </defs>
  //   </>
  // ),
  // playCircleFilled: (
  //   <path
  //     d="M9.5 16.5L16.5 12L9.5 7.5V16.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
  //     fill="currentColor"
  //   />
  // ),
  microphone: (
    <>
      <path
        d="M17 7V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M20 11C20 15.4183 16.4183 19 12 19M12 19C7.58172 19 4 15.4183 4 11M12 19V22M12 22H15M12 22H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  microphoneFilled: (
    <>
      <path
        d="M6.25 6.75C6.25 3.57436 8.82436 1 12 1C15.1756 1 17.75 3.57436 17.75 6.75V10.75C17.75 13.9256 15.1756 16.5 12 16.5C8.82436 16.5 6.25 13.9256 6.25 10.75V6.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 19.6951C6.50005 19.1976 3 15.3826 3 10.75H5C5 14.616 8.13401 17.75 12 17.75C15.866 17.75 19 14.616 19 10.75H21C21 15.3826 17.5 19.1976 13 19.6951V21H15V23H9V21H11V19.6951Z"
        fill="currentColor"
      />
    </>
  ),
  microphoneOff: (
    <>
      <path
        d="M7 7V11C7 13.7614 9.23858 16 12 16C13.1257 16 14.1645 15.628 15.0002 15.0002M8 3.99951C8.91223 2.78534 10.3644 2 12 2C14.7614 2 17 4.23858 17 7V11C17 11.5977 16.8951 12.1709 16.7028 12.7023"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 11C20 12.4571 19.6807 13.8233 19 15M12 19C7.58172 19 4 15.4183 4 11M12 19V22M12 19C13.8919 19 15.6304 18.3433 17 17.2454M12 22H14.5M12 22H9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 2L22 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  microphoneOffFilled: (
    <>
      <path
        d="M21.3358 22.7505L1.25 2.6647L2.66421 1.25049L22.75 21.3363L21.3358 22.7505Z"
        fill="currentColor"
      />
      <path
        d="M6.24756 6.74995V10.7499C6.24756 13.9255 8.82192 16.4999 11.9976 16.4999C13.2667 16.4999 14.4398 16.0887 15.391 15.3923L6.2674 6.2688C6.25426 6.42744 6.24756 6.58791 6.24756 6.74995Z"
        fill="currentColor"
      />
      <path
        d="M17.7474 10.75V6.75C17.7474 3.57436 15.173 1 11.9974 1C9.9711 1 8.18965 2.04807 7.16553 3.63166L17.0432 13.5094C17.4921 12.6902 17.7474 11.7499 17.7474 10.75Z"
        fill="currentColor"
      />
      <path
        d="M2.99756 10.75C2.99756 15.3826 6.49761 19.1976 10.9976 19.6951V21H8.99756V23H14.9976V21H12.9976V19.6951C14.7744 19.4987 16.3954 18.785 17.7065 17.7079L16.2835 16.2849C15.0992 17.2033 13.6122 17.75 11.9976 17.75C8.13157 17.75 4.99756 14.616 4.99756 10.75H2.99756Z"
        fill="currentColor"
      />
      <path
        d="M20.9977 10.75H18.9977C18.9977 12.0972 18.6171 13.3556 17.9575 14.4234L19.4019 15.8678C20.4081 14.4147 20.9977 12.6512 20.9977 10.75Z"
        fill="currentColor"
      />
    </>
  ),
  moneyJar: (
    <>
      <path
        d="M19.5 16V12.0059C19.5 10.5195 19.5 9.77627 19.2444 9.09603C18.9888 8.4158 18.4994 7.85648 17.5206 6.73784L16 5H8L6.47939 6.73784C5.50058 7.85648 5.01118 8.4158 4.75559 9.09603C4.5 9.77627 4.5 10.5195 4.5 12.0059V16C4.5 18.8284 4.5 20.2426 5.37868 21.1213C6.25736 22 7.67157 22 10.5 22H13.5C16.3284 22 17.7426 22 18.6213 21.1213C19.5 20.2426 19.5 18.8284 19.5 16Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 15.6831C9.5 16.9125 11.3539 17.9204 13.1325 17.3553C14.9112 16.7901 14.6497 15.1248 14.0463 14.4708C13.4429 13.8169 12.555 13.9265 11.5399 13.8751C9.25873 13.7594 9.09769 11.5722 10.9447 10.7069C12.2997 10.072 14.0379 10.8862 14.2381 12M11.971 9.5V10.4777M11.971 17.7204V18.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 2H16.5C16.9659 2 17.1989 2 17.3827 2.07612C17.6277 2.17761 17.8224 2.37229 17.9239 2.61732C18 2.80109 18 3.03406 18 3.5C18 3.96594 18 4.19891 17.9239 4.38268C17.8224 4.62771 17.6277 4.82239 17.3827 4.92388C17.1989 5 16.9659 5 16.5 5H7.5C7.03406 5 6.80109 5 6.61732 4.92388C6.37229 4.82239 6.17761 4.62771 6.07612 4.38268C6 4.19891 6 3.96594 6 3.5C6 3.03406 6 2.80109 6.07612 2.61732C6.17761 2.37229 6.37229 2.17761 6.61732 2.07612C6.80109 2 7.03406 2 7.5 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  mortgage: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 9C6.25 4.71979 9.71979 1.25 14 1.25C18.2802 1.25 21.75 4.7198 21.75 9C21.75 10.6455 21.2363 12.1735 20.3604 13.4291C20.1234 13.7688 19.6559 13.8521 19.3162 13.6151C18.9765 13.3781 18.8932 12.9106 19.1302 12.5709C19.8361 11.5589 20.25 10.3289 20.25 9C20.25 5.54822 17.4518 2.75 14 2.75C10.5482 2.75 7.75 5.54821 7.75 9C7.75 9.95993 7.96589 10.8673 8.35108 11.6782C8.52881 12.0523 8.36958 12.4997 7.99544 12.6775C7.62129 12.8552 7.17391 12.696 6.99618 12.3218C6.51749 11.3141 6.25 10.1873 6.25 9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0473 6.25C13.323 6.25 12.5192 7.00235 12.5192 8.22222V8.25H14.2692C14.6834 8.25 15.0192 8.58579 15.0192 9C15.0192 9.41421 14.6834 9.75 14.2692 9.75H12.5192V9.77778C12.5192 10.9976 13.323 11.75 14.0473 11.75C14.5342 11.75 15.0305 11.4377 15.3303 10.8431C15.5168 10.4732 15.9678 10.3245 16.3376 10.511C16.7075 10.6975 16.8562 11.1485 16.6697 11.5183C16.1723 12.5049 15.2178 13.25 14.0473 13.25C12.2554 13.25 11.0192 11.5648 11.0192 9.77778V9.75H10.5C10.0858 9.75 9.75 9.41421 9.75 9C9.75 8.58579 10.0858 8.25 10.5 8.25H11.0192V8.22222C11.0192 6.43521 12.2554 4.75 14.0473 4.75C15.2178 4.75 16.1723 5.49516 16.6697 6.48161C16.8562 6.85146 16.7075 7.30247 16.3377 7.48896C15.9678 7.67545 15.5168 7.52679 15.3303 7.15694C15.0305 6.5623 14.5342 6.25 14.0473 6.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.2502 14C2.2502 13.5858 2.58598 13.25 3.0002 13.25H5.39502C5.80159 13.25 6.20345 13.3416 6.56902 13.5185C6.56903 13.5185 6.56902 13.5185 6.56902 13.5185L8.611 14.5065C8.77145 14.5841 8.94981 14.6251 9.1317 14.6251H10.1743C11.0117 14.6251 11.7694 15.0205 12.2428 15.6409L16.3699 14.3729C16.3704 14.3727 16.3709 14.3725 16.3714 14.3724C17.5019 14.0208 18.7125 14.4437 19.4053 15.4032C20.0269 16.2639 19.7865 17.5054 18.8536 18.0438L11.3379 22.3801C10.6829 22.758 9.90646 22.8516 9.18202 22.6366L2.78684 20.7389C2.38974 20.6211 2.16335 20.2036 2.28118 19.8065C2.39902 19.4094 2.81646 19.1831 3.21356 19.3009L9.60869 21.1986C9.6087 21.1986 9.60868 21.1986 9.60869 21.1986C9.9358 21.2956 10.2873 21.2546 10.5883 21.0809L18.1038 16.7446C18.1039 16.7446 18.1038 16.7446 18.1038 16.7446C18.2452 16.663 18.3052 16.442 18.1893 16.2814C17.8625 15.8288 17.3136 15.6499 16.8161 15.8049L16.8133 15.8058L12.7487 17.0546C12.7497 17.0836 12.7502 17.1127 12.7502 17.142C12.7502 17.5324 12.4847 17.8528 12.1339 17.9498C12.1337 17.9498 12.1341 17.9497 12.1339 17.9498L9.59295 18.6524C8.96248 18.8267 8.28718 18.7664 7.69856 18.4815C7.69853 18.4815 7.69859 18.4815 7.69856 18.4815L5.51567 17.4254C5.1428 17.245 4.98677 16.7965 5.16717 16.4237C5.34757 16.0508 5.79608 15.8948 6.16894 16.0752L8.35183 17.1313C8.61117 17.2568 8.9121 17.2843 9.19318 17.2066C9.1932 17.2066 9.19317 17.2066 9.19318 17.2066L11.1274 16.6718C10.9513 16.3532 10.6008 16.1251 10.1743 16.1251H9.1317C8.72529 16.1251 8.32342 16.0337 7.95769 15.8567C7.95769 15.8567 7.95769 15.8567 7.95769 15.8567L5.91571 14.8687C5.75511 14.791 5.57674 14.75 5.39502 14.75H3.0002C2.58598 14.75 2.2502 14.4142 2.2502 14Z"
        fill="currentColor"
      />
    </>
  ),
  mortgageFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0656 13.7418C11.0867 13.7418 11.9357 14.2489 12.4724 14.99L16.9868 13.4339C18.0482 13.0641 19.1282 13.3247 19.9298 13.9903C21.0656 12.642 21.75 10.9009 21.75 9C21.75 4.71979 18.2802 1.25 14 1.25C9.7198 1.25 6.25 4.71979 6.25 9C6.25 10.4946 6.67311 11.8904 7.40609 13.0741L8.40513 13.6164C8.56107 13.7011 8.72611 13.7418 8.8884 13.7418H10.0656ZM14.0473 3.75C12.2554 3.75 11.0192 5.43523 11.0192 7.22222V7.25H10.5C10.0858 7.25 9.75 7.58579 9.75 8C9.75 8.41421 10.0858 8.75 10.5 8.75H11.0192V8.77778C11.0192 10.5647 12.2554 12.25 14.0473 12.25C15.2178 12.25 16.1723 11.5048 16.6697 10.5184C16.8562 10.1485 16.7075 9.69755 16.3377 9.51105C15.9678 9.32455 15.5168 9.47319 15.3303 9.84304C15.0305 10.4377 14.5342 10.75 14.0473 10.75C13.323 10.75 12.5192 9.99767 12.5192 8.77778V8.75H14.2692C14.6834 8.75 15.0192 8.41421 15.0192 8C15.0192 7.58579 14.6834 7.25 14.2692 7.25H12.5192V7.22222C12.5192 6.00234 13.323 5.25 14.0473 5.25C14.5342 5.25 15.0305 5.56227 15.3303 6.15696C15.5168 6.52681 15.9678 6.67545 16.3377 6.48895C16.7075 6.30245 16.8562 5.85144 16.6697 5.48159C16.1723 4.49518 15.2178 3.75 14.0473 3.75Z"
        fill="currentColor"
      />
      <path
        d="M12.8249 16.1907L17.3963 14.615C18.1964 14.3353 19.0654 14.6648 19.5723 15.4523C19.8935 15.9513 19.7579 16.6621 19.3003 16.9583L10.815 22.4511C10.3419 22.7573 9.78523 22.8315 9.26637 22.6587L2.93218 20.55C2.52365 20.414 2.24805 20.0318 2.24805 19.6012V14.25C2.24805 13.6977 2.69576 13.25 3.24805 13.25H4.6696C4.95941 13.25 5.24489 13.3233 5.50335 13.4636L7.80879 14.715C8.14441 14.8972 8.51401 14.9918 8.8884 14.9918H10.0656C11.0079 14.9918 11.7662 15.7777 11.839 16.7584V16.8919L9.10967 17.7385C8.66466 17.8766 8.18821 17.8317 7.76802 17.6083L5.43804 16.1286C5.20493 15.9805 4.89595 16.0495 4.74791 16.2826C4.59987 16.5157 4.66883 16.8247 4.90193 16.9727L7.24724 18.4622C7.25688 18.4683 7.26672 18.4741 7.27675 18.4795C7.93444 18.8365 8.69524 18.9141 9.40594 18.6936L12.2747 17.8038C12.6656 17.6826 12.9084 17.3089 12.9084 16.9134C12.9084 16.6871 12.8855 16.4663 12.8419 16.2534C12.8375 16.2319 12.8318 16.211 12.8249 16.1907Z"
        fill="currentColor"
      />
    </>
  ),
  // notes: (
  //   <>
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M16 6H4V4H16V6Z"
  //       fill="currentColor"
  //     />
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M20 13H4V11H20V13Z"
  //       fill="currentColor"
  //     />
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M12 20H4V18H12V20Z"
  //       fill="currentColor"
  //     />
  //   </>
  // ),
  neighbourhood: (
    <>
      <path
        d="M21 22V7.4849C21 6.38738 21 5.83862 20.6845 5.37551C20.3689 4.9124 19.7876 4.608 18.6251 3.99921L17.1459 3.22461C15.3209 2.26893 14.4084 1.7911 13.7042 2.08712C13 2.38315 13 3.24459 13 4.96746V9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M22 22H2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 8H19M21 11H19M21 14H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 13C8 11.1144 8 10.1716 8.58579 9.58579C9.17157 9 10.1144 9 12 9C13.8856 9 14.8284 9 15.4142 9.58579C16 10.1716 16 11.1144 16 13V22H8V13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 13H12.5M11.5 16H12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <ellipse
        cx="3.5"
        cy="14"
        rx="1.5"
        ry="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3.5 16V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  objectEnergyLabel: (
    <path
      d="M6.19351 11.3965L12.192 3.31186C12.6611 2.67957 13.5405 3.07311 13.5405 3.91536V10.1729C13.5405 10.6775 13.8853 11.0865 14.3107 11.0865H17.2283C17.891 11.0865 18.2443 12.0134 17.8065 12.6035L11.808 20.6881C11.3389 21.3204 10.4595 20.9269 10.4595 20.0846V13.8271C10.4595 13.3225 10.1147 12.9135 9.68931 12.9135H6.77173C6.10895 12.9135 5.75566 11.9866 6.19351 11.3965Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  // --
  objectLivingAreaSize: (
    <>
      <path
        fill="currentColor"
        d="M21.27,7.83c-.48-.99-1.29-1.62-2.89-2.87l-1-.78c-2.49-1.94-3.74-2.92-5.37-2.92s-2.86.96-5.29,2.86h0s-1.08.84-1.08.84c-1.6,1.25-2.41,1.88-2.89,2.87-.48.99-.48,2.01-.48,4.06v2.09c0,3.99,0,5.99,1.39,7.38,1.39,1.4,3.39,1.4,7.36,1.4h2c3.97,0,5.97,0,7.36-1.4,1.39-1.4,1.39-3.4,1.39-7.38v-2.09c0-2.04,0-3.07-.48-4.06ZM20.25,13.97c0,3.57,0,5.37-.95,6.32-.95.96-2.74.96-6.3.96h-2c-3.56,0-5.35,0-6.3-.96-.95-.96-.95-2.75-.95-6.32v-2.09c0-1.81,0-2.72.33-3.4.33-.68,1.05-1.24,2.47-2.35l1.01-.79c4.43-3.46,4.45-3.46,8.89,0l1.01.78c1.42,1.11,2.13,1.67,2.46,2.34.33.68.33,1.59.33,3.4v2.09Z"
      />
      <rect
        fill="currentColor"
        x="14.25"
        y="15.75"
        width="3.53"
        height="3.53"
        rx=".77"
        ry=".77"
      />
    </>
  ),
  objectNumberOfBedrooms: (
    <>
      <path
        d="M22 17.5005H2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 21V16C22 14.1144 22 13.1716 21.4142 12.5858C20.8284 12 19.8856 12 18 12H6C4.11438 12 3.17157 12 2.58579 12.5858C2 13.1716 2 14.1144 2 16V21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 12V10.2134C11 9.83272 10.9428 9.70541 10.6497 9.55538C10.0395 9.24292 9.29865 9 8.5 9C7.70135 9 6.96055 9.24292 6.35025 9.55538C6.05721 9.70541 6 9.83272 6 10.2134V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18 12V10.2134C18 9.83272 17.9428 9.70541 17.6497 9.55538C17.0395 9.24292 16.2987 9 15.5 9C14.7013 9 13.9605 9.24292 13.3503 9.55538C13.0572 9.70541 13 9.83272 13 10.2134V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21 12V7.36057C21 6.66893 21 6.32311 20.8079 5.99653C20.6157 5.66995 20.342 5.50091 19.7944 5.16283C17.5869 3.79978 14.8993 3 12 3C9.10067 3 6.41314 3.79978 4.20558 5.16283C3.65804 5.50091 3.38427 5.66995 3.19213 5.99653C3 6.32311 3 6.66893 3 7.36057V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  objectPlotSize: (
    <>
      <path
        d="M2 12C2 7.75736 2 5.63604 3.17157 4.31802C4.34315 3 6.22876 3 10 3H14C17.7712 3 19.6569 3 20.8284 4.31802C22 5.63604 22 7.75736 22 12C22 16.2426 22 18.364 20.8284 19.682C19.6569 21 17.7712 21 14 21H10C6.22876 21 4.34315 21 3.17157 19.682C2 18.364 2 16.2426 2 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M2 9H10C12.8284 9 14.2426 9 15.1213 9.87868C16 10.7574 16 12.1716 16 15V21"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M10 21V9" stroke="currentColor" strokeWidth="1.5" />
    </>
  ),
  objectSquareMeterPrice: (
    <>
      <path
        d="M16.5148 16.5149C17.0896 15.9401 16.9941 13.4982 16.9941 13.4982M16.5148 16.5149C15.94 17.0897 13.4981 16.994 13.4981 16.994M16.5148 16.5149L13 13M7.48506 7.48512C8.05987 6.91031 10.5018 7.00596 10.5018 7.00596M7.48506 7.48512C6.91025 8.05993 7.00598 10.5018 7.00598 10.5018M7.48506 7.48512L11 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  people: (
    <>
      <path
        d="M13 11C13 8.79086 11.2091 7 9 7C6.79086 7 5 8.79086 5 11C5 13.2091 6.79086 15 9 15C11.2091 15 13 13.2091 13 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0386 7.55773C11.0131 7.37547 11 7.18927 11 7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C14.2554 11 13.5584 10.7966 12.9614 10.4423"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 21C15 17.6863 12.3137 15 9 15C5.68629 15 3 17.6863 3 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 17C21 13.6863 18.3137 11 15 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  peopleFilled: (
    <>
      <path
        d="M7.40343 14.4399C4.44608 15.1571 2.25 17.8221 2.25 21C2.25 21.4142 2.58579 21.75 3 21.75H15C15.4142 21.75 15.75 21.4142 15.75 21C15.75 17.8221 13.5539 15.1571 10.5966 14.4399C12.1526 13.8088 13.25 12.2825 13.25 10.5C13.25 8.15279 11.3472 6.25 9 6.25C6.65279 6.25 4.75 8.15279 4.75 10.5C4.75 12.2825 5.84739 13.8088 7.40343 14.4399Z"
        fill="currentColor"
      />
      <path
        d="M10.9854 5.10194C13.1827 5.91035 14.75 8.02214 14.75 10.5C14.75 11.8557 14.281 13.1008 13.4973 14.0829C14.8566 14.9683 15.9389 16.2433 16.5853 17.75H21C21.4143 17.75 21.75 17.4142 21.75 17C21.75 13.8221 19.554 11.1571 16.5966 10.4399C18.1526 9.80875 19.25 8.28253 19.25 6.5C19.25 4.15279 17.3473 2.25 15 2.25C13.1426 2.25 11.5635 3.44154 10.9854 5.10194Z"
        fill="currentColor"
      />
    </>
  ),
  percentSquare: (
    <>
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8 16L16 8M10 9C10 9.55228 9.55228 10 9 10C8.44772 10 8 9.55228 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9ZM16 14.8284C16 15.3807 15.5523 15.8284 15 15.8284C14.4477 15.8284 14 15.3807 14 14.8284C14 14.2761 14.4477 13.8284 15 13.8284C15.5523 13.8284 16 14.2761 16 14.8284Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  percentSquareFilled: (
    <>
      <path
        d="M12 1.75C14.2177 1.75 15.9565 1.74854 17.3115 1.93066C18.6882 2.11575 19.7804 2.50315 20.6387 3.36133C21.4968 4.21953 21.8843 5.31182 22.0693 6.68848C22.2515 8.04349 22.25 9.78227 22.25 12C22.25 14.2177 22.2515 15.9565 22.0693 17.3115C21.8843 18.6882 21.4968 19.7804 20.6387 20.6387C19.7804 21.4968 18.6882 21.8843 17.3115 22.0693C15.9565 22.2515 14.2177 22.25 12 22.25C9.78227 22.25 8.04349 22.2515 6.68848 22.0693C5.31182 21.8843 4.21953 21.4968 3.36133 20.6387C2.50315 19.7804 2.11575 18.6882 1.93066 17.3115C1.74854 15.9565 1.75 14.2177 1.75 12C1.75 9.78227 1.74854 8.0435 1.93066 6.68848C2.11575 5.31182 2.50313 4.21953 3.36133 3.36133C4.21953 2.50313 5.31182 2.11575 6.68848 1.93066C8.0435 1.74854 9.78227 1.75 12 1.75ZM16.5303 7.46973C16.2374 7.17683 15.7626 7.17683 15.4697 7.46973L7.46973 15.4697C7.17683 15.7626 7.17683 16.2374 7.46973 16.5303C7.76262 16.8232 8.23738 16.8232 8.53027 16.5303L16.5303 8.53027C16.8232 8.23738 16.8232 7.76262 16.5303 7.46973ZM15 13.0781C14.0336 13.0781 13.2501 13.8617 13.25 14.8281C13.25 15.7946 14.0335 16.5781 15 16.5781C15.9665 16.5781 16.75 15.7946 16.75 14.8281C16.7499 13.8617 15.9664 13.0781 15 13.0781ZM15 14.5781C15.138 14.5781 15.2499 14.6902 15.25 14.8281C15.25 14.9662 15.1381 15.0781 15 15.0781C14.8619 15.0781 14.75 14.9662 14.75 14.8281C14.7501 14.6902 14.862 14.5781 15 14.5781ZM9 7.25C8.03351 7.25 7.25 8.03351 7.25 9C7.25 9.96649 8.03351 10.75 9 10.75C9.96649 10.75 10.75 9.96649 10.75 9C10.75 8.03351 9.96649 7.25 9 7.25ZM9 8.75C9.13807 8.75 9.25 8.86193 9.25 9C9.25 9.13807 9.13807 9.25 9 9.25C8.86193 9.25 8.75 9.13807 8.75 9C8.75 8.86193 8.86193 8.75 9 8.75Z"
        fill="currentColor"
      />
    </>
  ),
  person: (
    <>
      <path
        d="M17 8.5C17 5.73858 14.7614 3.5 12 3.5C9.23858 3.5 7 5.73858 7 8.5C7 11.2614 9.23858 13.5 12 13.5C14.7614 13.5 17 11.2614 17 8.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 20.5C19 16.634 15.866 13.5 12 13.5C8.13401 13.5 5 16.634 5 20.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  personFilled: (
    <>
      <path
        d="M6.75 8C6.75 5.1005 9.1005 2.75 12 2.75C14.8995 2.75 17.25 5.1005 17.25 8C17.25 10.8995 14.8995 13.25 12 13.25C9.1005 13.25 6.75 10.8995 6.75 8Z"
        fill="currentColor"
      />
      <path
        d="M4.25 20.5C4.25 16.2198 7.71979 12.75 12 12.75C16.2802 12.75 19.75 16.2198 19.75 20.5C19.75 20.9142 19.4142 21.25 19 21.25H5C4.58579 21.25 4.25 20.9142 4.25 20.5Z"
        fill="currentColor"
      />
    </>
  ),
  pill: (
    <>
      <path
        d="M11 7H17M11 5V9C11 10.6569 12.3431 12 14 12C15.6569 12 17 10.6569 17 9V5C17 3.34315 15.6569 2 14 2C12.3431 2 11 3.34315 11 5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M4 14H6.39482C6.68897 14 6.97908 14.0663 7.24217 14.1936L9.28415 15.1816C9.54724 15.3089 9.83735 15.3751 10.1315 15.3751H11.1741C12.1825 15.3751 13 16.1662 13 17.142C13 17.1814 12.973 17.2161 12.9338 17.2269L10.3929 17.9295C9.93707 18.0555 9.449 18.0116 9.025 17.8064L6.84211 16.7503"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13 16.5L17.5928 15.0889C18.407 14.8352 19.2871 15.136 19.7971 15.8423C20.1659 16.3529 20.0157 17.0842 19.4785 17.3942L11.9629 21.7305C11.4849 22.0063 10.9209 22.0736 10.3952 21.9176L4 20.0199"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  pin: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.63869C6.92757 1.63869 2.75 5.55704 2.75 10.4694C2.75 13.177 4.07718 15.1756 5.67363 16.8788C6.35837 17.6094 7.11246 18.3059 7.84456 18.982L7.8446 18.982L7.84539 18.9828C7.96133 19.0898 8.07671 19.1964 8.19117 19.3025C9.03952 20.0889 9.84562 20.8573 10.5352 21.6774C11.2845 22.5684 12.7108 22.5982 13.4858 21.7114C14.1933 20.902 15.0081 20.1314 15.8592 19.3359L16.0149 19.1904C16.8086 18.449 17.6288 17.6828 18.3679 16.8743C19.948 15.1457 21.25 13.1257 21.25 10.4694C21.25 5.55704 17.0724 1.63869 12 1.63869ZM12 6.88869C9.79086 6.88869 8 8.67956 8 10.8887C8 13.0978 9.79086 14.8887 12 14.8887C14.2091 14.8887 16 13.0978 16 10.8887C16 8.67956 14.2091 6.88869 12 6.88869Z"
      fill="currentColor"
    />
  ),
  qr: (
    <>
      <path
        d="M3 6C3 4.58579 3 3.87868 3.43934 3.43934C3.87868 3 4.58579 3 6 3C7.41421 3 8.12132 3 8.56066 3.43934C9 3.87868 9 4.58579 9 6C9 7.41421 9 8.12132 8.56066 8.56066C8.12132 9 7.41421 9 6 9C4.58579 9 3.87868 9 3.43934 8.56066C3 8.12132 3 7.41421 3 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3 18C3 16.5858 3 15.8787 3.43934 15.4393C3.87868 15 4.58579 15 6 15C7.41421 15 8.12132 15 8.56066 15.4393C9 15.8787 9 16.5858 9 18C9 19.4142 9 20.1213 8.56066 20.5607C8.12132 21 7.41421 21 6 21C4.58579 21 3.87868 21 3.43934 20.5607C3 20.1213 3 19.4142 3 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3 12L9 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3V8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 6C15 4.58579 15 3.87868 15.4393 3.43934C15.8787 3 16.5858 3 18 3C19.4142 3 20.1213 3 20.5607 3.43934C21 3.87868 21 4.58579 21 6C21 7.41421 21 8.12132 20.5607 8.56066C20.1213 9 19.4142 9 18 9C16.5858 9 15.8787 9 15.4393 8.56066C15 8.12132 15 7.41421 15 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M21 12H15C13.5858 12 12.8787 12 12.4393 12.4393C12 12.8787 12 13.5858 12 15M12 17.7692V20.5385M15 15V16.5C15 17.9464 15.7837 18 17 18C17.5523 18 18 18.4477 18 19M16 21H15M18 15C19.4142 15 20.1213 15 20.5607 15.44C21 15.8799 21 16.5881 21 18.0043C21 19.4206 21 20.1287 20.5607 20.5687C20.24 20.8898 19.7767 20.9766 19 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  reload: (
    <>
      <path
        d="M5.5 3.5L5.5 14.5C5.5 18.2133 8.18503 21 12 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 20.5L18.5 9.5C18.5 5.78672 15.815 3 12 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 18C21 18 19.1588 20.5 18.5 20.5C17.8412 20.5 16 18 16 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.50022C8 5.50022 6.15878 3.00025 5.49998 3.00024C4.84118 3.00024 3 5.50024 3 5.50024"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  restaurant: (
    <>
      <path
        d="M4 21.001L7.00071 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></path>
      <path
        d="M15 10.001L14 11.001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></path>
      <path
        d="M18 3.00098L13 8.00098L17.0003 12.0007L22 7.00098"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></path>
      <path
        d="M20 5L17 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></path>
      <path
        d="M20 21L12 13M12 13L2 3C2 6.84174 3.52612 10.5261 6.24264 13.2426L9 16L12 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></path>
    </>
  ),
  safe: (
    <>
      <path
        d="M16 17L16.2099 17.2099C16.5786 17.5786 16.763 17.763 16.9862 17.7506C17.2094 17.7383 17.3722 17.5346 17.6979 17.1274L18.9996 15.5M13 15.4543V15.8403C13 17.0422 13 17.6431 13.1484 18.1931C13.3316 18.8723 13.6791 19.4986 14.1616 20.0197C14.5522 20.4416 15.0678 20.7701 16.0988 21.4271C16.5604 21.7212 16.7912 21.8683 17.0365 21.9367C17.3395 22.0211 17.6605 22.0211 17.9635 21.9367C18.2088 21.8683 18.4396 21.7212 18.9012 21.4271C19.9322 20.7701 20.4478 20.4416 20.8384 20.0197C21.3209 19.4986 21.6684 18.8723 21.8516 18.1931C22 17.6431 22 17.0422 22 15.8403V15.4543C22 14.7059 22 14.3317 21.8582 14.0157C21.7707 13.8208 21.6454 13.6443 21.4892 13.496C21.2359 13.2555 20.877 13.1241 20.159 12.8613L18.685 12.3218C18.099 12.1073 17.806 12 17.5 12C17.194 12 16.901 12.1073 16.315 12.3218L14.841 12.8613C14.123 13.1241 13.7641 13.2555 13.5108 13.496C13.3546 13.6443 13.2293 13.8208 13.1418 14.0157C13 14.3317 13 14.7059 13 15.4543Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M16.1712 7.9091V9.5M16.1712 7.9091C16.1712 7.15599 16.8045 6.54546 17.5856 6.54546C18.3668 6.54546 19 7.15599 19 7.9091V9.5M16.1712 7.9091V5.18183C16.1712 4.42871 15.538 3.81819 14.7568 3.81819C13.9757 3.81819 13.3424 4.42871 13.3424 5.18183M13.3424 5.18183V9.5M13.3424 5.18183V3.36364C13.3424 2.61052 12.7092 2 11.928 2C11.1469 2 10.5136 2.61052 10.5136 3.36364V6.09092M10.5136 6.09092C10.5136 5.3378 9.8804 4.72728 9.09925 4.72728C8.3181 4.72728 7.68485 5.3378 7.68485 6.09092V12.638C7.68485 13.054 7.15233 13.2514 6.8624 12.9429L4.57112 10.5043C4.18153 10.0442 3.52308 9.88846 2.95688 10.1224C1.94855 10.539 1.71198 12.0103 2.36735 12.8584C3.48877 14.3098 4.63778 16.2915 5.56538 18.0388C6.82424 20.4102 9.30884 22 12.0719 22M10.5136 6.09092V9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  savings: (
    <path
      d="M16 10.8845C16.2448 10.8845 16.4535 10.7983 16.626 10.626C16.7983 10.4535 16.8845 10.2448 16.8845 10C16.8845 9.75517 16.7983 9.5465 16.626 9.374C16.4535 9.20167 16.2448 9.1155 16 9.1155C15.7552 9.1155 15.5465 9.20167 15.374 9.374C15.2017 9.5465 15.1155 9.75517 15.1155 10C15.1155 10.2448 15.2017 10.4535 15.374 10.626C15.5465 10.7983 15.7552 10.8845 16 10.8845ZM8 8.75H13V7.25H8V8.75ZM4.875 20.5C4.34683 18.6768 3.819 16.8628 3.2915 15.0577C2.76383 13.2526 2.5 11.4 2.5 9.5C2.5 8.10767 2.98525 6.92625 3.95575 5.95575C4.92625 4.98525 6.10767 4.5 7.5 4.5H12.75C13.2077 3.89867 13.7568 3.415 14.3973 3.049C15.0376 2.683 15.7385 2.5 16.5 2.5C16.7757 2.5 17.0113 2.59775 17.2068 2.79325C17.4023 2.98875 17.5 3.22433 17.5 3.5C17.5 3.568 17.4907 3.63592 17.472 3.70375C17.4535 3.77175 17.434 3.83458 17.4135 3.89225C17.3212 4.13325 17.2426 4.38008 17.1777 4.63275C17.1131 4.88525 17.0577 5.14033 17.0115 5.398L19.6135 8H21.5V14.1095L18.771 15.0058L17.125 20.5H12.5V18.5H9.5V20.5H4.875ZM6 19H8V17H14V19H16L17.55 13.85L20 13.025V9.5H19L15.5 6C15.5 5.66667 15.5208 5.34583 15.5625 5.0375C15.6042 4.72917 15.6731 4.41983 15.7693 4.1095C15.2859 4.24283 14.8641 4.47525 14.5038 4.80675C14.1436 5.13808 13.8673 5.53583 13.675 6H7.5C6.53333 6 5.70833 6.34167 5.025 7.025C4.34167 7.70833 4 8.53333 4 9.5C4 11.1333 4.225 12.7292 4.675 14.2875C5.125 15.8458 5.56667 17.4167 6 19Z"
      fill="currentColor"
    />
  ),
  // profile: (
  //   <>
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
  //       fill="currentColor"
  //     />
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M11.9915 7.75C11.0221 7.75 10.238 8.53451 10.238 9.5C10.238 10.4655 11.0221 11.25 11.9915 11.25C12.961 11.25 13.7451 10.4655 13.7451 9.5C13.7451 8.53452 12.961 7.75 11.9915 7.75ZM8.73795 9.5C8.73795 7.70407 10.1957 6.25 11.9915 6.25C13.7874 6.25 15.2451 7.70406 15.2451 9.5C15.2451 11.2959 13.7874 12.75 11.9915 12.75C10.1957 12.75 8.73795 11.2959 8.73795 9.5ZM15.9485 17.5083C13.9023 15.2881 10.0928 15.3703 8.04244 17.5179L6.95752 16.4821C9.57052 13.7453 14.3841 13.5975 17.0515 16.4917L15.9485 17.5083Z"
  //       fill="currentColor"
  //     />
  //   </>
  // ),
  // menuExpand: (
  //   <>
  //     <path
  //       fill="currentColor"
  //       d="M13,21.75h-2c-3.91,0-5.87,0-7.38-1.1-.49-.35-.92-.78-1.27-1.27-1.1-1.51-1.1-3.47-1.1-7.38s0-5.87,1.1-7.38c.35-.49.78-.92,1.27-1.27,1.51-1.1,3.47-1.1,7.38-1.1h2c3.91,0,5.87,0,7.38,1.1.49.36.92.78,1.27,1.27,1.1,1.51,1.1,3.47,1.1,7.38s0,5.87-1.1,7.38c-.35.49-.78.92-1.27,1.27-1.51,1.1-3.47,1.1-7.38,1.1ZM11,3.75c-3.58,0-5.38,0-6.5.81-.36.26-.68.58-.94.94-.81,1.12-.81,2.92-.81,6.5s0,5.38.81,6.5c.26.36.58.68.94.94,1.12.81,2.92.81,6.5.81h2c3.58,0,5.38,0,6.5-.81.36-.26.68-.58.94-.94.81-1.12.81-2.92.81-6.5s0-5.38-.81-6.5c-.26-.36-.58-.68-.94-.94-1.12-.81-2.92-.81-6.5-.81h-2Z"
  //     />
  //     <rect fill="currentColor" x="13.75" y="3.5" width="1.5" height="17" />
  //     <path
  //       fill="currentColor"
  //       d="M19,7.75h-1.5c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h1.5c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  //     />
  //     <path
  //       fill="currentColor"
  //       d="M19,11.75h-1.5c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h1.5c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  //     />
  //     <path
  //       fill="currentColor"
  //       d="M8,14.75c-.21,0-.42-.09-.57-.26-.27-.31-.24-.79.08-1.06l1.23-1.06c.15-.13.31-.27.42-.37-.11-.11-.27-.25-.42-.37l-1.23-1.06c-.31-.27-.35-.74-.08-1.06.27-.31.75-.35,1.06-.08l1.23,1.06c.6.52,1.03.89,1.03,1.51s-.43.99-1.03,1.51l-1.23,1.06c-.14.12-.32.18-.49.18ZM9.28,12.13h0,0Z"
  //     />
  //   </>
  // ),
  // menuCollapse: (
  //   <g transform="scale(-1, 1) translate(-24, 0)">
  //     <path
  //       fill="currentColor"
  //       d="M13,21.75h-2c-3.91,0-5.87,0-7.38-1.1-.49-.35-.92-.78-1.27-1.27-1.1-1.51-1.1-3.47-1.1-7.38s0-5.87,1.1-7.38c.35-.49.78-.92,1.27-1.27,1.51-1.1,3.47-1.1,7.38-1.1h2c3.91,0,5.87,0,7.38,1.1.49.36.92.78,1.27,1.27,1.1,1.51,1.1,3.47,1.1,7.38s0,5.87-1.1,7.38c-.35.49-.78.92-1.27,1.27-1.51,1.1-3.47,1.1-7.38,1.1ZM11,3.75c-3.58,0-5.38,0-6.5.81-.36.26-.68.58-.94.94-.81,1.12-.81,2.92-.81,6.5s0,5.38.81,6.5c.26.36.58.68.94.94,1.12.81,2.92.81,6.5.81h2c3.58,0,5.38,0,6.5-.81.36-.26.68-.58.94-.94.81-1.12.81-2.92.81-6.5s0-5.38-.81-6.5c-.26-.36-.58-.68-.94-.94-1.12-.81-2.92-.81-6.5-.81h-2Z"
  //     />
  //     <rect fill="currentColor" x="13.75" y="3.5" width="1.5" height="17" />
  //     <path
  //       fill="currentColor"
  //       d="M19,7.75h-1.5c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h1.5c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  //     />
  //     <path
  //       fill="currentColor"
  //       d="M19,11.75h-1.5c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h1.5c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  //     />
  //     <path
  //       fill="currentColor"
  //       d="M8,14.75c-.21,0-.42-.09-.57-.26-.27-.31-.24-.79.08-1.06l1.23-1.06c.15-.13.31-.27.42-.37-.11-.11-.27-.25-.42-.37l-1.23-1.06c-.31-.27-.35-.74-.08-1.06.27-.31.75-.35,1.06-.08l1.23,1.06c.6.52,1.03.89,1.03,1.51s-.43.99-1.03,1.51l-1.23,1.06c-.14.12-.32.18-.49.18ZM9.28,12.13h0,0Z"
  //     />
  //   </g>
  // ),
  school: (
    <>
      <path
        d="M1.99805 7.99928C1.99805 9.34126 10.0943 13 11.9857 13C13.8772 13 21.9734 9.34126 21.9734 7.99928C21.9734 6.6573 13.8772 2.99854 11.9857 2.99854C10.0943 2.99854 1.99805 6.6573 1.99805 7.99928Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99219 11L7.24348 16.8002C7.32919 17.1975 7.52703 17.5687 7.85696 17.8054C10.0787 19.3998 13.8908 19.3998 16.1126 17.8054C16.4426 17.5687 16.6404 17.1975 16.7261 16.8002L17.9774 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4774 9.49951V16.5006M20.4774 16.5006C19.6864 17.9471 19.3366 18.7221 18.9813 20.0011C18.9042 20.4562 18.9654 20.6855 19.2786 20.8891C19.4059 20.9718 19.5588 21.0012 19.7104 21.0012H21.229C21.3904 21.0012 21.5533 20.9675 21.6863 20.8757C21.9774 20.6747 22.0523 20.4541 21.9734 20.0011C21.662 18.8135 21.2653 18.0016 20.4774 16.5006Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  screenShare: (
    <>
      <path
        d="M4 21C4 19.8954 3.10457 19 2 19M8 21C8 17.6863 5.31371 15 2 15M12 21C12 15.4772 7.52285 11 2 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2941 20H19C20.6569 20 22 18.6569 22 17V6C22 4.34315 20.6569 3 19 3H6C4.34315 3 3 4.34315 3 6V8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  search: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.125 20 15.078 19.2635 16.6177 18.0319L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L18.0319 16.6177C19.2635 15.078 20 13.125 20 11C20 6.02944 15.9706 2 11 2ZM4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11Z"
      fill="currentColor"
    />
  ),
  shield: (
    <>
      <path
        d="M21 11.0511V6.12325C21 5.34825 20.4145 4.70502 19.6551 4.57302C16.595 4.04108 14.0546 2.85772 12.8152 2.20154C12.3077 1.93282 11.6923 1.93282 11.1848 2.20154C9.94542 2.85772 7.40502 4.04108 4.34489 4.57302C3.58552 4.70502 3 5.34825 3 6.12325V11.0511C3 17.4795 9.53762 20.9859 11.4689 21.8815C11.8097 22.0395 12.1903 22.0395 12.5311 21.8815C14.4624 20.9859 21 17.4795 21 11.0511Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.5 11.5C14.5 12.8807 13.3807 14 12 14C10.6193 14 9.5 12.8807 9.5 11.5C9.5 10.1193 10.6193 9 12 9C13.3807 9 14.5 10.1193 14.5 11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  signature: (
    <>
      <path
        d="M22 12.6344C18 16.1465 17.4279 10.621 15.3496 11.0165C13 11.4637 11.5 16.4445 13 16.4445C14.5 16.4445 12.5 10.5 10.5 12.5556C8.5 14.6111 7.85936 17.2946 6.23526 15.3025C-1.5 5.81446 4.99998 -1.14994 8.16322 3.45685C10.1653 6.37256 6.5 16.9769 2 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  sound: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2C9.55228 2 10 2.44772 10 3V21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21V3C8 2.44772 8.44772 2 9 2ZM6 6C6.55228 6 7 6.44772 7 7V17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17V7C5 6.44772 5.44772 6 6 6ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V6ZM15 8C15.5523 8 16 8.44772 16 9V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V9C14 8.44772 14.4477 8 15 8ZM19 7C19 6.44772 18.5523 6 18 6C17.4477 6 17 6.44772 17 7V17C17 17.5523 17.4477 18 18 18C18.5523 18 19 17.5523 19 17V7ZM21 10C21.5523 10 22 10.4477 22 11V13C22 13.5523 21.5523 14 21 14C20.4477 14 20 13.5523 20 13V11C20 10.4477 20.4477 10 21 10ZM4 11C4 10.4477 3.55228 10 3 10C2.44772 10 2 10.4477 2 11V13C2 13.5523 2.44772 14 3 14C3.55228 14 4 13.5523 4 13V11Z"
      fill="currentColor"
    />
  ),
  squareArrowExpand: (
    <>
      <path
        d="M16.5148 16.5149C17.0896 15.9401 16.9941 13.4982 16.9941 13.4982M16.5148 16.5149C15.94 17.0897 13.4981 16.994 13.4981 16.994M16.5148 16.5149L13 13M7.48506 7.48512C8.05987 6.91031 10.5018 7.00596 10.5018 7.00596M7.48506 7.48512C6.91025 8.05993 7.00598 10.5018 7.00598 10.5018M7.48506 7.48512L11 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  squareArrowShrink: (
    <>
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.0167 11.0167C11.5915 10.4419 11.4959 8 11.4959 8M11.0167 11.0167C10.4419 11.5915 8 11.4958 8 11.4958M11.0167 11.0167L7 7M12.9869 12.9868C13.5617 12.412 16.0036 12.5077 16.0036 12.5077M12.9869 12.9868C12.4121 13.5616 12.5078 16.0035 12.5078 16.0035M12.9869 12.9868L17 16.9999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  star: (
    <>
      <path
        d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  starFilled: (
    <>
      <path
        d="M11.9961 1.25C13.0454 1.25 13.8719 2.04253 14.3995 3.11191L16.1616 6.66516C16.215 6.77513 16.3417 6.92998 16.5321 7.07164C16.7223 7.21315 16.9086 7.29121 17.0311 7.3118L20.2207 7.84613C21.3729 8.03973 22.3386 8.60449 22.6521 9.5879C22.9653 10.5705 22.5064 11.5916 21.6778 12.4216L21.677 12.4225L19.1991 14.9209C19.1009 15.0199 18.9909 15.2064 18.9219 15.4494C18.8534 15.6908 18.8473 15.9107 18.8784 16.0527L18.8788 16.0547L19.5877 19.1454C19.8818 20.4317 19.7843 21.7073 18.8771 22.3742C17.9667 23.0433 16.7227 22.7467 15.5925 22.0736L12.6026 20.289C12.477 20.214 12.2614 20.1532 12.0011 20.1532C11.7427 20.1532 11.5226 20.2132 11.3888 20.291L11.3869 20.2921L8.40288 22.0732C7.27405 22.7487 6.03154 23.04 5.12111 22.3702C4.21449 21.7032 4.11214 20.43 4.40711 19.1447L5.1159 16.0547L5.11633 16.0527C5.14741 15.9107 5.14133 15.6908 5.0728 15.4494C5.0038 15.2064 4.89379 15.0199 4.79558 14.9209L2.31585 12.4206C1.49265 11.5906 1.03521 10.5704 1.34595 9.58925C1.65759 8.60525 2.62143 8.0398 3.77433 7.84606L6.96132 7.31219L6.96233 7.31202C7.07917 7.29175 7.2627 7.21456 7.45248 7.07268C7.64261 6.93054 7.76959 6.77535 7.82312 6.66516L7.82582 6.65967L9.58562 3.11097L9.58632 3.10957C10.119 2.04108 10.948 1.25 11.9961 1.25Z"
        fill="currentColor"
      />
    </>
  ),
  starHalf: (
    <>
      <path
        d="M11.9979 1.25001L12 1.25L12.0034 1.25C12.4176 1.25 12.7534 1.58579 12.7534 2V19.4031L8.40699 22.0736C7.27683 22.7467 6.0328 23.0433 5.12244 22.3742C4.21519 21.7073 4.11776 20.4318 4.41178 19.1454L5.12072 16.0547L5.12115 16.0528C5.24843 15.4978 4.96035 15.0669 4.8004 14.9209L2.32248 12.4225L2.32151 12.4215C1.4931 11.5915 1.03422 10.5704 1.34745 9.5879C1.66095 8.60449 2.62664 8.03974 3.77877 7.84613L6.96842 7.31181C7.16455 7.28519 7.61357 7.11749 7.84061 6.65966L9.59975 3.11238C10.1265 2.04505 10.9512 1.25291 11.9979 1.25001Z"
        fill="currentColor"
      />
      <path
        d="M14.6668 5.30909C15.0379 5.12507 15.4879 5.27672 15.6719 5.64781L16.1764 6.66515C16.2299 6.77535 16.3569 6.93055 16.547 7.07269C16.7368 7.21456 16.9203 7.29175 17.0372 7.31202L17.0382 7.31219L20.2252 7.84606C21.3781 8.0398 22.3419 8.60525 22.6536 9.58926C22.9643 10.5704 22.5069 11.5906 21.6837 12.4206L19.2039 14.9209C19.1057 15.0199 18.9957 15.2064 18.9267 15.4494C18.8582 15.6908 18.8521 15.9107 18.8832 16.0528L18.8836 16.0547L19.5924 19.1447C19.8874 20.4301 19.785 21.7032 18.8784 22.3702C17.968 23.04 16.7255 22.7487 15.5966 22.0732L14.6156 21.4877C14.2599 21.2754 14.1437 20.8149 14.356 20.4593C14.5683 20.1036 15.0287 19.9874 15.3844 20.1996L16.3661 20.7856C17.377 21.3905 17.8551 21.2609 17.9895 21.162C18.1278 21.0603 18.3954 20.6347 18.1304 19.4803L17.4193 16.3802C17.3209 15.9375 17.3651 15.4576 17.4837 15.0398C17.6022 14.6224 17.8172 14.189 18.1389 13.8646L20.6187 11.3644C21.2553 10.7225 21.2928 10.2607 21.2236 10.0422C21.1553 9.82646 20.8639 9.47442 19.977 9.32539L16.7877 8.79113L16.7851 8.79068C16.3719 8.71994 15.971 8.51489 15.6489 8.27407C15.3274 8.03375 15.0153 7.70613 14.8286 7.32363L14.3281 6.31422C14.1441 5.94313 14.2957 5.49312 14.6668 5.30909Z"
        fill="currentColor"
      />
    </>
  ),
  stop: (
    <path
      d="M12.0436 3.25C13.6463 3.24999 14.9086 3.24998 15.913 3.35586C16.9399 3.4641 17.7833 3.68971 18.5113 4.19945C19.0129 4.55072 19.4493 4.98706 19.8005 5.48872C20.3103 6.21671 20.5359 7.06008 20.6441 8.08697C20.75 9.0914 20.75 10.3537 20.75 11.9564V12.0436C20.75 13.6463 20.75 14.9086 20.6441 15.913C20.5359 16.9399 20.3103 17.7833 19.8005 18.5113C19.4493 19.0129 19.0129 19.4493 18.5113 19.8005C17.7833 20.3103 16.9399 20.5359 15.913 20.6441C14.9086 20.75 13.6463 20.75 12.0436 20.75H11.9564C10.3537 20.75 9.0914 20.75 8.08697 20.6441C7.06008 20.5359 6.21671 20.3103 5.48872 19.8005C4.98706 19.4493 4.55072 19.0129 4.19945 18.5113C3.68971 17.7833 3.4641 16.9399 3.35586 15.913C3.24998 14.9086 3.24999 13.6463 3.25 12.0436V11.9564C3.24999 10.3537 3.24998 9.0914 3.35586 8.08697C3.4641 7.06008 3.68971 6.21671 4.19945 5.48872C4.55072 4.98706 4.98706 4.55072 5.48872 4.19945C6.21671 3.68971 7.06008 3.4641 8.08697 3.35586C9.0914 3.24998 10.3537 3.24999 11.9564 3.25H12.0436Z"
      fill="currentColor"
    />
  ),
  sunPositionFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 9.91418L15.2072 6.70708L13.793 5.29286L13.0001 6.08576V2.49997L11.0001 2.49997V6.08576L10.2072 5.29286L8.79297 6.70708L12.0001 9.91418Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.242 10.8439L17.6562 9.42969L19.0705 10.8439L17.6563 12.2581L16.242 10.8439Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 15.501H5V17.501H3V15.501Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.3436 9.42954L7.75781 10.8438L6.3436 12.258L4.92939 10.8438L6.3436 9.42954Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 15.501H21V17.501H19V15.501Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 19.501H21V21.501H3V19.501Z"
        fill="currentColor"
      />
      <path
        d="M17 17.501H7V16.501C7 13.7396 9.23858 11.501 12 11.501C14.7614 11.501 17 13.7396 17 16.501V17.501Z"
        fill="currentColor"
      />
    </>
  ),
  supermarket: (
    <>
      <path
        d="M2.9668 10.4961V15.4979C2.9668 18.3273 2.9668 19.742 3.84548 20.621C4.72416 21.5001 6.13837 21.5001 8.9668 21.5001H14.9668C17.7952 21.5001 19.2094 21.5001 20.0881 20.621C20.9668 19.742 20.9668 18.3273 20.9668 15.4979V10.4961"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.9668 16.9932C14.2827 17.6004 13.1936 17.9932 11.9668 17.9932C10.74 17.9932 9.65089 17.6004 8.9668 16.9932"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.1038 8.41848C9.82182 9.43688 8.79628 11.1936 6.84777 11.4482C5.12733 11.673 3.82246 10.922 3.48916 10.608C3.12168 10.3534 2.28416 9.53872 2.07906 9.02952C1.87395 8.52032 2.11324 7.41706 2.28416 6.96726L2.96743 4.98888C3.13423 4.49196 3.5247 3.31666 3.92501 2.91913C4.32533 2.5216 5.13581 2.5043 5.4694 2.5043H12.4749C14.2781 2.52978 18.2209 2.48822 19.0003 2.50431C19.7797 2.52039 20.2481 3.17373 20.3848 3.45379C21.5477 6.27061 22 7.88382 22 8.57124C21.8482 9.30456 21.22 10.6873 19.0003 11.2955C16.6933 11.9275 15.3854 10.6981 14.9751 10.2261M9.15522 10.2261C9.47997 10.625 10.4987 11.4279 11.9754 11.4482C13.4522 11.4686 14.7273 10.4383 15.1802 9.92062C15.3084 9.76786 15.5853 9.31467 15.8725 8.41848"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  swimming: (
    <>
      <path
        d="M10.7184 6.86177L15 16C12.8333 16 12.1739 14.8571 9.91304 13.7143C8.10435 12.8 5.57971 12.9524 4.82609 13.1429L7.85739 10.9998C8.16585 10.7817 8.32008 10.6727 8.36937 10.5067C8.41866 10.3407 8.34893 10.1651 8.20947 9.81406L7.78519 8.74593C7.62654 8.34653 7.54721 8.14683 7.40384 8.00197C7.35388 7.9515 7.2987 7.9065 7.23922 7.86772C7.06848 7.7564 6.8569 7.71887 6.43376 7.64379L3.18315 7.06706C2.4987 6.94562 2 6.35065 2 5.65551C2 4.78222 2.77418 4.11181 3.63851 4.23665L8.0343 4.87152C8.82604 4.98586 9.22191 5.04304 9.5521 5.23177C9.68974 5.31045 9.81754 5.40521 9.93281 5.51407C10.2093 5.7752 10.379 6.13739 10.7184 6.86177Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <circle
        cx="19"
        cy="10"
        r="3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></circle>
      <path
        d="M2 18.0843C3.05556 14.5527 7.7685 16.1736 11.5 18.0843C15.2315 19.995 19 21.2108 21 18.0843"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </>
  ),
  threeDots: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7461 12C10.7461 11.3096 11.3057 10.75 11.9961 10.75H12.0051C12.6954 10.75 13.2551 11.3096 13.2551 12C13.2551 12.6904 12.6954 13.25 12.0051 13.25H11.9961C11.3057 13.25 10.7461 12.6904 10.7461 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.75 12C16.75 11.3096 17.3096 10.75 18 10.75H18.009C18.6994 10.75 19.259 11.3096 19.259 12C19.259 12.6904 18.6994 13.25 18.009 13.25H18C17.3096 13.25 16.75 12.6904 16.75 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 12C4.75 11.3096 5.30964 10.75 6 10.75H6.00898C6.69934 10.75 7.25898 11.3096 7.25898 12C7.25898 12.6904 6.69934 13.25 6.00898 13.25H6C5.30964 13.25 4.75 12.6904 4.75 12Z"
        fill="currentColor"
      />
    </>
  ),
  thumbsDown: (
    <>
      <path
        d="M2 11.5C2 12.6046 2.89543 13.5 4 13.5C5.65685 13.5 7 12.1569 7 10.5V6.5C7 4.84315 5.65685 3.5 4 3.5C2.89543 3.5 2 4.39543 2 5.5V11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4787 16.1937L15.2124 15.3337C14.9942 14.6289 14.8851 14.2765 14.969 13.9982C15.0369 13.7731 15.1859 13.579 15.389 13.4513C15.64 13.2935 16.0197 13.2935 16.7791 13.2935H17.1831C19.7532 13.2935 21.0382 13.2935 21.6452 12.5327C21.7145 12.4458 21.7762 12.3533 21.8296 12.2563C22.2965 11.4079 21.7657 10.2649 20.704 7.9789C19.7297 5.88111 19.2425 4.83222 18.338 4.21485C18.2505 4.15508 18.1605 4.0987 18.0683 4.04586C17.116 3.5 15.9362 3.5 13.5764 3.5H13.0646C10.2057 3.5 8.77628 3.5 7.88814 4.36053C7 5.22106 7 6.60607 7 9.37607V10.3497C7 11.8054 7 12.5332 7.25834 13.1994C7.51668 13.8656 8.01135 14.4134 9.00069 15.5089L13.0921 20.0394C13.1947 20.1531 13.246 20.2099 13.2913 20.2493C13.7135 20.6167 14.3652 20.5754 14.7344 20.1577C14.774 20.1129 14.8172 20.0501 14.9036 19.9245C15.0388 19.728 15.1064 19.6297 15.1654 19.5323C15.6928 18.6609 15.8524 17.6256 15.6108 16.6429C15.5838 16.5331 15.5488 16.4199 15.4787 16.1937Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  thumbsDownFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 11.375C1.25 12.9628 2.49721 14.25 4.03571 14.25C6.08706 14.25 7.75 12.5338 7.75 10.4167V6.58333C7.75 4.46624 6.08706 2.75 4.03571 2.75C2.49721 2.75 1.25 4.03718 1.25 5.625V11.375ZM4.03571 12.3333C3.52288 12.3333 3.10714 11.9043 3.10714 11.375V5.625C3.10714 5.09573 3.52288 4.66667 4.03571 4.66667C5.06139 4.66667 5.89286 5.52479 5.89286 6.58333V10.4167C5.89286 11.4752 5.06139 12.3333 4.03571 12.3333Z"
        fill="currentColor"
      />
      <path
        d="M12.799 20.815C13.5298 21.4511 14.6525 21.3829 15.2964 20.6544C15.4097 20.5125 15.6704 20.1672 15.807 19.9207C16.4367 18.8803 16.6286 17.6412 16.3392 16.4638C16.3068 16.3322 16.2656 16.1992 16.2023 15.9946L15.9289 15.1118C15.8154 14.7453 15.7468 14.5208 15.7117 14.3527C15.6855 14.26 15.6985 14.0717 15.9601 14.0602C16.1402 14.0442 16.8457 14.0435 17.2394 14.0435C18.4766 14.0435 19.4811 14.0435 20.2488 13.9419C21.0337 13.838 21.7462 13.6087 22.2315 13.0005C22.3273 12.8804 22.4127 12.7524 22.4867 12.618C22.8663 11.9283 22.7859 11.1853 22.5573 10.4375C22.335 9.70996 21.9188 8.81395 21.409 7.71633C20.9359 6.6976 20.516 5.79345 20.1401 5.15929C19.7512 4.5033 19.3355 3.98759 18.7609 3.5954C18.0878 3.13597 17.1903 2.89563 16.4221 2.8217C15.6771 2.75 14.7621 2.75001 13.6144 2.75002C12.2303 2.75 10.5147 2.74998 9.64051 2.86387C8.73584 2.98172 7.97376 3.23334 7.3663 3.82191C6.75553 4.4137 6.49136 5.16154 6.36819 6.04919C6.25001 6.90085 6.25003 7.98266 6.25005 9.31985L6.25003 10.4925C6.24964 11.8105 6.24939 12.6719 6.55913 13.4706C6.86812 14.2674 7.45104 14.9125 8.34723 15.9043L12.5574 20.5663C12.6369 20.6546 12.7182 20.7447 12.799 20.815Z"
        fill="currentColor"
      />
    </>
  ),
  thumbsUp: (
    <>
      <path
        d="M2 12.5C2 11.3954 2.89543 10.5 4 10.5C5.65685 10.5 7 11.8431 7 13.5V17.5C7 19.1569 5.65685 20.5 4 20.5C2.89543 20.5 2 19.6046 2 18.5V12.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4787 7.80626L15.2124 8.66634C14.9942 9.37111 14.8851 9.72349 14.969 10.0018C15.0369 10.2269 15.1859 10.421 15.389 10.5487C15.64 10.7065 16.0197 10.7065 16.7791 10.7065H17.1831C19.7532 10.7065 21.0382 10.7065 21.6452 11.4673C21.7145 11.5542 21.7762 11.6467 21.8296 11.7437C22.2965 12.5921 21.7657 13.7351 20.704 16.0211C19.7297 18.1189 19.2425 19.1678 18.338 19.7852C18.2505 19.8449 18.1605 19.9013 18.0683 19.9541C17.116 20.5 15.9362 20.5 13.5764 20.5H13.0646C10.2057 20.5 8.77628 20.5 7.88814 19.6395C7 18.7789 7 17.3939 7 14.6239V13.6503C7 12.1946 7 11.4668 7.25834 10.8006C7.51668 10.1344 8.01135 9.58664 9.00069 8.49112L13.0921 3.96056C13.1947 3.84694 13.246 3.79012 13.2913 3.75075C13.7135 3.38328 14.3652 3.42464 14.7344 3.84235C14.774 3.8871 14.8172 3.94991 14.9036 4.07554C15.0388 4.27205 15.1064 4.37031 15.1654 4.46765C15.6928 5.33913 15.8524 6.37436 15.6108 7.35715C15.5838 7.46692 15.5488 7.5801 15.4787 7.80626Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  thumbsUpFilled: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 12.625C1.25 11.0372 2.49721 9.75003 4.03571 9.75003C6.08706 9.75003 7.75 11.4663 7.75 13.5834V17.4167C7.75 19.5338 6.08706 21.25 4.03571 21.25C2.49721 21.25 1.25 19.9628 1.25 18.375V12.625ZM4.03571 11.6667C3.52288 11.6667 3.10714 12.0958 3.10714 12.625V18.375C3.10714 18.9043 3.52288 19.3334 4.03571 19.3334C5.06139 19.3334 5.89286 18.4752 5.89286 17.4167V13.5834C5.89286 12.5248 5.06139 11.6667 4.03571 11.6667Z"
        fill="currentColor"
      />
      <path
        d="M12.799 3.18499C13.5298 2.54898 14.6525 2.61713 15.2964 3.34567C15.4097 3.48751 15.6704 3.83281 15.807 4.07931C16.4367 5.11969 16.6286 6.35887 16.3392 7.53622C16.3068 7.66781 16.2656 7.80085 16.2023 8.00546L15.9289 8.88818C15.8154 9.25476 15.7468 9.47927 15.7117 9.64734C15.6855 9.74004 15.6985 9.9283 15.9601 9.93979C16.1402 9.95585 16.8457 9.95655 17.2394 9.95655C18.4766 9.95653 19.4811 9.95651 20.2488 10.0581C21.0337 10.162 21.7462 10.3913 22.2315 10.9996C22.3273 11.1197 22.4127 11.2476 22.4867 11.3821C22.8663 12.0718 22.7859 12.8147 22.5573 13.5625C22.335 14.2901 21.9188 15.1861 21.409 16.2837C20.9359 17.3024 20.516 18.2066 20.1401 18.8407C19.7512 19.4967 19.3355 20.0124 18.7609 20.4046C18.0878 20.8641 17.1903 21.1044 16.4221 21.1783C15.6771 21.25 14.7621 21.25 13.6144 21.25C12.2303 21.25 10.5147 21.25 9.64051 21.1362C8.73584 21.0183 7.97376 20.7667 7.3663 20.1781C6.75553 19.5863 6.49136 18.8385 6.36819 17.9508C6.25001 17.0992 6.25003 16.0174 6.25005 14.6802L6.25003 13.5075C6.24964 12.1895 6.24939 11.3282 6.55913 10.5294C6.86812 9.73266 7.45104 9.08753 8.34723 8.09572L12.5574 3.43371C12.6369 3.34545 12.7182 3.25529 12.799 3.18499Z"
        fill="currentColor"
      />
    </>
  ),
  trainStation: (
    <>
      <path
        d="M2 3H6.73259C9.34372 3 10.6493 3 11.8679 3.40119C13.0866 3.80239 14.1368 4.57795 16.2373 6.12907L19.9289 8.85517C19.9692 8.88495 19.9894 8.89984 20.0084 8.91416C21.2491 9.84877 21.985 11.307 21.9998 12.8603C22 12.8841 22 12.9091 22 12.9593C22 12.9971 22 13.016 21.9997 13.032C21.9825 14.1115 21.1115 14.9825 20.032 14.9997C20.016 15 19.9971 15 19.9593 15H2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 8H3.89284C4.16278 8 4.29775 8 4.4256 8.0082C5.52021 8.07839 6.53798 8.595 7.24076 9.43715C7.32284 9.53551 7.40251 9.64446 7.56185 9.86235C7.61383 9.93344 7.63982 9.96899 7.66371 10.0048C7.86673 10.3091 7.98241 10.6633 7.99815 11.0287C8 11.0717 8 11.1158 8 11.2038V11.4157C8 11.5874 8 11.6732 7.9741 11.7416C7.93351 11.8488 7.84884 11.9335 7.74159 11.9741C7.67317 12 7.58735 12 7.41572 12H2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21 11H17.3333C14.3878 11 12 8.76142 12 6V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 19H22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18 19V21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 19V21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 19V21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  transcribe: (
    <g transform="scale(-1, 1) translate(-24, 0)">
      <path
        d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M 16.837003,13.212003 H 10.350497 M 16.837003,8.162997 H 13.59375"
        stroke="currentColor"
        strokeWidth="1.45099"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
  trophy: (
    <>
      <path
        d="M12 17C10.3264 17 8.86971 18.265 8.11766 20.1312C7.75846 21.0225 8.27389 22 8.95877 22H15.0412C15.7261 22 16.2415 21.0225 15.8823 20.1312C15.1303 18.265 13.6736 17 12 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18.5 5H19.7022C20.9031 5 21.5035 5 21.8168 5.37736C22.13 5.75472 21.9998 6.32113 21.7393 7.45395L21.3485 9.15307C20.7609 11.7086 18.6109 13.6088 16 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 5H4.29779C3.09692 5 2.49649 5 2.18324 5.37736C1.86999 5.75472 2.00024 6.32113 2.26075 7.45395L2.65148 9.15307C3.23914 11.7086 5.38912 13.6088 8 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17C15.0208 17 17.565 12.3379 18.3297 5.99089C18.5412 4.23558 18.647 3.35793 18.0868 2.67896C17.5267 2 16.6223 2 14.8134 2H9.18658C7.37775 2 6.47333 2 5.91317 2.67896C5.35301 3.35793 5.45875 4.23558 5.67025 5.99089C6.435 12.3379 8.97923 17 12 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  upload: (
    <>
      <path
        d="M2.99996 14L3.2338 14.6626C4.14396 17.2413 4.59903 18.5307 5.63738 19.2654C6.67572 20 8.04305 20 10.7777 20H13.2222C15.9569 20 17.3242 20 18.3625 19.2654C19.4009 18.5307 19.856 17.2413 20.7661 14.6626L21 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 4V14M12 4C11.2997 4 9.99149 5.9943 9.49996 6.5M12 4C12.7002 4 14.0084 5.9943 14.5 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  video: (
    <>
      <path
        d="M2 11C2 7.70017 2 6.05025 3.02513 5.02513C4.05025 4 5.70017 4 9 4H10C13.2998 4 14.9497 4 15.9749 5.02513C17 6.05025 17 7.70017 17 11V13C17 16.2998 17 17.9497 15.9749 18.9749C14.9497 20 13.2998 20 10 20H9C5.70017 20 4.05025 20 3.02513 18.9749C2 17.9497 2 16.2998 2 13V11Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M17 8.90585L17.1259 8.80196C19.2417 7.05623 20.2996 6.18336 21.1498 6.60482C22 7.02628 22 8.42355 22 11.2181V12.7819C22 15.5765 22 16.9737 21.1498 17.3952C20.2996 17.8166 19.2417 16.9438 17.1259 15.198L17 15.0941"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="11.5"
        cy="9.5"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  videoOff: (
    <>
      <path
        d="M2.00189 1.99988L21.9772 21.9999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.8516 16.8677C16.7224 17.8061 16.4665 18.4668 15.9595 18.9744C14.9356 19.9996 13.2877 19.9996 9.992 19.9996H8.99323C5.69749 19.9996 4.04961 19.9996 3.02575 18.9744C2.00189 17.9493 2.00189 16.2994 2.00189 12.9996V10.9996C2.00189 7.69971 2.00189 6.04979 3.02575 5.02466C3.36827 4.68172 3.78062 4.45351 4.30114 4.30164"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.23627 4.0004C8.47815 3.99988 8.72995 3.99988 8.99217 3.99988H9.99093C13.2867 3.99988 14.9346 3.99988 15.9584 5.02501C16.9822 6.05013 16.9822 7.70005 16.9822 10.9999V12.7573M16.9822 9.2313L19.3018 7.52901C20.7729 6.54061 21.4489 7.17184 21.6674 7.64835C22.1191 8.92801 21.9768 11.3935 21.9768 14.5416C21.8703 16.5549 21.5952 16.7718 21.3137 16.9938L21.3107 16.9961"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  volumeOff: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.29289 1.29289C1.68342 0.90237 2.31658 0.90237 2.70711 1.29289L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L1.29289 2.70711C0.90237 2.31658 0.90237 1.68342 1.29289 1.29289Z"
        fill="currentColor"
      />
      <path
        d="M10.9916 3.9756C11.6784 3.44801 12.4957 3.01957 13.367 3.38808C14.2302 3.75318 14.5076 4.63267 14.6274 5.49785C14.7502 6.38459 14.7502 7.60557 14.7502 9.12365V9.76734C14.7502 10.3838 14.7502 10.6921 14.565 10.7688C14.3798 10.8455 14.1618 10.6275 13.7259 10.1916L9.60564 6.07138C9.40567 5.87142 9.30569 5.77143 9.30615 5.64652C9.30661 5.5216 9.40651 5.42317 9.60631 5.22631C10.1262 4.71414 10.59 4.28407 10.9916 3.9756Z"
        fill="currentColor"
      />
      <path
        d="M14.7502 14.8793C14.7502 16.3974 14.7502 17.6184 14.6274 18.5051C14.5076 19.3703 14.2302 20.2498 13.367 20.6149C12.4957 20.9834 11.6784 20.555 10.9916 20.0274C10.2892 19.4879 9.39657 18.5764 8.34663 17.5043C7.80717 16.9534 7.44921 16.6872 7.08663 16.5373C6.72221 16.3867 6.27914 16.3228 5.50619 16.3228C4.83768 16.3228 4.23963 16.3228 3.78679 16.2757C3.31184 16.2264 2.87088 16.119 2.47421 15.8484C1.7184 15.3327 1.42917 14.5776 1.31957 13.8837C1.23785 13.3662 1.24723 12.798 1.25479 12.3404V11.6625C1.24723 11.2049 1.23785 10.6367 1.31957 10.1192C1.42917 9.4253 1.7184 8.67023 2.47421 8.15456C2.87088 7.88392 3.31184 7.77651 3.78679 7.72717C4.23963 7.68013 4.83768 7.68015 5.50619 7.68017C6.27914 7.68017 6.72221 7.61622 7.08663 7.46557C7.15387 7.43777 7.18754 7.42386 7.20716 7.4187C7.30665 7.39256 7.38317 7.40781 7.46504 7.47009C7.48118 7.48237 7.50056 7.50175 7.53931 7.54049L14.6596 14.6608L14.6648 14.666C14.7187 14.7211 14.7492 14.7949 14.7501 14.872L14.7502 14.8793Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2869 7.29899C19.674 6.90513 20.3072 6.89969 20.701 7.28685C22.1127 8.67445 23 10.4871 23 12.5C23 13.8929 22.5738 15.1964 21.8385 16.3278C21.5376 16.7909 20.9182 16.9223 20.4551 16.6214C19.992 16.3204 19.8606 15.701 20.1615 15.238C20.7044 14.4027 21 13.4737 21 12.5C21 11.1032 20.389 9.78458 19.299 8.71315C18.9052 8.32599 18.8997 7.69285 19.2869 7.29899ZM16.3654 9.22717C16.7922 8.87668 17.4224 8.93856 17.7729 9.36538C18.5358 10.2945 19 11.4536 19 12.7195C19 12.7455 18.9998 12.7716 18.9994 12.7976C18.9911 13.3498 18.5366 13.7907 17.9844 13.7823C17.4322 13.7739 16.9913 13.3195 16.9997 12.7673C16.9999 12.7514 17 12.7354 17 12.7195C17 11.9573 16.7233 11.2388 16.2272 10.6346C15.8767 10.2078 15.9386 9.57766 16.3654 9.22717Z"
        fill="currentColor"
      />
    </>
  ),
  volumeOn: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3594 3.34172C14.6002 3.47318 14.75 3.72565 14.75 4V20C14.75 20.2744 14.6002 20.5268 14.3594 20.6583C14.1186 20.7898 13.8252 20.7792 13.5944 20.6309L6.77972 16.25H4C2.48122 16.25 1.25 15.0188 1.25 13.5V10.5C1.25 8.98122 2.48122 7.75 4 7.75H6.77972L13.5944 3.36912C13.8252 3.22076 14.1186 3.21025 14.3594 3.34172Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3935 8.20503C16.8326 7.87003 17.4601 7.95439 17.7951 8.39347C18.5519 9.38539 19.0001 10.6418 19.0001 12.0001C19.0001 13.3584 18.5519 14.6147 17.7951 15.6067C17.4601 16.0457 16.8326 16.1301 16.3935 15.7951C15.9544 15.4601 15.8701 14.8326 16.2051 14.3935C16.6991 13.7461 17.0001 12.915 17.0001 12.0001C17.0001 11.0852 16.6991 10.2541 16.2051 9.60664C15.8701 9.16756 15.9544 8.54004 16.3935 8.20503Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3247 6.26245C19.7321 5.8895 20.3646 5.91738 20.7376 6.32472C22.1408 7.8573 23 9.83243 23 12C23 14.1676 22.1408 16.1427 20.7376 17.6753C20.3646 18.0826 19.732 18.1105 19.3247 17.7376C18.9174 17.3646 18.8895 16.732 19.2625 16.3247C20.3608 15.1251 21 13.621 21 12C21 10.379 20.3609 8.87497 19.2625 7.67529C18.8895 7.26796 18.9174 6.6354 19.3247 6.26245Z"
        fill="currentColor"
      />
    </>
  ),
  waiting: (
    <>
      <path
        d="M19 2V5C19 8.86599 15.866 12 12 12M5 2V5C5 8.86599 8.13401 12 12 12M12 12C15.866 12 19 15.134 19 19V22M12 12C8.13401 12 5 15.134 5 19V22"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4 2H20M20 22H4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  walking: (
    <>
      <path
        d="M15 4C15 5.10457 14.1046 6 13 6C11.8954 6 11 5.10457 11 4C11 2.89543 11.8954 2 13 2C14.1046 2 15 2.89543 15 4Z"
        fill="currentColor"
      />
      <path
        d="M12.8751 7.06983C11.9963 6.63061 10.9557 6.65953 10.1026 7.14698L7.91415 8.39796C7.50987 8.62897 7.16466 8.951 6.90633 9.33839L5.16805 11.9458C4.8617 12.4053 4.98588 13.0262 5.4454 13.3325C5.90492 13.6389 6.52576 13.5147 6.83211 13.0552L8.5704 10.4478C8.65649 10.3187 8.77164 10.2113 8.90633 10.1343L9.6368 9.71632L9.24618 11.6694C9.03579 12.7225 9.40477 13.808 10.213 14.5151L13.1378 17.0747L14.5518 21.3169C14.7267 21.8404 15.2928 22.1232 15.8165 21.9487C16.3401 21.774 16.6227 21.2078 16.4483 20.6841L14.9483 16.1841C14.8921 16.0156 14.7919 15.8645 14.6583 15.7476L12.963 14.2642C12.969 14.242 12.976 14.2196 12.9806 14.1968L13.5684 11.2534C13.8291 11.5548 14.143 11.841 14.5235 12.0894C15.3934 12.657 16.5397 13.0005 18.0001 13.0005C18.5524 13.0005 19.0001 12.5528 19.0001 12.0005C19.0001 11.4482 18.5524 11.0005 18.0001 11.0005C16.8593 11.0005 16.1088 10.7351 15.6173 10.4146C15.1249 10.0933 14.8326 9.6776 14.67 9.2837C14.3821 8.58649 13.8857 7.57513 12.8751 7.06983Z"
        fill="currentColor"
      />
      <path
        d="M8.89226 14.9355C9.04229 15.1205 9.20756 15.2962 9.3903 15.4561L10.4772 16.4072L9.9362 17.8516C9.89682 17.9565 9.83995 18.0545 9.76823 18.1406L7.26823 21.1406C6.91465 21.5648 6.2833 21.6221 5.85905 21.2686C5.43516 20.9149 5.37768 20.2835 5.73112 19.8594L8.12273 16.9893L8.89226 14.9355Z"
        fill="currentColor"
      />
    </>
  ),
  wall: (
    <>
      <path
        d="M 19,5.7692308 H 5 c -1.41421,0 -2.12132,0 -2.56066,0.4393002 C 2,6.647931 2,7.355031 2,8.769231 V 15 c 0,1.4142 0,2.1213 0.43934,2.5607 C 2.87868,18 3.58579,18 5,18 h 14 c 1.4142,0 2.1213,0 2.5607,-0.4393 C 22,17.1213 22,16.4142 22,15 V 8.769231 c 0,-1.4142 0,-2.1213 -0.4393,-2.5607 C 21.1213,5.7692308 20.4142,5.7692308 19,5.7692308 Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 2,14 H 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 12,14 V 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 7,18 V 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 17,18 V 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 2.057692,9.942305 H 21.826921"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 7.057692,5.9423054 V 9.942305"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 17.05769,5.9423054 V 9.942305"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  world: (
    <>
      <path
        d="M12 22C6.47715 22 2 17.5228 2 12C2 9.20746 3.14465 6.68227 4.99037 4.86802M12 22C11.037 21.2864 11.1907 20.4555 11.6738 19.6247C12.4166 18.3474 12.4166 18.3474 12.4166 16.6444C12.4166 14.9414 13.4286 14.1429 17 14.8571C18.6047 15.1781 19.7741 12.9609 21.8573 13.693M12 22C16.9458 22 21.053 18.4096 21.8573 13.693M21.8573 13.693C21.9511 13.1427 22 12.5771 22 12C22 7.11857 18.5024 3.05405 13.8766 2.17579M13.8766 2.17579C14.3872 3.11599 14.1816 4.23551 13.1027 4.66298C11.3429 5.3603 12.6029 6.64343 11.1035 7.4356C10.1038 7.96372 8.6044 7.83152 7.10496 6.24716C6.31517 5.41264 5.83966 4.95765 4.99037 4.86802M13.8766 2.17579C13.2687 2.06039 12.6414 2 12 2C9.26969 2 6.79495 3.09421 4.99037 4.86802"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </>
  ),
  paintRoller: (
    <>
      <path
        d="M4 5C4 4.25579 4 3.88369 4.08912 3.58019C4.30005 2.86183 4.86183 2.30005 5.58019 2.08912C5.88369 2 6.25579 2 7 2H14C14.7442 2 15.1163 2 15.4198 2.08912C16.1382 2.30005 16.7 2.86183 16.9109 3.58019C17 3.88369 17 4.25579 17 5C17 5.74421 17 6.11631 16.9109 6.41981C16.7 7.13817 16.1382 7.69995 15.4198 7.91088C15.1163 8 14.7442 8 14 8H7C6.25579 8 5.88369 8 5.58019 7.91088C4.86183 7.69995 4.30005 7.13817 4.08912 6.41981C4 6.11631 4 5.74421 4 5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.5C12 17.0341 12 16.8011 12.0761 16.6173C12.1776 16.3723 12.3723 16.1776 12.6173 16.0761C12.8011 16 13.0341 16 13.5 16C13.9659 16 14.1989 16 14.3827 16.0761C14.6277 16.1776 14.8224 16.3723 14.9239 16.6173C15 16.8011 15 17.0341 15 17.5V20.5C15 20.9659 15 21.1989 14.9239 21.3827C14.8224 21.6277 14.6277 21.8224 14.3827 21.9239C14.1989 22 13.9659 22 13.5 22C13.0341 22 12.8011 22 12.6173 21.9239C12.3723 21.8224 12.1776 21.6277 12.0761 21.3827C12 21.1989 12 20.9659 12 20.5V17.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.249 5C18.1037 5 18.531 5 18.8681 5.15224C19.9978 5.6624 20.0005 6.86278 20.0005 8.00422C20.0005 8.96065 20.0005 9.43886 19.8701 9.84219C19.4513 11.1378 17.7387 11.768 16.0836 12.2373C14.9006 12.5727 14.3091 12.7404 13.9045 13.2756C13.5 13.8107 13.5 14.4389 13.5 15.6952V16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
};
